(() => {
  const roots = Array.from(document.querySelectorAll("[data-feps3d-root]")).filter(
    (candidate) => candidate.dataset.feps3dInitialized !== "1"
  );
  for (const root of roots) {
    if (!root || root.dataset.feps3dInitialized === "1") continue;
    root.dataset.feps3dInitialized = "1";
    if (!root.querySelector(".feps3d-shopify__app")) {
      root.innerHTML = "<div class=\"feps3d-shopify__app\">\n    <aside class=\"feps3d-shopify__panel feps3d-shopify__navigator\" data-fok-ui-block=\"navigator\">\n      <section class=\"feps3d-shopify__section feps3d-shopify__section--header\">\n        <div class=\"feps3d-shopify__section-card\">\n          <p class=\"feps3d-shopify__eyebrow\">FOK-3D: Fungus of Knowledge (FOK)</p>\n          <p class=\"feps3d-shopify__brand-note\">Copyright Matija Samec, 2026. All rights reserved.</p>\n        </div>\n      </section>\n\n      <section class=\"feps3d-shopify__section feps3d-shopify__section--navigator\">\n        <div class=\"feps3d-shopify__section-card\">\n          <h3 class=\"feps3d-shopify__section-title\">Navigator</h3>\n          <div class=\"feps3d-shopify__control-grid\" data-fok-ui-block-host=\"navigator\">\n            <details class=\"feps3d-shopify__filter-dropdown\">\n              <summary>View</summary>\n              <div class=\"feps3d-shopify__filter-body\">\n                <div class=\"feps3d-shopify__view-list\" role=\"radiogroup\" aria-label=\"FOK view presets\">\n                  <label class=\"feps3d-shopify__view-option\"><input data-feps3d-control=\"view\" type=\"radio\" name=\"feps3d-view-preset\" value=\"fok-top\" checked> Mushroom Top (FOK)</label>\n                  <label class=\"feps3d-shopify__view-option\"><input data-feps3d-control=\"view\" type=\"radio\" name=\"feps3d-view-preset\" value=\"fok-side\"> Side View (FOK)</label>\n                  <label class=\"feps3d-shopify__view-option\"><input data-feps3d-control=\"view\" type=\"radio\" name=\"feps3d-view-preset\" value=\"fok-projection\"> Projection (FOK)</label>\n                  <label class=\"feps3d-shopify__view-option\"><input data-feps3d-control=\"view\" type=\"radio\" name=\"feps3d-view-preset\" value=\"fok-s-expanded\"> Substrate Expanded View (FOK-S)</label>\n                </div>\n              </div>\n            </details>\n\n            <details class=\"feps3d-shopify__filter-dropdown\">\n              <summary>Component filter</summary>\n              <div class=\"feps3d-shopify__filter-body\">\n                <label class=\"feps3d-shopify__toggle\"><input data-feps3d-control=\"nodes\" type=\"checkbox\" checked> All nodes</label>\n                <label class=\"feps3d-shopify__toggle\"><input data-feps3d-control=\"citations\" type=\"checkbox\" checked> Connections (mycelium)</label>\n                <label class=\"feps3d-shopify__toggle\"><input data-feps3d-control=\"semantic\" type=\"checkbox\" checked> Semantic links (chitin)</label>\n                <label class=\"feps3d-shopify__toggle\"><input data-feps3d-control=\"reference-theme-health\" type=\"checkbox\" checked> Awaiting integration</label>\n                <label class=\"feps3d-shopify__toggle\"><input data-feps3d-control=\"reference-blue\" type=\"checkbox\" checked> Potential Sources</label>\n                <label class=\"feps3d-shopify__toggle\"><input data-feps3d-control=\"reference-fringe\" type=\"checkbox\" checked> Edge of Knowledge / Outer rim</label>\n                <label class=\"feps3d-shopify__toggle\"><input data-feps3d-control=\"phenomena\" type=\"checkbox\" checked> Phenomena</label>\n                <label class=\"feps3d-shopify__toggle\"><input data-feps3d-control=\"phenomenon-group-l1\" type=\"checkbox\" checked> Core phenomena groups</label>\n                <label class=\"feps3d-shopify__toggle\"><input data-feps3d-control=\"phenomenon-group-l2\" type=\"checkbox\" checked> Topic clusters</label>\n                <label class=\"feps3d-shopify__toggle\"><input data-feps3d-control=\"phenomenon-group-l3\" type=\"checkbox\" checked> Integrating groups</label>\n              </div>\n            </details>\n          </div>\n        </div>\n      </section>\n\n    </aside>\n\n    <main class=\"feps3d-shopify__viewport\">\n      <canvas class=\"feps3d-shopify__canvas\" data-feps3d-canvas></canvas>\n    </main>\n\n    <aside class=\"feps3d-shopify__panel feps3d-shopify__sidebar\" data-fok-ui-block=\"information\">\n      <section class=\"feps3d-shopify__section\">\n        <div class=\"feps3d-shopify__details-grid\">\n          <div class=\"feps3d-shopify__section-card\">\n            <h3 class=\"feps3d-shopify__section-title\">Information</h3>\n            <div class=\"feps3d-shopify__meta-card feps3d-shopify__info-card\" data-feps3d-info-card data-fok-ui-block-host=\"information\"></div>\n          </div>\n        </div>\n      </section>\n    </aside>\n\n    <section class=\"feps3d-shopify__panel feps3d-shopify__understanding-block\" data-feps3d-understanding data-fok-ui-block=\"understanding\">\n      <div class=\"feps3d-shopify__section-card\">\n        <h3 class=\"feps3d-shopify__section-title\">Understanding</h3>\n        <div class=\"feps3d-shopify__understanding-grid\" data-fok-ui-block-host=\"understanding\">\n          <section class=\"feps3d-shopify__navigator-group\">\n            <h4 class=\"feps3d-shopify__navigator-group-title\">Sources</h4>\n            <div class=\"feps3d-shopify__navigator-button-list\" data-feps3d-navigator-list=\"sources\"></div>\n          </section>\n          <section class=\"feps3d-shopify__navigator-group\">\n            <h4 class=\"feps3d-shopify__navigator-group-title\">Population</h4>\n            <div class=\"feps3d-shopify__navigator-button-list\" data-feps3d-navigator-list=\"population\"></div>\n          </section>\n          <section class=\"feps3d-shopify__navigator-group\">\n            <h4 class=\"feps3d-shopify__navigator-group-title\">Tools</h4>\n            <div class=\"feps3d-shopify__navigator-button-list\" data-feps3d-navigator-list=\"tools\"></div>\n          </section>\n          <section class=\"feps3d-shopify__navigator-group\">\n            <h4 class=\"feps3d-shopify__navigator-group-title\">Natural environments</h4>\n            <div class=\"feps3d-shopify__navigator-button-list\" data-feps3d-navigator-list=\"natural-environments\"></div>\n          </section>\n          <section class=\"feps3d-shopify__navigator-group\">\n            <h4 class=\"feps3d-shopify__navigator-group-title\">Urban environments</h4>\n            <div class=\"feps3d-shopify__navigator-button-list\" data-feps3d-navigator-list=\"urban-environments\"></div>\n          </section>\n        </div>\n      </div>\n    </section>\n  </div>";
    }
const canvas = root.querySelector("[data-feps3d-canvas]");
      const ctx = canvas.getContext("2d");
      const infoCard = root.querySelector("[data-feps3d-info-card]");
      const compactMobileQuery = window.matchMedia("(max-width: 720px), (pointer: coarse)");
      const compactMobileView = compactMobileQuery.matches;

      function inflatePublicTokens(value, tokens) {
        if (Array.isArray(value)) {
          if (
            value.length === 2
            && value[0] === "~"
            && Number.isInteger(value[1])
          ) {
            return value[1] >= 0 && value[1] < tokens.length
              ? tokens[value[1]]
              : value;
          }
          return value.map((item) => inflatePublicTokens(item, tokens));
        }
        if (value && typeof value === "object") {
          return Object.fromEntries(
            Object.entries(value).map(
              ([key, item]) => [key, inflatePublicTokens(item, tokens)]
            )
          );
        }
        return value;
      }

      function inflateScenePayload(sceneData) {
        if (!sceneData || !sceneData.meta) return sceneData;
        const payload = sceneData.meta.public_payload || {};
        const nodeStyleRegistry = payload.node_style_registry || {};
        const edgeStyleRegistry = payload.edge_style_registry || {};
        const nodeMetaSchemas = payload.node_meta_schemas || {};
        const edgeMetaSchemas = payload.edge_meta_schemas || {};
        const stringTokens = payload.string_tokens || [];

        function inflateMeta(value, schemaName, schemas) {
          value = inflatePublicTokens(value, stringTokens);
          if (!Array.isArray(value)) return value && typeof value === "object" ? value : {};
          const keys = schemas && schemas[schemaName] ? schemas[schemaName] : [];
          const meta = {};
          for (let index = 0; index < keys.length && index < value.length; index += 1) {
            const item = value[index];
            if (item === null || item === undefined || item === "" || item === false) continue;
            meta[keys[index]] = item;
          }
          return meta;
        }

        function inflateVia(value, schemaName) {
          if (!Array.isArray(value)) return value;
          const keys = edgeMetaSchemas[schemaName] || [];
          const viaIndex = keys.indexOf("via");
          if (viaIndex < 0 || viaIndex >= value.length || !Array.isArray(value[viaIndex])) return value;
          const inflated = value.slice();
          const viaSchemas = payload.via_schemas || [];
          inflated[viaIndex] = inflated[viaIndex].map((row) => {
            if (!Array.isArray(row) || !Number.isInteger(row[0]) || !Array.isArray(viaSchemas[row[0]])) return row;
            const point = {};
            const schema = viaSchemas[row[0]];
            for (let index = 0; index < schema.length && index + 1 < row.length; index += 1) {
              point[schema[index]] = row[index + 1];
            }
            return point;
          });
          return inflated;
        }

        if ([2, 3, 4].includes(Number(payload.version)) && Array.isArray(sceneData.node_rows) && Array.isArray(sceneData.edge_rows)) {
          const nodeKinds = payload.node_kinds || [];
          const nodeLayers = payload.node_layers || [];
          const nodeStyles = payload.node_styles || [];
          const edgeKinds = payload.edge_kinds || [];
          const edgeStyles = payload.edge_styles || [];
          const nodeSchemasByKind = payload.node_schema_by_kind || [];
          const edgeSchemasByKind = payload.edge_schema_by_kind || [];

          sceneData.nodes = sceneData.node_rows.map((row) => {
            if ([3, 4].includes(Number(payload.version)) && Number.isInteger(row[0])) {
              const encoding = payload.outer_reference_encoding || {};
              const width = Number(encoding.id_width) || 6;
              const suffix = String(row[0]).padStart(width, "0");
              const kindIndex = encoding.kind_index;
              const kind = nodeKinds[kindIndex] || "source";
              const schemaName = encoding.meta_schema || nodeSchemasByKind[kindIndex] || "";
              const meta = { ...(encoding.meta_defaults || {}), ...(encoding.meta_constant_fields || {}) };
              for (const [key, rowIndex] of Object.entries(encoding.meta_row_fields || {})) {
                const value = row[rowIndex];
                if (value === null || value === undefined || value === "" || value === false) continue;
                meta[key] = value;
              }
              const uniqueId = `${encoding.unique_id_prefix || "LIT-"}${suffix}`;
              const label = row[1] === null || row[1] === undefined ? uniqueId : row[1];
              const node = {
                id: `${encoding.id_prefix || "SRC-LIT-"}${suffix}`,
                layer: nodeLayers[encoding.layer_index] || "",
                kind,
                unique_id: uniqueId,
                label,
                short_label: label,
                x: row[2],
                y: row[3],
                z: row[4],
                orbit_hint: encoding.orbit_hint,
                angle_deg: row[5],
                meta,
                style: {},
              };
              if (schemaName) node.meta_schema = schemaName;
              const styleIndex = encoding.style_index;
              if (Number.isInteger(styleIndex) && nodeStyles[styleIndex]) {
                node.style_id = `ns${styleIndex + 1}`;
                node.style = { ...nodeStyles[styleIndex] };
              }
              return node;
            }
            const kindIndex = row[2];
            const kind = nodeKinds[kindIndex] || "";
            const schemaName = nodeSchemasByKind[kindIndex] || "";
            const node = {
              id: row[0],
              layer: nodeLayers[row[1]] || "",
              kind,
              unique_id: row[3] === null || row[3] === undefined ? row[0] : row[3],
              label: row[4],
              short_label: row[5] === null || row[5] === undefined ? row[4] : row[5],
              x: row[6],
              y: row[7],
              z: row[8],
              orbit_hint: row[9],
              angle_deg: row[10],
              meta: inflateMeta(row[11], schemaName, nodeMetaSchemas),
              style: {},
            };
            if (schemaName) node.meta_schema = schemaName;
            if (Number.isInteger(row[12]) && nodeStyles[row[12]]) {
              node.style_id = `ns${row[12] + 1}`;
              node.style = { ...nodeStyles[row[12]] };
            }
            return node;
          });

          sceneData.edges = sceneData.edge_rows.map((row) => {
            const kindIndex = row[1];
            const kind = edgeKinds[kindIndex] || "";
            const schemaName = edgeSchemasByKind[kindIndex] || "";
            const edge = {
              id: row[0],
              kind,
              source: sceneData.nodes[row[2]] ? sceneData.nodes[row[2]].id : "",
              target: sceneData.nodes[row[3]] ? sceneData.nodes[row[3]].id : "",
              meta: inflateMeta(inflateVia(row[4], schemaName), schemaName, edgeMetaSchemas),
              style: {},
            };
            if (schemaName) edge.meta_schema = schemaName;
            if (Number.isInteger(row[5]) && edgeStyles[row[5]]) {
              edge.style_id = `es${row[5] + 1}`;
              edge.style = { ...edgeStyles[row[5]] };
            }
            return edge;
          });
          delete sceneData.node_rows;
          delete sceneData.edge_rows;
          return sceneData;
        }

        for (const node of sceneData.nodes || []) {
          if (!node.style && node.style_id && nodeStyleRegistry[node.style_id]) {
            node.style = { ...nodeStyleRegistry[node.style_id] };
          } else if (!node.style) {
            node.style = {};
          }
          node.meta = inflateMeta(node.meta, node.meta_schema, nodeMetaSchemas);
        }

        for (const edge of sceneData.edges || []) {
          if (!edge.style && edge.style_id && edgeStyleRegistry[edge.style_id]) {
            edge.style = { ...edgeStyleRegistry[edge.style_id] };
          } else if (!edge.style) {
            edge.style = {};
          }
          edge.meta = inflateMeta(edge.meta, edge.meta_schema, edgeMetaSchemas);
        }
        return sceneData;
      }

      let scene = null;
      let nodes = [];
      let edges = [];
      let publicDetails = { node_meta: {}, edge_meta: {} };
      let publicDetailsManifest = null;
      let publicDetailsManifestPromise = null;
      const publicDetailsShardPromises = new Map();
      const publicDetailsLoadedShards = new Set();
      const eagRelationEdgeKinds = ["eag_concept_eag_category", "eag_expression_eag_category", "eag_concept_eag_concept", "eag_expression_eag_expression", "eag_expression_eag_concept", "eag_construct_eag_category", "eag_construct_eag_construct"];
      const researchInsightEagEdgeKinds = ["research_insight_eag_category", "research_insight_eag_concept", "research_insight_eag_expression", "research_insight_eag_construct"];
      const environmentCategoryKinds = ["urban_environ_category", "natural_environ_category"];
      const contextClusterKinds = ["urban", "natural", "population"];
      const environmentCategoryKindSet = new Set(environmentCategoryKinds);
      const contextClusterKindSet = new Set(contextClusterKinds);
      const semanticEdgeKinds = new Set(["tool_source", "tool_research_design", "phenomenon_tool", "source_phenomenon", "phenomenon_group", "tool_group", "source_research_design", "source_research_insights", ...researchInsightEagEdgeKinds, ...eagRelationEdgeKinds, "intervention_unit_participant_group", "intervention_unit_environment", ...environmentCategoryKinds, "participant_group_age_category", ...contextClusterKinds, "l4_context_cluster", "l5_eag_semantic", "conceptual_populations", "conceptual_environments"]);
      const citationEdgeKinds = ["citation", "source_source", "source_resource", "resource_resource"];
      const citationEdgeKindSet = new Set(citationEdgeKinds);
      const eagSemanticNodeKinds = new Set(["eag_category", "eag_concept", "eag_expression", "eag_construct"]);
      const phenomenonLikeNodeKinds = ["phenomenon", "eag_category", "eag_concept", "eag_expression", "eag_construct"];
      const sourceResourceNodeKinds = ["source", "resource"];

      function isEnvironmentCategoryNode(node) {
        return !!node && environmentCategoryKindSet.has(node.kind);
      }

      function isContextClusterNode(node) {
        return !!node && contextClusterKindSet.has(node.kind);
      }

      function isSourceElement(node) {
        return !!node && node.kind === "source";
      }

      function isResourceElement(node) {
        return !!node && node.kind === "resource";
      }

      function isSourceResourceElement(node) {
        return !!node && sourceResourceNodeKinds.includes(node.kind);
      }

      function isCitationEdge(edge) {
        return !!edge && citationEdgeKindSet.has(edge.kind);
      }

      function edgeKindAllowed(allowedKinds, edge) {
        if (!allowedKinds) return true;
        const hasKind = Array.isArray(allowedKinds)
          ? (kind) => allowedKinds.includes(kind)
          : (kind) => allowedKinds.has(kind);
        return hasKind(edge.kind) || (isCitationEdge(edge) && hasKind("citation"));
      }

      function isEagSemanticNode(node) {
        return !!node && eagSemanticNodeKinds.has(node.kind);
      }

      function isPhenomenonLikeNode(node) {
        return !!node && (node.kind === "phenomenon" || isEagSemanticNode(node));
      }
      let nodeById = new Map();
      let edgeById = new Map();
      let edgesByNode = new Map();
      let interactionEdgesByNode = new Map();
      let interactionScopeCache = new Map();
      let interactionScopeTraversal = "anchored_connected_paths";
      let timeRules = {};
      let stemBottom = null;
      let orbitRange = [1, 30000];
      const fokSLogicalMaxOrbit = 50000;
      const fokSSourceMaxOrbit = 20000;
      const fokSMethodBoundaryOrbit = 21000;
      const fokSReviewSynthesisOrbit = 23000;
      const fokSConceptualEdgeOrbit = 25000;
      const fokSIntegrationQueueOrbit = 45000;
      const fokSHumanReviewOrbit = 46000;
      const fokSAccessBarrierOrbit = 49000;
      const fokSReferenceOuterOrbit = 50000;
      const fokSReferenceBandOrbits = {
        reference_green_band: fokSReferenceOuterOrbit,
        reference_blue_band: fokSReferenceOuterOrbit,
        reference_fringe_band: fokSReferenceOuterOrbit,
      };
      const fokSOrbitByVisualType = {
        source_study_mixed_methods: fokSMethodBoundaryOrbit,
        source_study_conference_abstract: fokSMethodBoundaryOrbit,
        source_review_theory: fokSReviewSynthesisOrbit,
        source_review_systematic: fokSReviewSynthesisOrbit,
        source_review_meta_analysis: fokSReviewSynthesisOrbit,
        source_review_narrative: fokSReviewSynthesisOrbit,
        source_protocol: fokSReviewSynthesisOrbit,
        source_unclear: fokSConceptualEdgeOrbit,
        source_conceptual_theory: fokSConceptualEdgeOrbit,
        source_waits_for_integration: fokSIntegrationQueueOrbit,
        source_needs_human: fokSHumanReviewOrbit,
        source_paywall: fokSAccessBarrierOrbit,
        source_language_barrier: fokSAccessBarrierOrbit,
        reference: fokSReferenceOuterOrbit,
      };
      const fokSOrbitBySourceBand = {
        source_method_boundary_band: fokSMethodBoundaryOrbit,
        source_review_synthesis_band: fokSReviewSynthesisOrbit,
        source_conceptual_edge_band: fokSConceptualEdgeOrbit,
        source_waits_for_integration_band: fokSIntegrationQueueOrbit,
        source_needs_human_band: fokSHumanReviewOrbit,
        source_access_barrier_band: fokSAccessBarrierOrbit,
        reference_source_band: fokSReferenceOuterOrbit,
      };
      const fokSGuideOrbits = [20000, 21000, 23000, 25000, 45000, 46000, 49000, 50000];
      let zRange = [0, 2410];
      let unknownYearZ = 0;
      let flatYearCutoff = 1990;
      let flatYearZ = 10;
      let layerBaseZ = 2410;
      let zUnitsPerYear = 20;
      let postHanZUnitsPerYear = 40;
      let fokSYearSpacingMultiplier = 3;
      let fokSExtraTickYears = [1995, 2005, 2015, 2025];
      let hereAndNowYear = new Date().getFullYear();
      let hereAndNowZ = 0;
      let animationFrame = null;
      let lastTransform = null;
      let lastProjectedNodes = [];
      let lastHitGrid = null;
      let dragStart = null;
      let pinchStartDistance = null;
      let pinchStartZoom = null;
      let interactionMoved = false;
      let touchGestureWasMulti = false;
      let suppressNextClickSelection = false;
      let interactionStyle = {};
      let nodeDesignSpecification = {};
      let uiDisplaySpecification = {};
      let lastUiDisplayStateKey = "";
      let lastInformationHtml = "";
      let activeUiDisplayProfile = {
        navigator: [],
        information: [],
        understanding: [],
      };
      let informationSectionsMounted = false;

      function inlineJsonById(elementId) {
        const id = String(elementId || "").trim();
        if (!id) return null;
        const element = document.getElementById(id);
        if (!element) throw new Error(`Missing inline data element: ${id}`);
        return JSON.parse(element.textContent || "{}");
      }

      function publicDetailsUrl(sceneData) {
        const explicitUrl = String(root.dataset.feps3dDetailsUrl || "").trim();
        if (explicitUrl) return explicitUrl;
        const metaUrl = String(sceneData && sceneData.meta ? sceneData.meta.public_details_url || "" : "").trim();
        const sceneUrl = String(root.dataset.feps3dSceneUrl || "").trim();
        if (metaUrl) {
          try {
            return new URL(metaUrl, new URL(sceneUrl || window.location.href, window.location.href)).toString();
          } catch (error) {
            return metaUrl;
          }
        }
        if (sceneUrl && sceneUrl.includes("FOK_Public_Scene.json")) {
          return sceneUrl.replace("FOK_Public_Scene.json", "FOK_Public_Details.json");
        }
        if (sceneUrl && sceneUrl.includes(".public.scene.json")) {
          return sceneUrl.replace(".public.scene.json", ".public.details.json");
        }
        return "";
      }

      function inflateDetailRows(rows, schemas, objects, stringTokens = []) {
        const result = {};
        for (const row of rows || []) {
          if (!Array.isArray(row) || !Number.isInteger(row[0])) continue;
          const object = objects[row[0]];
          if (!object) continue;
          const keys = schemas[object.kind] || [];
          const meta = {};
          for (let index = 0; index < keys.length && index + 1 < row.length; index += 1) {
            const value = inflatePublicTokens(row[index + 1], stringTokens);
            if (value === null || value === undefined) continue;
            meta[keys[index]] = value;
          }
          result[object.id] = meta;
        }
        return result;
      }

      function mergePublicDetails(details, schemas = null) {
        let incomingNodeMeta = {};
        let incomingEdgeMeta = {};
        const schema = details && details.meta ? details.meta.schema : "";
        if (schema === "FEPS-3D-public-details-v2") {
          incomingNodeMeta = inflateDetailRows(details.node_rows, details.node_schemas || {}, nodes);
          incomingEdgeMeta = inflateDetailRows(details.edge_rows, details.edge_schemas || {}, edges);
        } else if (["FEPS-3D-public-details-shard-v1", "FEPS-3D-public-details-shard-v2"].includes(schema)) {
          const activeSchemas = schemas || publicDetailsManifest || {};
          const detailStringTokens = activeSchemas.string_tokens || [];
          incomingNodeMeta = inflateDetailRows(details.node_rows, activeSchemas.node_schemas || {}, nodes, detailStringTokens);
          incomingEdgeMeta = inflateDetailRows(details.edge_rows, activeSchemas.edge_schemas || {}, edges, detailStringTokens);
        } else if (details && typeof details === "object") {
          incomingNodeMeta = details.node_meta || {};
          incomingEdgeMeta = details.edge_meta || {};
        }
        Object.assign(publicDetails.node_meta, incomingNodeMeta);
        Object.assign(publicDetails.edge_meta, incomingEdgeMeta);
        for (const [nodeId, detail] of Object.entries(incomingNodeMeta)) {
          const node = nodeById.get(nodeId);
          if (node && detail && typeof detail === "object") {
            node.meta = { ...(node.meta || {}), ...detail };
          }
        }
        for (const [edgeId, detail] of Object.entries(incomingEdgeMeta)) {
          const edge = edgeById.get(edgeId);
          if (edge && detail && typeof detail === "object") {
            edge.meta = { ...(edge.meta || {}), ...detail };
          }
        }
        interactionScopeCache.clear();

        const sourceByUniqueId = new Map(
          nodes
            .filter((node) => isSourceResourceElement(node) && node.unique_id)
            .map((node) => [String(node.unique_id), node])
        );
        for (const node of nodes) {
          const meta = node.meta || {};
          if (isSourceResourceElement(node) && !meta.source_title && meta.apa7_citation) {
            meta.source_title = meta.apa7_citation;
          }
        }
        for (const node of nodes) {
          const meta = node.meta || {};
          if (!meta.source_title) {
            const sourceRef = String(meta.source_id || meta.source_unique_id || "");
            const sourceNode = nodeById.get(sourceRef) || sourceByUniqueId.get(sourceRef) || nodeById.get(`SRC-${sourceRef}`);
            if (sourceNode && sourceNode.meta && sourceNode.meta.source_title) {
              meta.source_title = sourceNode.meta.source_title;
            }
          }
          if (!meta.tool_description && meta.tool_description_text) {
            meta.tool_description = meta.tool_description_text;
          }
          for (const field of ["linked_sources", "linked_tools", "linked_phenomena"]) {
            if (!Array.isArray(meta[field])) continue;
            meta[field] = meta[field].map((item) => {
              const linkedId = typeof item === "string" ? item : (item && item.id);
              const linkedNode = linkedId ? nodeById.get(linkedId) : null;
              if (!linkedNode) return item;
              const linkedMeta = linkedNode.meta || {};
              if (field === "linked_sources") {
                return {
                  id: linkedNode.id,
                  unique_id: linkedNode.unique_id,
                  label: linkedNode.label,
                  title: linkedMeta.source_title,
                  apa7_citation: linkedMeta.apa7_citation,
                };
              }
              return {
                id: linkedNode.id,
                label: linkedNode.label,
                short_label: linkedNode.short_label,
                primary_pole: linkedMeta.primary_pole,
              };
            });
          }
        }
        requestRender();
      }

      function fnv1a32(value) {
        const bytes = new TextEncoder().encode(String(value || ""));
        let hash = 2166136261;
        for (const byte of bytes) {
          hash ^= byte;
          hash = Math.imul(hash, 16777619) >>> 0;
        }
        return hash >>> 0;
      }

      function loadPublicDetailsManifest(sceneData) {
        if (publicDetailsManifest) return Promise.resolve(publicDetailsManifest);
        if (publicDetailsManifestPromise) return publicDetailsManifestPromise;
        const inlineDetailsId = String(root.dataset.feps3dInlineDetailsId || "").trim();
        if (inlineDetailsId) {
          publicDetailsManifest = inlineJsonById(inlineDetailsId) || {};
          return Promise.resolve(publicDetailsManifest);
        }
        const detailsUrl = publicDetailsUrl(sceneData);
        if (!detailsUrl) return Promise.resolve(null);
        publicDetailsManifestPromise = fetch(detailsUrl, { credentials: "same-origin" })
          .then((response) => {
            if (!response.ok) {
              throw new Error(`Details asset request failed with status ${response.status}`);
            }
            return response.json();
          })
          .then((details) => {
            if (
              details
              && details.meta
              && ["FEPS-3D-public-details-v3", "FEPS-3D-public-details-v4"].includes(details.meta.schema)
            ) {
              publicDetailsManifest = details;
              return details;
            }
            mergePublicDetails(details);
            publicDetailsManifest = details || {};
            return publicDetailsManifest;
          })
          .finally(() => {
            publicDetailsManifestPromise = null;
          });
        return publicDetailsManifestPromise;
      }

      function detailsShardUrl(manifest, shard) {
        const detailsUrl = publicDetailsUrl(scene);
        const baseUrl = new URL(detailsUrl, window.location.href);
        const shardUrl = new URL(shard.filename, baseUrl);
        if (shard.version) shardUrl.searchParams.set("v", shard.version);
        return shardUrl.toString();
      }

      function loadPublicDetails(sceneData, nodeId) {
        if (!sceneData || !sceneData.meta || !sceneData.meta.public_lite || !nodeId) {
          return Promise.resolve();
        }
        return loadPublicDetailsManifest(sceneData).then((manifest) => {
          if (
            !manifest
            || !manifest.meta
            || !["FEPS-3D-public-details-v3", "FEPS-3D-public-details-v4"].includes(manifest.meta.schema)
          ) {
            return undefined;
          }
          const shardCount = Number(manifest.meta.shard_count) || 1;
          const requestedShardIds = new Set([
            (fnv1a32(nodeId) % shardCount).toString(16).padStart(2, "0")
          ]);
          if (manifest.meta.edge_shard_basis === "edge_id") {
            for (const edge of edgesByNode.get(nodeId) || []) {
              requestedShardIds.add(
                (fnv1a32(edge.id) % shardCount).toString(16).padStart(2, "0")
              );
            }
          }
          return Promise.all(
            [...requestedShardIds].map((shardId) => loadPublicDetailsShard(manifest, shardId))
          ).then(() => undefined);
        });
      }

      function loadPublicDetailsShard(manifest, shardId) {
          if (publicDetailsLoadedShards.has(shardId)) return undefined;
          if (publicDetailsShardPromises.has(shardId)) {
            return publicDetailsShardPromises.get(shardId);
          }
          const shard = (manifest.shards || []).find((candidate) => candidate.id === shardId);
          if (!shard) throw new Error(`Missing details shard ${shardId}`);
          const inlineShardPrefix = String(root.dataset.feps3dInlineDetailsShardPrefix || "").trim();
          if (inlineShardPrefix) {
            const details = inlineJsonById(`${inlineShardPrefix}${shardId}`);
            mergePublicDetails(details, manifest);
            publicDetailsLoadedShards.add(shardId);
            return undefined;
          }
          const promise = fetch(detailsShardUrl(manifest, shard), { credentials: "same-origin" })
            .then((response) => {
              if (!response.ok) {
                throw new Error(`Details shard ${shardId} failed with status ${response.status}`);
              }
              return response.json();
            })
            .then((details) => {
              mergePublicDetails(details, manifest);
              publicDetailsLoadedShards.add(shardId);
            })
            .finally(() => {
              publicDetailsShardPromises.delete(shardId);
            });
          publicDetailsShardPromises.set(shardId, promise);
          return promise;
      }

      function ensurePublicDetailsLoaded(nodeId) {
        return loadPublicDetails(scene, nodeId).catch((error) => {
          console.warn("FOK-3D public details load failed:", error);
        });
      }

      const navigatorListSectionIds = {
        sources: "source_index",
        population: "population_index",
        tools: "tools_index",
        "natural-environments": "natural_environments_index",
        "urban-environments": "urban_environments_index",
        "eag-categories": "categories_index",
        "eag-constructs": "constructs_index",
      };

      function ensureNavigatorDropdowns() {
        const grid = root.querySelector(".feps3d-shopify__understanding-grid");
        if (!grid) return;
        const additions = [
          ["eag-categories", "EAG categories"],
          ["eag-constructs", "Constructs"],
        ];
        for (const [listKey, label] of additions) {
          if (grid.querySelector(`[data-feps3d-navigator-list="${listKey}"]`)) continue;
          const group = document.createElement("section");
          group.className = "feps3d-shopify__navigator-group";
          group.innerHTML = `
            <h4 class="feps3d-shopify__navigator-group-title">${label}</h4>
            <div class="feps3d-shopify__navigator-button-list" data-feps3d-navigator-list="${listKey}"></div>
          `;
          grid.appendChild(group);
        }
        for (const group of Array.from(grid.querySelectorAll("section.feps3d-shopify__navigator-group"))) {
          const title = group.querySelector(".feps3d-shopify__navigator-group-title");
          const list = group.querySelector(".feps3d-shopify__navigator-button-list");
          if (!title || !list) continue;
          const dropdown = document.createElement("details");
          dropdown.className = "feps3d-shopify__navigator-group feps3d-shopify__navigator-dropdown";
          const summary = document.createElement("summary");
          summary.className = "feps3d-shopify__navigator-dropdown-summary";
          summary.textContent = title.textContent;
          dropdown.dataset.fokUiSectionId = navigatorListSectionIds[
            String(list.dataset.feps3dNavigatorList || "")
          ] || String(list.dataset.feps3dNavigatorList || "").replace(/-/g, "_");
          dropdown.dataset.fokUiSectionOrigin = "index";
          dropdown.append(summary, list);
          group.replaceWith(dropdown);
        }
      }

      ensureNavigatorDropdowns();

      const controls = {
        nodes: root.querySelector('[data-feps3d-control="nodes"]'),
        citations: root.querySelector('[data-feps3d-control="citations"]'),
        semantic: root.querySelector('[data-feps3d-control="semantic"]'),
        referenceThemeHealth: root.querySelector('[data-feps3d-control="reference-theme-health"]'),
        referenceBlue: root.querySelector('[data-feps3d-control="reference-blue"]'),
        referenceFringe: root.querySelector('[data-feps3d-control="reference-fringe"]'),
        phenomena: root.querySelector('[data-feps3d-control="phenomena"]'),
        phenomenonGroupL1: root.querySelector('[data-feps3d-control="phenomenon-group-l1"]'),
        phenomenonGroupL2: root.querySelector('[data-feps3d-control="phenomenon-group-l2"]'),
        phenomenonGroupL3: root.querySelector('[data-feps3d-control="phenomenon-group-l3"]'),
        researchTypeSelect: null,
        navigatorLists: {
          sources: root.querySelector('[data-feps3d-navigator-list="sources"]'),
          population: root.querySelector('[data-feps3d-navigator-list="population"]'),
          tools: root.querySelector('[data-feps3d-navigator-list="tools"]'),
          naturalEnvironments: root.querySelector('[data-feps3d-navigator-list="natural-environments"]'),
          urbanEnvironments: root.querySelector('[data-feps3d-navigator-list="urban-environments"]'),
          eagCategories: root.querySelector('[data-feps3d-navigator-list="eag-categories"]'),
          eagConstructs: root.querySelector('[data-feps3d-navigator-list="eag-constructs"]'),
        },
        viewOptions: Array.from(root.querySelectorAll('[data-feps3d-control="view"]')),
        connectionFilterList: null,
      };

      const state = {
        azimuth: 0,
        elevation: 0,
        zoom: 1,
        projectionMode: "orthographic",
        cameraDistance: 4200,
        showNodes: true,
        showCitations: true,
        showSemantic: true,
        showReferenceThemeHealth: true,
        showReferenceBlue: true,
        showReferenceFringe: true,
        showPhenomena: true,
        showPhenomenonGroupL1: true,
        showPhenomenonGroupL2: true,
        showPhenomenonGroupL3: true,
        showTools: true,
        hiddenConnectionKinds: new Set(),
        researchTypeFilter: "all",
        dragging: false,
        hoverId: null,
        selectedId: null,
        activeViewPreset: "front",
        activeModelPreset: "fok",
      };

      function uiTextValue(key, fallback) {
        const text = uiDisplaySpecification && uiDisplaySpecification.text;
        const value = text && text[key];
        return typeof value === "string" && value.trim() ? value : fallback;
      }

      function uiPixelValue(value, fallback) {
        const numeric = Number(value);
        return `${Number.isFinite(numeric) ? Math.max(0, numeric) : fallback}px`;
      }

      function ensureUiDisplayHooks() {
        const controlGrid = root.querySelector(".feps3d-shopify__control-grid");
        if (controlGrid) {
          for (const dropdown of controlGrid.querySelectorAll(".feps3d-shopify__filter-dropdown")) {
            if (dropdown.querySelector('[data-feps3d-control="view"]')) {
              dropdown.dataset.fokUiSectionId = "view_presets";
            } else if (dropdown.querySelector('[data-feps3d-control="nodes"]')) {
              dropdown.dataset.fokUiSectionId = "component_filter";
            } else if (dropdown.querySelector('[data-feps3d-control="research-type"]')) {
              dropdown.dataset.fokUiSectionId = "research_type_filter";
            } else if (dropdown.querySelector("[data-feps3d-connection-filter-list]")) {
              dropdown.dataset.fokUiSectionId = "connection_filter";
            }
            dropdown.dataset.fokUiSectionOrigin = "control";
          }
        }
        for (const list of root.querySelectorAll("[data-feps3d-navigator-list]")) {
          const dropdown = list.closest(".feps3d-shopify__navigator-dropdown");
          if (!dropdown) continue;
          dropdown.dataset.fokUiSectionId = navigatorListSectionIds[
            String(list.dataset.feps3dNavigatorList || "")
          ] || String(list.dataset.feps3dNavigatorList || "").replace(/-/g, "_");
          dropdown.dataset.fokUiSectionOrigin = "index";
        }
      }

      function applyUiDisplayCommon() {
        ensureUiDisplayHooks();
        const style = uiDisplaySpecification.style || {};
        const layout = uiDisplaySpecification.layout || {};
        const cssVariables = {
          "--fok-ui-font-family": style.font_family,
          "--fok-ui-background-color": style.background_color,
          "--fok-ui-panel-color": style.panel_color,
          "--fok-ui-panel-secondary-color": style.panel_secondary_color,
          "--fok-ui-line-color": style.line_color,
          "--fok-ui-text-color": style.text_color,
          "--fok-ui-muted-text-color": style.muted_text_color,
          "--fok-ui-accent-color": style.accent_color,
          "--fok-ui-green-color": style.green_color,
          "--fok-ui-blue-color": style.blue_color,
          "--fok-ui-pink-color": style.pink_color,
          "--fok-ui-amber-color": style.amber_color,
          "--fok-ui-brand-title-color": style.brand_title_color,
          "--fok-ui-brand-note-color": style.brand_note_color,
          "--fok-ui-block-title-color": style.block_title_color,
          "--fok-ui-information-title-color": style.information_title_color,
          "--fok-ui-information-heading-color": style.information_heading_color,
          "--fok-ui-body-text-color": style.body_text_color,
          "--fok-ui-menu-title-color": style.menu_title_color,
          "--fok-ui-menu-background-color": style.menu_background_color,
          "--fok-ui-menu-border-color": style.menu_border_color,
          "--fok-ui-navigator-menu-title-color": style.navigator_menu_title_color,
          "--fok-ui-navigator-menu-background-color": style.navigator_menu_background_color,
          "--fok-ui-navigator-menu-border-color": style.navigator_menu_border_color,
          "--fok-ui-button-text-color": style.button_text_color,
          "--fok-ui-button-background-color": style.button_background_color,
          "--fok-ui-button-border-color": style.button_border_color,
          "--fok-ui-button-active-text-color": style.button_active_text_color,
          "--fok-ui-button-active-background-color": style.button_active_background_color,
          "--fok-ui-button-active-border-color": style.button_active_border_color,
        };
        const pixelVariables = {
          "--fok-ui-brand-title-size": [style.brand_title_size_px, 13],
          "--fok-ui-brand-note-size": [style.brand_note_size_px, 11],
          "--fok-ui-block-title-size": [style.block_title_size_px, 14],
          "--fok-ui-information-title-size": [style.information_title_size_px, 20],
          "--fok-ui-information-heading-size": [style.information_heading_size_px, 11],
          "--fok-ui-body-text-size": [style.body_text_size_px, 13],
          "--fok-ui-muted-text-size": [style.muted_text_size_px, 13],
          "--fok-ui-menu-title-size": [style.menu_title_size_px, 12],
          "--fok-ui-menu-border-radius": [style.menu_border_radius_px, 14],
          "--fok-ui-navigator-menu-title-size": [style.navigator_menu_title_size_px, 12],
          "--fok-ui-navigator-menu-border-radius": [style.navigator_menu_border_radius_px, 6],
          "--fok-ui-button-text-size": [style.button_text_size_px, 11.5],
          "--fok-ui-button-border-radius": [style.button_border_radius_px, 999],
          "--fok-ui-app-border-radius": [layout.app_border_radius_px, 24],
          "--fok-ui-panel-padding-top": [layout.panel_padding_top_px, 18],
          "--fok-ui-panel-padding-horizontal": [layout.panel_padding_horizontal_px, 22],
          "--fok-ui-panel-padding-bottom": [layout.panel_padding_bottom_px, 28],
          "--fok-ui-section-spacing": [layout.section_spacing_px, 24],
          "--fok-ui-control-gap": [layout.control_gap_px, 12],
          "--fok-ui-navigator-gap": [layout.navigator_gap_px, 8],
          "--fok-ui-understanding-max-height": [layout.desktop_understanding_max_height_px, 460],
        };
        for (const [name, value] of Object.entries(cssVariables)) {
          if (typeof value === "string" && value.trim()) root.style.setProperty(name, value);
        }
        for (const [name, [value, fallback]] of Object.entries(pixelVariables)) {
          root.style.setProperty(name, uiPixelValue(value, fallback));
        }

        const brandTitle = root.querySelector(".feps3d-shopify__eyebrow");
        const brandNote = root.querySelector(".feps3d-shopify__brand-note");
        const navigatorTitle = root.querySelector(".feps3d-shopify__section--navigator .feps3d-shopify__section-title");
        const informationTitle = root.querySelector(".feps3d-shopify__sidebar .feps3d-shopify__section-title");
        const understandingTitle = root.querySelector(".feps3d-shopify__understanding-block .feps3d-shopify__section-title");
        if (brandTitle) brandTitle.textContent = uiTextValue("brand_title", "FOK-3D: Fungus of Knowledge (FOK)");
        if (brandNote) brandNote.textContent = uiTextValue("brand_note", "Copyright Matija Samec, 2026. All rights reserved.");
        if (navigatorTitle) navigatorTitle.textContent = uiTextValue("navigator_title", "Navigator");
        if (informationTitle) informationTitle.textContent = uiTextValue("information_title", "Information");
        if (understandingTitle) understandingTitle.textContent = uiTextValue("understanding_title", "Understanding");

        const viewTitles = {
          view_presets: ["view_presets_title", "View"],
          component_filter: ["component_filter_title", "Component filter"],
          research_type_filter: ["research_type_filter_title", "Research type"],
          connection_filter: ["connection_filter_title", "Connection filter"],
        };
        for (const dropdown of root.querySelectorAll("[data-fok-ui-section-id]")) {
          const titleSpec = viewTitles[dropdown.dataset.fokUiSectionId];
          const summary = dropdown.querySelector(":scope > summary");
          if (titleSpec && summary) summary.textContent = uiTextValue(titleSpec[0], titleSpec[1]);
        }
        for (const dropdown of root.querySelectorAll('[data-fok-ui-section-origin="index"]')) {
          const key = dropdown.dataset.fokUiSectionId;
          const summary = dropdown.querySelector(":scope > summary");
          if (summary) {
            summary.textContent = uiTextValue(
              `section.${key}`,
              summary.textContent || key.replace(/_/g, " "),
            );
          }
        }

        const app = root.querySelector(".feps3d-shopify__app");
        const desktopOrder = Array.isArray(layout.desktop_primary_order)
          ? layout.desktop_primary_order
          : ["navigator", "model", "information"];
        if (app && desktopOrder.length === 3) {
          const navigatorWidth = uiPixelValue(layout.desktop_navigator_width_px, 320);
          const informationMin = uiPixelValue(layout.desktop_information_min_width_px, 300);
          const informationMax = uiPixelValue(layout.desktop_information_max_width_px, 360);
          const columnsByBlock = {
            navigator: navigatorWidth,
            model: "minmax(0, 1fr)",
            information: `minmax(${informationMin}, ${informationMax})`,
          };
          app.style.gridTemplateAreas = `"${desktopOrder.join(" ")}" "understanding understanding understanding"`;
          app.style.gridTemplateColumns = desktopOrder.map((block) => columnsByBlock[block]).join(" ");
        }
        const mobileOrder = Array.isArray(layout.mobile_block_order)
          ? layout.mobile_block_order
          : ["model", "information", "navigator", "understanding"];
        mobileOrder.forEach((block, index) => {
          root.style.setProperty(`--fok-ui-mobile-order-${block}`, String(index + 1));
        });
        lastUiDisplayStateKey = "";
        syncUiResponsiveLayout();
      }

      function syncUiResponsiveLayout() {
        const layout = uiDisplaySpecification.layout || {};
        const breakpoint = Number(layout.mobile_breakpoint_px);
        const activeBreakpoint = Number.isFinite(breakpoint) ? breakpoint : 1080;
        const width = root.clientWidth || window.innerWidth;
        root.classList.toggle("feps3d-ui--compact", width <= activeBreakpoint);
      }

      function uiSectionEnabled(sectionList, sectionId) {
        return Array.isArray(sectionList)
          && (sectionList.includes("all") || sectionList.includes(sectionId));
      }

      function uiDisplayProfile(mode, node) {
        const states = uiDisplaySpecification.states || {};
        if (mode === "normal" || !node) {
          return states.normal || { navigator: [], information: [], understanding: [] };
        }
        const role = nodeInteractionRole(node);
        const modeProfiles = states[mode] || {};
        return modeProfiles[role] || states.normal || { navigator: [], information: [], understanding: [] };
      }

      function uiBlockHosts() {
        return {
          navigator: root.querySelector('[data-fok-ui-block-host="navigator"]'),
          information: root.querySelector('[data-fok-ui-block-host="information"]'),
          understanding: root.querySelector('[data-fok-ui-block-host="understanding"]'),
        };
      }

      function placeUiSections(profile) {
        ensureUiDisplayHooks();
        const hosts = uiBlockHosts();
        const sections = Array.from(root.querySelectorAll("[data-fok-ui-section-id]"));
        for (const section of sections) section.hidden = true;
        const placed = new Set();
        for (const blockName of ["navigator", "information", "understanding"]) {
          const host = hosts[blockName];
          if (!host) continue;
          for (const sectionId of profile[blockName] || []) {
            for (const section of sections) {
              if (
                section.dataset.fokUiSectionId !== sectionId
                || placed.has(section)
              ) continue;
              host.appendChild(section);
              section.hidden = false;
              section.dataset.fokUiCurrentBlock = blockName;
              placed.add(section);
            }
          }
        }
      }

      function applyUiDisplayState(mode, node) {
        ensureUiDisplayHooks();
        const profile = uiDisplayProfile(mode, node);
        activeUiDisplayProfile = profile;
        const role = node ? nodeInteractionRole(node) : "normal";
        const stateKey = JSON.stringify([
          mode,
          role,
          profile.navigator,
          profile.information,
          profile.understanding,
        ]);
        if (stateKey === lastUiDisplayStateKey) {
          placeUiSections(profile);
          return profile;
        }
        lastUiDisplayStateKey = stateKey;
        placeUiSections(profile);
        return profile;
      }

      function informationSectionId(element) {
        const explicitSectionId = String(element.dataset.fokUiInformationSection || "").trim();
        if (explicitSectionId) return explicitSectionId;
        if (element.querySelector(".feps3d-shopify__info-title")) return "header";
        if (element.matches(".feps3d-shopify__link-spacer") || element.querySelector(".feps3d-shopify__navigator-link")) {
          return "external_link";
        }
        const kicker = element.querySelector(".feps3d-shopify__info-kicker");
        if (kicker && kicker.textContent.trim()) {
          return kicker.textContent
            .trim()
            .toLowerCase()
            .replace(/[^a-z0-9]+/g, "_")
            .replace(/^_+|_+$/g, "");
        }
        return "details";
      }

      function filterInformationHtml(html, sectionList) {
        if (!html || !Array.isArray(sectionList) || sectionList.length === 0) return "";
        const template = document.createElement("template");
        template.innerHTML = html;
        for (const element of Array.from(template.content.children)) {
          const sectionId = informationSectionId(element);
          element.dataset.fokUiInformationSection = sectionId;
          element.dataset.fokUiSectionId = sectionId;
          element.dataset.fokUiSectionOrigin = "information";
          if (!uiSectionEnabled(sectionList, sectionId)) element.remove();
        }
        return template.innerHTML;
      }

      function informationHtmlForUi(node, mode, profile = null) {
        const activeProfile = profile || uiDisplayProfile(mode, node);
        const activeSectionIds = [
          ...(activeProfile.navigator || []),
          ...(activeProfile.information || []),
          ...(activeProfile.understanding || []),
        ];
        return filterInformationHtml(
          node ? informationHtml(node) : groundedInformationHtml(),
          activeSectionIds,
        );
      }

      function updateInformationCard(html) {
        const normalizedHtml = String(html || "");
        if (normalizedHtml === lastInformationHtml && informationSectionsMounted) {
          placeUiSections(activeUiDisplayProfile);
          return;
        }
        for (const element of Array.from(
          root.querySelectorAll('[data-fok-ui-section-origin="information"]')
        )) {
          element.remove();
        }
        lastInformationHtml = normalizedHtml;
        infoCard.innerHTML = normalizedHtml;
        informationSectionsMounted = true;
        ensureResearchTypeFilterControls();
        placeUiSections(activeUiDisplayProfile);
      }

      function activeCombinedViewPreset() {
        if (state.activeModelPreset === "fok-s") return "fok-s-expanded";
        if (state.activeViewPreset === "front") return "fok-side";
        if (state.activeViewPreset === "perspective") return "fok-projection";
        return "fok-top";
      }

      function syncViewOptions() {
        const activePreset = activeCombinedViewPreset();
        for (const option of controls.viewOptions) {
          option.checked = option.value === activePreset;
        }
      }

      const connectionKindOrder = [...citationEdgeKinds, ...semanticEdgeKinds];

      function edgeKindKey(edge) {
        return String((edge && edge.kind) || "unknown");
      }

      function connectionKindCounts() {
        const counts = new Map();
        for (const edge of edges) {
          const kind = edgeKindKey(edge);
          counts.set(kind, (counts.get(kind) || 0) + 1);
        }
        return counts;
      }

      function connectionKindSortIndex(kind) {
        const index = connectionKindOrder.indexOf(kind);
        return index >= 0 ? index : connectionKindOrder.length;
      }

      function currentConnectionKinds() {
        const counts = connectionKindCounts();
        return Array.from(counts.keys()).sort((a, b) => {
          const sortA = connectionKindSortIndex(a);
          const sortB = connectionKindSortIndex(b);
          if (sortA !== sortB) return sortA - sortB;
          return a.localeCompare(b);
        });
      }

      function edgeKindVisible(edge) {
        return !state.hiddenConnectionKinds.has(edgeKindKey(edge));
      }

      const researchTypeLabelByKey = {
        empirical: "Empirical",
        review: "Review",
        protocol: "Protocol",
        conceptual: "Conceptual",
      };
      const researchTypeSortOrder = ["empirical", "review", "protocol", "conceptual"];
      let researchTypeVisibilityCache = null;

      function normalizeResearchType(value) {
        return String(value || "").trim().toLowerCase();
      }

      function researchTypeLabel(type) {
        const key = normalizeResearchType(type);
        if (!key) return "Unknown";
        return researchTypeLabelByKey[key] || key.replace(/_/g, " ").replace(/\b\w/g, (letter) => letter.toUpperCase());
      }

      function sourceTypeForNode(node) {
        return normalizeResearchType(node && node.meta ? node.meta.source_type : "");
      }

      function selectedResearchType() {
        const type = normalizeResearchType(state.researchTypeFilter);
        return type && type !== "all" ? type : "";
      }

      function researchTypeFilterActive() {
        return state.activeModelPreset === "fok" && !!selectedResearchType();
      }

      function integratedResearchSourceNode(node) {
        return !!(isSourceElement(node) && node.meta && node.meta.integration_state === "integrated_source");
      }

      function researchTypeCounts() {
        const counts = new Map();
        for (const node of nodes) {
          if (!integratedResearchSourceNode(node)) continue;
          const type = sourceTypeForNode(node);
          if (!type) continue;
          counts.set(type, (counts.get(type) || 0) + 1);
        }
        return counts;
      }

      function currentResearchTypes() {
        const counts = researchTypeCounts();
        return Array.from(counts.keys()).sort((left, right) => {
          const leftIndex = researchTypeSortOrder.indexOf(left);
          const rightIndex = researchTypeSortOrder.indexOf(right);
          if (leftIndex !== rightIndex) {
            if (leftIndex < 0) return 1;
            if (rightIndex < 0) return -1;
            return leftIndex - rightIndex;
          }
          return researchTypeLabel(left).localeCompare(researchTypeLabel(right), undefined, { sensitivity: "base" });
        });
      }

      function nodeAboveHan(node) {
        return !!(node && Number.isFinite(Number(node.z)) && Number(node.z) > hereAndNowZ + 0.001);
      }

      function sourceKeySetForResearchType(type) {
        const keys = new Set();
        for (const node of nodes) {
          if (!integratedResearchSourceNode(node) || sourceTypeForNode(node) !== type) continue;
          for (const key of sourceLinkKeys(node)) keys.add(key);
        }
        return keys;
      }

      function sourceKeysMatchAny(node, sourceKeys) {
        if (!node || !sourceKeys || !sourceKeys.size) return false;
        for (const key of sourceLinkKeys(node)) {
          if (sourceKeys.has(key)) return true;
        }
        return false;
      }

      function researchTypeVisibleNodeIds() {
        const type = selectedResearchType();
        if (!type) return null;
        if (researchTypeVisibilityCache && researchTypeVisibilityCache.type === type) {
          return researchTypeVisibilityCache.nodeIds;
        }
        const nodeIds = new Set();
        const sourceKeys = sourceKeySetForResearchType(type);
        const addSourceNode = (node) => {
          if (!node || !integratedResearchSourceNode(node) || sourceTypeForNode(node) !== type) return false;
          if (nodeIds.has(node.id)) return false;
          nodeIds.add(node.id);
          return true;
        };
        const addAboveHanNode = (node) => {
          if (!node || !nodeAboveHan(node) || nodeIds.has(node.id)) return false;
          nodeIds.add(node.id);
          return true;
        };
        const addById = (nodeId) => addAboveHanNode(nodeById.get(nodeId));

        for (const node of nodes) {
          if (addSourceNode(node)) continue;
          if (!nodeAboveHan(node)) continue;
          if (sourceTypeForNode(node) === type || sourceKeysMatchAny(node, sourceKeys)) {
            addAboveHanNode(node);
          }
        }

        let changed = true;
        while (changed) {
          changed = false;
          for (const edge of edges) {
            const sourceNode = nodeById.get(edge.source);
            const targetNode = nodeById.get(edge.target);
            if (!sourceNode || !targetNode) continue;
            const sourceVisible = nodeIds.has(edge.source);
            const targetVisible = nodeIds.has(edge.target);

            if (edge.kind === "source_phenomenon" || edge.kind === "tool_source" || edge.kind === "source_research_insights") {
              if (sourceVisible) {
                if (addAboveHanNode(targetNode)) changed = true;
                for (const viaNodeId of edgeViaNodeIds(edge)) {
                  if (addById(viaNodeId)) changed = true;
                }
              }
              continue;
            }

            if (edge.kind === "source_research_design") {
              if (sourceVisible || targetVisible) {
                if (addAboveHanNode(sourceNode)) changed = true;
                if (addAboveHanNode(targetNode)) changed = true;
              }
              continue;
            }

            if (edge.kind === "phenomenon_tool") {
              if (sourceVisible && addAboveHanNode(targetNode)) changed = true;
              if (targetVisible && addAboveHanNode(sourceNode)) changed = true;
              continue;
            }

            if (edge.kind === "phenomenon_group" || edge.kind === "tool_group") {
              if (sourceVisible && addAboveHanNode(targetNode)) changed = true;
              continue;
            }

            if (
              edge.kind === "intervention_unit_participant_group" ||
              edge.kind === "intervention_unit_environment" ||
              environmentCategoryKindSet.has(edge.kind) ||
              edge.kind === "participant_group_age_category" ||
              contextClusterKindSet.has(edge.kind) ||
              edge.kind === "l4_context_cluster" ||
              edge.kind === "l5_eag_semantic"
            ) {
              if (sourceVisible && addAboveHanNode(targetNode)) changed = true;
            }
          }
        }

        researchTypeVisibilityCache = { type, nodeIds };
        return nodeIds;
      }

      function researchTypeVisibleNode(node) {
        if (!researchTypeFilterActive()) return true;
        if (integratedResearchSourceNode(node)) return sourceTypeForNode(node) === selectedResearchType();
        if (!nodeAboveHan(node)) return false;
        const visibleIds = researchTypeVisibleNodeIds();
        return !!(visibleIds && visibleIds.has(node.id));
      }

      function researchTypeVisibleEdge(edge) {
        if (!researchTypeFilterActive()) return true;
        const visibleIds = researchTypeVisibleNodeIds();
        return !!(visibleIds && visibleIds.has(edge.source) && visibleIds.has(edge.target));
      }

      function renderResearchTypeFilterControls() {
        const select = controls.researchTypeSelect;
        if (!select) return;
        const counts = researchTypeCounts();
        const previous = state.researchTypeFilter || "all";
        select.replaceChildren();
        const allOption = document.createElement("option");
        allOption.value = "all";
        allOption.textContent = "All research types";
        select.appendChild(allOption);
        for (const type of currentResearchTypes()) {
          const option = document.createElement("option");
          option.value = type;
          option.textContent = `${researchTypeLabel(type)} (${counts.get(type) || 0})`;
          select.appendChild(option);
        }
        const hasPrevious = previous === "all" || currentResearchTypes().includes(previous);
        state.researchTypeFilter = hasPrevious ? previous : "all";
        select.value = state.researchTypeFilter;
      }

      function ensureResearchTypeFilterControls() {
        const select = infoCard.querySelector(
          "[data-feps3d-control='research-type']"
        );
        controls.researchTypeSelect = select;
        if (!select) return;
        renderResearchTypeFilterControls();
        if (select.dataset.feps3dResearchTypeBound === "1") return;
        select.dataset.feps3dResearchTypeBound = "1";
        select.addEventListener("change", () => {
          state.researchTypeFilter = select.value || "all";
          researchTypeVisibilityCache = null;
          if (state.selectedId && !researchTypeVisibleNode(nodeById.get(state.selectedId))) state.selectedId = null;
          if (state.hoverId && !researchTypeVisibleNode(nodeById.get(state.hoverId))) state.hoverId = null;
          buildNavigatorControls();
          requestRender();
        });
      }

      function renderConnectionFilterControls() {
        const list = controls.connectionFilterList;
        if (!list) return;
        const counts = connectionKindCounts();
        list.replaceChildren();
        for (const kind of currentConnectionKinds()) {
          const label = document.createElement("label");
          label.className = "feps3d-shopify__toggle feps3d-shopify__toggle--connection";
          const input = document.createElement("input");
          input.type = "checkbox";
          input.checked = !state.hiddenConnectionKinds.has(kind);
          input.dataset.feps3dConnectionKind = kind;
          input.addEventListener("change", () => {
            if (input.checked) {
              state.hiddenConnectionKinds.delete(kind);
            } else {
              state.hiddenConnectionKinds.add(kind);
            }
            requestRender();
          });
          const name = document.createElement("span");
          name.className = "feps3d-shopify__connection-kind-name";
          name.textContent = kind;
          const count = document.createElement("span");
          count.className = "feps3d-shopify__connection-kind-count";
          count.textContent = String(counts.get(kind) || 0);
          label.append(input, name, count);
          list.appendChild(label);
        }
      }

      function ensureConnectionFilterControls() {
        const controlGrid = root.querySelector(".feps3d-shopify__control-grid");
        if (!controlGrid) return;
        let list = root.querySelector("[data-feps3d-connection-filter-list]");
        if (!list) {
          const dropdown = document.createElement("details");
          dropdown.className = "feps3d-shopify__filter-dropdown feps3d-shopify__filter-dropdown--connection";
          dropdown.dataset.fokUiSectionId = "connection_filter";
          dropdown.dataset.fokUiSectionOrigin = "control";
          const summary = document.createElement("summary");
          summary.textContent = "Connection filter";
          list = document.createElement("div");
          list.className = "feps3d-shopify__filter-body feps3d-shopify__filter-body--connection";
          list.setAttribute("data-feps3d-connection-filter-list", "");
          dropdown.append(summary, list);
          controlGrid.appendChild(dropdown);
        }
        controls.connectionFilterList = list;
        renderConnectionFilterControls();
      }

      controls.nodes.checked = state.showNodes;
      controls.citations.checked = state.showCitations;
      controls.semantic.checked = state.showSemantic;
      controls.referenceThemeHealth.checked = state.showReferenceThemeHealth;
      controls.referenceBlue.checked = state.showReferenceBlue;
      controls.referenceFringe.checked = state.showReferenceFringe;
      controls.phenomena.checked = state.showPhenomena;
      controls.phenomenonGroupL1.checked = state.showPhenomenonGroupL1;
      controls.phenomenonGroupL2.checked = state.showPhenomenonGroupL2;
      controls.phenomenonGroupL3.checked = state.showPhenomenonGroupL3;
      syncViewOptions();
      ensureConnectionFilterControls();
      updateInformationCard(groundedInformationHtml());


      function navigatorNodeLabel(node) {
        return String((node && (node.short_label || node.title || node.label || node.id)) || "").trim() || "Untitled";
      }

      function environmentCategoryDomain(node) {
        if (!isEnvironmentCategoryNode(node)) return null;
        if (node.kind === "natural_environ_category") return "natural";
        if (node.kind === "urban_environ_category") return "urban";
        return null;
      }

      function navigatorNodes(groupKey) {
        let options = nodes.filter((node) => {
          if (!node) return false;
          if (!researchTypeVisibleNode(node)) return false;
          if (groupKey === "sources") return isIntegratedSourceNode(node);
          if (groupKey === "population") return node.kind === "age_category";
          if (groupKey === "tools") return isSpecificToolLikeNode(node);
          if (groupKey === "naturalEnvironments") return environmentCategoryDomain(node) === "natural";
          if (groupKey === "urbanEnvironments") return environmentCategoryDomain(node) === "urban";
          if (groupKey === "eagCategories") return node.kind === "eag_category";
          if (groupKey === "eagConcepts") return node.kind === "eag_concept";
          if (groupKey === "eagExpressions") return node.kind === "eag_expression";
          if (groupKey === "eagConstructs") return node.kind === "eag_construct";
          return false;
        });
        if (groupKey === "eagConcepts") {
          const finalConcepts = options.filter(
            (node) => (node.meta || {}).ontology_status === "final_concept"
          );
          if (finalConcepts.length) options = finalConcepts;
        }
        return options.sort((left, right) => navigatorNodeLabel(left).localeCompare(navigatorNodeLabel(right), undefined, { sensitivity: "base" }));
      }

      function syncNavigatorButtons() {
        for (const button of root.querySelectorAll("[data-feps3d-navigator-node-id]")) {
          const active = button.dataset.feps3dNavigatorNodeId === state.selectedId;
          button.classList.toggle("is-active", active);
          button.setAttribute("aria-pressed", active ? "true" : "false");
        }
      }

      function selectNavigatorNode(nodeId) {
        const node = nodeById.get(nodeId);
        if (!node) return;
        state.selectedId = node.id;
        state.hoverId = null;
        ensurePublicDetailsLoaded(node.id);
        syncNavigatorButtons();
        requestRender();
      }

      function renderNavigatorGroup(groupKey, container) {
        if (!container || container.dataset.feps3dNavigatorRendered === "1") return;
        container.dataset.feps3dNavigatorRendered = "1";
        container.innerHTML = "";
        const options = navigatorNodes(groupKey);
        if (!options.length) {
          const empty = document.createElement("div");
          empty.className = "feps3d-shopify__muted";
          empty.textContent = "No navigator items available.";
          container.appendChild(empty);
          return;
        }
        for (const node of options) {
          const button = document.createElement("button");
          button.type = "button";
          button.className = "feps3d-shopify__navigator-button";
          button.dataset.feps3dNavigatorNodeId = node.id;
          button.setAttribute("aria-pressed", "false");
          button.title = node.id;
          button.textContent = navigatorNodeLabel(node);
          button.addEventListener("click", () => selectNavigatorNode(node.id));
          container.appendChild(button);
        }
      }

      function buildNavigatorControls() {
        for (const [groupKey, container] of Object.entries(controls.navigatorLists || {})) {
          if (!container) continue;
          container.innerHTML = "";
          container.dataset.feps3dNavigatorRendered = "0";
          const dropdown = container.closest(".feps3d-shopify__navigator-dropdown");
          if (!dropdown || dropdown.open) renderNavigatorGroup(groupKey, container);
          if (dropdown && dropdown.dataset.feps3dNavigatorBound !== "1") {
            dropdown.dataset.feps3dNavigatorBound = "1";
            dropdown.addEventListener("toggle", () => {
              if (!dropdown.open) return;
              renderNavigatorGroup(groupKey, container);
              syncNavigatorButtons();
            });
          }
        }
        syncNavigatorButtons();
      }

      function currentIsometricView() {
        return compactMobileQuery.matches
          ? { azimuth: -1.42, elevation: 0.34, zoom: 1.16, projectionMode: "orthographic" }
          : { azimuth: -0.92, elevation: 0.62, zoom: 1, projectionMode: "orthographic" };
      }

      function currentSuperiorView() {
        return { azimuth: -Math.PI / 2, elevation: 1.55, zoom: 1.18, projectionMode: "orthographic" };
      }

      function currentAstronomicalView() {
        return { azimuth: -Math.PI / 2, elevation: Math.PI / 2, zoom: 1.0, projectionMode: "perspective" };
      }

      function currentProfileView() {
        return { azimuth: 0, elevation: 0.0, zoom: 1.0, projectionMode: "orthographic" };
      }

      function applyInitialView() {
        const initialView = currentProfileView();
        state.azimuth = initialView.azimuth;
        state.elevation = initialView.elevation;
        state.zoom = initialView.zoom;
        state.projectionMode = initialView.projectionMode;
      }

      function clampAlpha(alpha) {
        const value = Number(alpha);
        if (!Number.isFinite(value)) return 1;
        return Math.max(0, Math.min(1, value));
      }

      function hexToRgba(hex, alpha = 1) {
        const fallback = "#ffffff";
        const value = typeof hex === "string" && hex.trim() ? hex.trim() : fallback;
        if (value.startsWith("rgb(") || value.startsWith("rgba(")) return value;
        const clean = value.replace("#", "");
        if (!/^[0-9a-fA-F]{6}$/.test(clean)) {
          return hexToRgba(fallback, alpha);
        }
        const r = parseInt(clean.slice(0, 2), 16);
        const g = parseInt(clean.slice(2, 4), 16);
        const b = parseInt(clean.slice(4, 6), 16);
        return `rgba(${r}, ${g}, ${b}, ${clampAlpha(alpha)})`;
      }

      function interactionNumber(key, fallback) {
        const value = Number(interactionStyle[key]);
        return Number.isFinite(value) ? value : fallback;
      }

      function interactionString(key, fallback) {
        const value = interactionStyle[key];
        return typeof value === "string" && value.trim() ? value : fallback;
      }

      function interactionBoolean(key, fallback) {
        const value = interactionStyle[key];
        return typeof value === "boolean" ? value : fallback;
      }

      function escapeHtml(value) {
        return String(value)
          .replace(/&/g, "&amp;")
          .replace(/</g, "&lt;")
          .replace(/>/g, "&gt;")
          .replace(/"/g, "&quot;")
          .replace(/'/g, "&#39;");
      }

      function mathDegToRad(deg) {
        return (deg * Math.PI) / 180;
      }

      function clockDegToMathDeg(clockDeg) {
        let deg = 90 - clockDeg;
        while (deg < 0) deg += 360;
        while (deg >= 360) deg -= 360;
        return deg;
      }

      function yearToZ(year) {
        if (year == null) return unknownYearZ;
        if (year <= flatYearCutoff) return flatYearZ;
        if (year <= hereAndNowYear) return flatYearZ + zUnitsPerYear * (year - flatYearCutoff);
        return flatYearZ + postHanZUnitsPerYear * (year - flatYearCutoff);
      }

      function fokTimeAxisTicks() {
        const ticks = [
          { label: `<=${flatYearCutoff}`, z: flatYearZ },
          { label: "2000", z: yearToZ(2000) },
          { label: "2010", z: yearToZ(2010) },
          { label: "2020", z: yearToZ(2020) },
        ];
        if (!ticks.some((tick) => Math.abs(tick.z - hereAndNowZ) <= 0.001)) {
          ticks.push({ label: "here and now", z: hereAndNowZ });
        }
        return ticks;
      }

      function fokSTimeAxisTicks() {
        const years = Array.from(new Set([2000, 2010, 2020].concat(fokSExtraTickYears)))
          .filter((year) => year > flatYearCutoff && year <= hereAndNowYear)
          .sort((left, right) => left - right);
        const ticks = [{ label: `<=${flatYearCutoff}`, z: flatYearZ }];
        for (const year of years) {
          ticks.push({ label: String(year), z: yearToZ(year) });
        }
        if (!ticks.some((tick) => Math.abs(tick.z - hereAndNowZ) <= 0.001)) {
          ticks.push({ label: "here and now", z: hereAndNowZ });
        }
        return ticks;
      }

      function timeAxisTicks() {
        return state.activeModelPreset === "fok-s" ? fokSTimeAxisTicks() : fokTimeAxisTicks();
      }

      function activeTimeAxisTicks() {
        return timeAxisTicks().filter((tick) => state.activeModelPreset !== "fok-s" || tick.z <= hereAndNowZ + 0.001);
      }

      function displayZForActiveModel(rawZ) {
        if (state.activeModelPreset !== "fok-s" || !Number.isFinite(rawZ)) return rawZ;
        if (rawZ <= flatYearZ + 0.001) return rawZ;
        if (rawZ <= hereAndNowZ + 0.001) {
          return flatYearZ + (rawZ - flatYearZ) * fokSYearSpacingMultiplier;
        }
        return rawZ;
      }

      function activeLogicalMaxOrbit() {
        const sceneMaxOrbit = Number.isFinite(orbitRange[1]) ? orbitRange[1] : 30000;
        return state.activeModelPreset === "fok-s" ? Math.max(sceneMaxOrbit, fokSLogicalMaxOrbit) : sceneMaxOrbit;
      }

      function activeGuideOrbits() {
        return state.activeModelPreset === "fok-s" ? fokSGuideOrbits : [3300, 9000, 10000, 15000, 17000, 4000, 5000, 26000, 28000, 30000, 23000, 25000];
      }

      function orbitRadius(orbitHint) {
        const logicalMaxOrbit = activeLogicalMaxOrbit();
        const inner = 55;
        const extendedOuter = 1250;
        const clamped = Math.max(1, Math.min(logicalMaxOrbit, orbitHint));
        const fraction = (clamped - 1) / (logicalMaxOrbit - 1);
        return inner + fraction * (extendedOuter - inner);
      }

      function orbitHintFromRadius(radius, logicalMaxOrbit) {
        const inner = 55;
        const extendedOuter = 1250;
        const clamped = Math.max(inner, Math.min(extendedOuter, radius));
        const fraction = (clamped - inner) / (extendedOuter - inner);
        return 1 + fraction * (logicalMaxOrbit - 1);
      }

      function polarPoint(orbitHint, angleDeg, z = 0) {
        const radius = orbitRadius(orbitHint);
        const rad = mathDegToRad(angleDeg);
        return {
          x: Math.cos(rad) * radius,
          y: Math.sin(rad) * radius,
          z,
        };
      }

      function legacyFokSDisplayPoint(point) {
        const orbit = fokSReferenceOrbit(point);
        const sourceOrbit = Number.isFinite(orbit) ? orbit : fokSSourceOrbit(point);
        if (!Number.isFinite(sourceOrbit)) return point;
        const numericAngle = Number(point.angle_deg);
        const angleDeg = Number.isFinite(numericAngle)
          ? numericAngle
          : (Math.atan2(Number(point.y) || 0, Number(point.x) || 0) * 180) / Math.PI;
        return polarPoint(sourceOrbit, angleDeg, Number(point.z) || 0);
      }

      function displayPointForActiveModel(point) {
        if (!isSourceResourceElement(point)) return point;
        const meta = point.meta || {};
        if (state.activeModelPreset !== "fok-s") {
          const fokX = Number(meta.fok_x);
          const fokY = Number(meta.fok_y);
          if (Number.isFinite(fokX) && Number.isFinite(fokY)) {
            return { x: fokX, y: fokY, z: Number(point.z) || 0 };
          }
          return point;
        }
        const layoutX = Number(meta.fok_s_layout_x);
        const layoutY = Number(meta.fok_s_layout_y);
        if (Number.isFinite(layoutX) && Number.isFinite(layoutY)) {
          return { x: layoutX, y: layoutY, z: Number(point.z) || 0 };
        }
        return legacyFokSDisplayPoint(point);
      }

      function stemBottomPoint(stem, orbitHint, angleDeg, zValue, centerX, centerY) {
        const radius = orbitRadius(orbitHint);
        const rad = mathDegToRad(angleDeg);
        const stemZ = Number(stem && stem.z);
        const baseZ = Number.isFinite(stemZ) ? stemZ : 0;
        const pointZ = Number.isFinite(Number(zValue)) ? Number(zValue) : baseZ;
        const fallbackCenterX = Number(stem && stem.center_x);
        const fallbackCenterY = Number(stem && stem.center_y);
        const numericCenterX = Number.isFinite(Number(centerX)) ? Number(centerX) : fallbackCenterX;
        const numericCenterY = Number.isFinite(Number(centerY)) ? Number(centerY) : fallbackCenterY;
        return {
          x: (Number.isFinite(numericCenterX) ? numericCenterX : 0) + Math.cos(rad) * radius,
          y: (Number.isFinite(numericCenterY) ? numericCenterY : 0) + Math.sin(rad) * radius,
          z: pointZ,
        };
      }

      function hideShroomTopGuides() {
        if (state.activeModelPreset !== "fok") return false;
        const selectedNode = state.selectedId ? nodeById.get(state.selectedId) : null;
        const hoveredNode = state.hoverId ? nodeById.get(state.hoverId) : null;
        return [selectedNode, hoveredNode].some((node) =>
          isSourceResourceElement(node) ||
          (node && Number.isFinite(Number(node.z)) && Number(node.z) > hereAndNowZ + 0.001)
        );
      }

      function stemBottomGuideRings() {
        if (!stemBottom) return [];
        const fallbackBaseZ = Number.isFinite(Number(stemBottom.z)) ? Number(stemBottom.z) : 0;
        const fallbackCenterX = Number.isFinite(Number(stemBottom.center_x)) ? Number(stemBottom.center_x) : 0;
        const fallbackCenterY = Number.isFinite(Number(stemBottom.center_y)) ? Number(stemBottom.center_y) : 0;
        const rawRings = Array.isArray(stemBottom.guide_rings) ? stemBottom.guide_rings : [];
        const parsed = [];
        if (rawRings.length > 0) {
          for (const ring of rawRings) {
            const orbit = Number(ring && ring.orbit);
            if (!Number.isFinite(orbit)) continue;
            const ringZ = Number(ring && ring.z);
            const ringCenterX = Number(ring && ring.center_x);
            const ringCenterY = Number(ring && ring.center_y);
            const strokeAlpha = Number(ring && ring.stroke_alpha);
            const fillAlpha = Number(ring && ring.fill_alpha);
            const width = Number(ring && ring.width);
            parsed.push({
              orbit,
              z: Number.isFinite(ringZ) ? ringZ : fallbackBaseZ,
              center_x: Number.isFinite(ringCenterX) ? ringCenterX : fallbackCenterX,
              center_y: Number.isFinite(ringCenterY) ? ringCenterY : fallbackCenterY,
              color: typeof ring?.color === "string" && ring.color.trim() ? ring.color : "#B7BBD9",
              stroke_alpha: Number.isFinite(strokeAlpha) ? strokeAlpha : 0.45,
              fill_alpha: Number.isFinite(fillAlpha) ? fillAlpha : 0,
              width: Number.isFinite(width) ? width : 0.75,
              label: typeof ring?.label === "string" ? ring.label : "",
            });
          }
        }
        if (parsed.length > 0) {
          return hideShroomTopGuides()
            ? parsed.filter((ring) => !String(ring.label || "").startsWith("shroom_top"))
            : parsed;
        }
        return [
          {
            orbit: Number(stemBottom.inner_orbit),
            z: fallbackBaseZ,
            center_x: fallbackCenterX,
            center_y: fallbackCenterY,
            color: "#B7BBD9",
            stroke_alpha: 0.38,
            fill_alpha: 0,
            width: 0.75,
            label: "source_to_phenomenon",
          },
          {
            orbit: Number(stemBottom.outer_orbit),
            z: fallbackBaseZ,
            center_x: fallbackCenterX,
            center_y: fallbackCenterY,
            color: "#B7BBD9",
            stroke_alpha: 0.52,
            fill_alpha: 0,
            width: 0.75,
            label: "source_to_tool",
          },
        ].filter((ring) => Number.isFinite(ring.orbit));
      }

      function rotatePoint(point) {
        const displayPoint = displayPointForActiveModel(point);
        const cosA = Math.cos(state.azimuth);
        const sinA = Math.sin(state.azimuth);
        const x1 = displayPoint.x * cosA - displayPoint.y * sinA;
        const y1 = displayPoint.x * sinA + displayPoint.y * cosA;
        const displayZ = displayZForActiveModel(displayPoint.z);

        const cosE = Math.cos(state.elevation);
        const sinE = Math.sin(state.elevation);
        const y2 = y1 * cosE - displayZ * sinE;
        const z2 = y1 * sinE + displayZ * cosE;
        return { x: x1, y: y2, z: z2 };
      }

      function isReferenceSourceNode(node) {
        return isResourceElement(node);
      }

      function substrateNode(node) {
        const nodeZ = Number(node && node.z);
        return isSourceResourceElement(node) && Number.isFinite(nodeZ) && nodeZ >= 0 && nodeZ <= hereAndNowZ;
      }

      function sourceBandName(node) {
        if (!node.meta) return "";
        return node.meta.source_band || node.meta.noder_target_band || "";
      }

      function sourceBandOrbit(node) {
        if (!node.meta) return null;
        const orbit = Number(node.meta.source_band_orbit);
        return Number.isFinite(orbit) ? orbit : null;
      }

      function referenceBandName(node) {
        return node.meta && node.meta.reference_band ? node.meta.reference_band : "";
      }

      function fokSFixedOrbitForNode(node) {
        const meta = node && node.meta ? node.meta : {};
        const visualOrbit = fokSOrbitByVisualType[meta.source_visual_record_type];
        if (Number.isFinite(visualOrbit)) return visualOrbit;
        const bandOrbit = fokSOrbitBySourceBand[meta.source_band || meta.noder_layout_band || ""];
        return Number.isFinite(bandOrbit) ? bandOrbit : null;
      }

      function fokSReferenceOrbit(node) {
        if (!node || !node.meta || !node.meta.reference_band) return null;
        if (node.meta.integration_state === "integrated_source") return null;
        const fixedOrbit = fokSFixedOrbitForNode(node);
        if (Number.isFinite(fixedOrbit)) return fixedOrbit;
        const explicitOrbit = Number(node.meta.fok_s_reference_orbit);
        if (Number.isFinite(explicitOrbit)) return explicitOrbit;
        const band = referenceBandName(node);
        const orbit = fokSReferenceBandOrbits[band];
        return Number.isFinite(orbit) ? orbit : null;
      }

      function fokSSourceOrbit(node) {
        if (!isSourceResourceElement(node)) return null;
        if (fokSReferenceOrbit(node) != null) return null;
        const fixedOrbit = fokSFixedOrbitForNode(node);
        if (Number.isFinite(fixedOrbit)) return fixedOrbit;
        const canonicalOrbit = Number(node.orbit_hint);
        if (Number.isFinite(canonicalOrbit)) return Math.min(fokSSourceMaxOrbit, Math.max(1, canonicalOrbit));
        const radius = Math.hypot(Number(node.x) || 0, Number(node.y) || 0);
        const sceneMaxOrbit = Number.isFinite(orbitRange[1]) ? orbitRange[1] : 30000;
        return Math.min(fokSSourceMaxOrbit, orbitHintFromRadius(radius, sceneMaxOrbit));
      }

      function displayOrbitHintForActiveModel(node) {
        if (state.activeModelPreset !== "fok-s") {
          const fokOrbit = Number(node && node.meta ? node.meta.fok_orbit : null);
          if (Number.isFinite(fokOrbit)) return fokOrbit;
        }
        if (state.activeModelPreset === "fok-s") {
          const layoutBaseOrbit = Number(node && node.meta ? node.meta.fok_s_layout_base_orbit : null);
          if (Number.isFinite(layoutBaseOrbit)) return layoutBaseOrbit;
          const orbit = fokSReferenceOrbit(node);
          if (Number.isFinite(orbit)) return orbit;
          const sourceOrbit = fokSSourceOrbit(node);
          if (Number.isFinite(sourceOrbit)) return sourceOrbit;
        }
        return Number(node && node.orbit_hint);
      }

      function inspectableNode(node) {
        if (!node) return false;
        if (state.activeModelPreset === "fok-s") return isIntegratedSourceNode(node) || hasFokSNutrientConnection(node);
        if (isSourceElement(node)) return node.meta && node.meta.integration_state === "integrated_source";
        if (node.kind === "environment" || node.kind === "participant_group") return true;
        if (isEnvironmentCategoryNode(node) || node.kind === "age_category") return true;
        if (node.kind === "intervention_unit") return true;
        if (node.kind === "research_design") return true;
        if (node.kind === "research_insights") return true;
        if (isPhenomenonLikeNode(node) || isSpecificToolLikeNode(node)) return true;
        if (node.kind === "phenomenon_group") {
          const level = phenomenonGroupLevel(node);
          return (level >= 0 && level <= 5) || level === 9;
        }
        return false;
      }

      function isOuterReferenceBand(node) {
        const band = referenceBandName(node);
        return band === "reference_blue_band" || band === "reference_fringe_band";
      }

      function isIntegratedSourceNode(node) {
        return !!(isSourceElement(node) && node.meta && node.meta.integration_state === "integrated_source");
      }

      function isPublicMobileFokInteraction() {
        return false;
      }

      function isGreenPotentialResourceNode(node) {
        return isResourceElement(node) && referenceBandName(node) === "reference_green_band";
      }

      function isFokSNutrientEdge(edge) {
        if (state.activeModelPreset !== "fok-s" || !edge || edge.kind !== "source_resource") return false;
        const sourceNode = nodeById.get(edge.source);
        const targetNode = nodeById.get(edge.target);
        return (
          (isIntegratedSourceNode(sourceNode) && isGreenPotentialResourceNode(targetNode)) ||
          (isIntegratedSourceNode(targetNode) && isGreenPotentialResourceNode(sourceNode))
        );
      }

      function isFokSNutrientElement(node) {
        if (state.activeModelPreset !== "fok-s" || !isReferenceSourceNode(node)) return false;
        return (edgesByNode.get(node.id) || []).some((edge) => isFokSNutrientEdge(edge));
      }

      function hasFokSNutrientConnection(node) {
        if (state.activeModelPreset !== "fok-s" || !node) return false;
        if (node.meta && node.meta.has_fok_s_nutrient_connection) return true;
        return (edgesByNode.get(node.id) || []).some((edge) => isFokSNutrientEdge(edge));
      }

      function isFokSSelectableSourceNode(node) {
        if (!isSourceResourceElement(node)) return false;
        if (isIntegratedSourceNode(node)) return true;
        return state.activeModelPreset === "fok-s" && isReferenceSourceNode(node) && hasFokSNutrientConnection(node);
      }

      const bakedInteractionScales = Object.freeze({
        normalSourceReference: 0.3,
        inactiveHoverSelection: 0.3,
      });

      function inactiveHoverSelectionScale() {
        return state.activeModelPreset === "fok-s" ? 1 : bakedInteractionScales.inactiveHoverSelection;
      }

      function normalSourceReferenceScale() {
        return bakedInteractionScales.normalSourceReference;
      }

      function normalDimActive() {
        return state.activeModelPreset === "fok" && !state.selectedId && !state.hoverId;
      }

      function normalSourceReferenceDimActive() {
        return normalDimActive();
      }

      function isSourceOrReferenceNode(node) {
        return isSourceResourceElement(node);
      }

      function edgeTouchesSourceReference(edge) {
        if (!edge) return false;
        return isSourceOrReferenceNode(nodeById.get(edge.source)) || isSourceOrReferenceNode(nodeById.get(edge.target));
      }

      function edgeConnectsPhenomenonHierarchy(edge) {
        if (!edge || edge.kind !== "phenomenon_group") return false;
        const sourceNode = nodeById.get(edge.source);
        const targetNode = nodeById.get(edge.target);
        const sourceLevel = phenomenonGroupLevel(sourceNode);
        const targetLevel = phenomenonGroupLevel(targetNode);
        const sourceIsPOrGroup = sourceNode && (sourceNode.kind === "phenomenon" || (sourceNode.kind === "phenomenon_group" && sourceLevel >= 1 && sourceLevel <= 3));
        const targetIsGroup = targetNode && targetNode.kind === "phenomenon_group" && targetLevel >= 1 && targetLevel <= 3;
        return !!(sourceIsPOrGroup && targetIsGroup);
      }

      function edgeConnectsUpperHanModel(edge) {
        return edgeConnectsPhenomenonHierarchy(edge) ||
          edge.kind === "phenomenon_tool" ||
          edge.kind === "tool_group" ||
          edge.kind === "source_phenomenon" ||
          edge.kind === "source_research_design" ||
          edge.kind === "source_research_insights" ||
          edge.kind === "tool_source";
      }

      function defaultClarifyScaleForEdge(edge) {
        if (state.activeModelPreset !== "fok-s" || isFokSNutrientEdge(edge)) return 1;
        return interactionNumber("clarify_factor", 0.2);
      }

      function defaultClarifyScaleForNode(node) {
        if (state.activeModelPreset !== "fok-s" || isIntegratedSourceNode(node) || isFokSNutrientElement(node)) return 1;
        return interactionNumber("clarify_factor", 0.2);
      }

      function isSemanticEdge(edge) {
        return semanticEdgeKinds.has(edge.kind);
      }

      function currentGuidePlaneZ() {
        return state.activeModelPreset === "fok-s" ? hereAndNowZ : layerBaseZ;
      }

      function currentZAxisTop() {
        const configuredTop = Array.isArray(zRange) ? Number(zRange[1]) : NaN;
        const sceneTop = Number.isFinite(configuredTop) ? Math.max(hereAndNowZ, configuredTop) : hereAndNowZ;
        return state.activeModelPreset === "fok-s" ? hereAndNowZ : sceneTop;
      }

      function populationFilterNode(node) {
        return node && (
          node.kind === "participant_group" ||
          node.kind === "age_category" ||
          node.kind === "population"
        );
      }

      function environmentFilterNode(node) {
        return node && (
          node.kind === "environment" ||
          isEnvironmentCategoryNode(node) ||
          node.kind === "urban" ||
          node.kind === "natural"
        );
      }

      function componentVisibleNode(node) {
        if (isDeselectNode(node) && interactionBoolean("deselect_always_available", true)) return true;
        if (state.activeModelPreset === "fok-s" && !substrateNode(node)) return false;
        if (isPhenomenonLikeNode(node) && !state.showPhenomena) return false;
        if (node.kind === "phenomenon_group") {
          const groupLevel = Number(node.meta && node.meta.group_level);
          if (groupLevel === 1 && !state.showPhenomenonGroupL1) return false;
          if (groupLevel === 2 && !state.showPhenomenonGroupL2) return false;
          if (groupLevel >= 3 && !state.showPhenomenonGroupL3) return false;
        }
        if (isResourceElement(node)) {
          const referenceBand = referenceBandName(node);
          if (referenceBand === "reference_green_band" && !state.showReferenceThemeHealth) return false;
          if (referenceBand === "reference_blue_band" && !state.showReferenceBlue) return false;
          if (referenceBand === "reference_fringe_band" && !state.showReferenceFringe) return false;
        }
        return true;
      }

      function visibleNode(node) {
        if (isDeselectNode(node) && interactionBoolean("deselect_always_available", true)) return true;
        return state.showNodes && componentVisibleNode(node) && researchTypeVisibleNode(node);
      }

      function visibleEdge(edge) {
        if (!nodeById.has(edge.source) || !nodeById.has(edge.target)) return false;
        const sourceNode = nodeById.get(edge.source);
        const targetNode = nodeById.get(edge.target);
        if (!researchTypeVisibleEdge(edge)) return false;
        if (!componentVisibleNode(sourceNode) || !componentVisibleNode(targetNode)) return false;
        if (!edgeKindVisible(edge)) return false;
        if (state.activeModelPreset === "fok-s") return isCitationEdge(edge) && state.showCitations;
        if (isCitationEdge(edge)) return state.showCitations;
        if (isSemanticEdge(edge)) return state.showSemantic;
        return true;
      }

      function boundsForCurrentView() {
        const guidePoints = [];
        const guidePlaneZ = currentGuidePlaneZ();
        for (const orbit of activeGuideOrbits()) {
          for (let i = 0; i < 24; i += 1) {
            const angle = (i / 24) * 360;
            guidePoints.push(rotatePoint(polarPoint(orbit, angle, guidePlaneZ)));
          }
        }
        for (const tick of activeTimeAxisTicks()) {
          guidePoints.push(rotatePoint({ x: 0, y: 0, z: tick.z }));
          guidePoints.push(rotatePoint(polarPoint(activeLogicalMaxOrbit(), 0, tick.z)));
        }
        if (state.activeModelPreset === "fok" && stemBottom) {
          for (const ring of stemBottomGuideRings()) {
            const numericOrbit = Number(ring.orbit);
            const numericZ = Number(ring.z);
            if (!Number.isFinite(numericOrbit) || !Number.isFinite(numericZ)) continue;
            for (let i = 0; i < 24; i += 1) {
              const angle = (i / 24) * 360;
            guidePoints.push(rotatePoint(stemBottomPoint(stemBottom, numericOrbit, angle, numericZ, ring.center_x, ring.center_y)));
          }
        }
      }
        guidePoints.push(rotatePoint({ x: 0, y: 0, z: unknownYearZ }));
        guidePoints.push(rotatePoint({ x: 0, y: 0, z: currentZAxisTop() }));
        guidePoints.push(rotatePoint({ x: 0, y: 0, z: 0 }));

        const rotatedNodes = nodes.filter(visibleNode).map((node) => rotatePoint(node));
        const all = rotatedNodes.concat(guidePoints);
        const xs = all.map((point) => point.x);
        const zs = all.map((point) => point.z);
        const minX = Math.min(...xs);
        const maxX = Math.max(...xs);
        const minZ = Math.min(...zs);
        const maxZ = Math.max(...zs);
        const width = Math.max(1, maxX - minX);
        const height = Math.max(1, maxZ - minZ);
        return {
          centerX: (minX + maxX) / 2,
          centerZ: (minZ + maxZ) / 2,
          width,
          height,
        };
      }

      function screenTransform() {
        const rawDpr = window.devicePixelRatio || 1;
        const dpr = compactMobileQuery.matches ? Math.min(rawDpr, 2) : rawDpr;
        const rect = canvas.getBoundingClientRect();
        canvas.width = Math.max(1, Math.floor(rect.width * dpr));
        canvas.height = Math.max(1, Math.floor(rect.height * dpr));
        ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
        const width = rect.width;
        const height = rect.height;
        const bounds = boundsForCurrentView();
        const margin = width < 720 ? 18 : 70;
        const scale = Math.min(
          (width - margin * 2) / bounds.width,
          (height - margin * 2) / bounds.height,
        ) * state.zoom;
        return { width, height, scale, bounds };
      }

      function projectRotated(rotated, transform) {
        const centeredX = rotated.x - transform.bounds.centerX;
        const centeredZ = rotated.z - transform.bounds.centerZ;
        if (state.projectionMode === "perspective") {
          const safeDistance = Math.max(1200, state.cameraDistance - rotated.y);
          const factor = state.cameraDistance / safeDistance;
          return {
            x: transform.width / 2 + centeredX * transform.scale * factor,
            y: transform.height / 2 - centeredZ * transform.scale * factor,
            depth: rotated.y,
          };
        }
        return {
          x: transform.width / 2 + centeredX * transform.scale,
          y: transform.height / 2 - centeredZ * transform.scale,
          depth: rotated.y,
        };
      }

      function projectWorld(point, transform) {
        return projectRotated(rotatePoint(point), transform);
      }

      function drawPath(points, strokeStyle, lineWidth = 1, dash = []) {
        if (points.length < 2) return;
        ctx.save();
        ctx.strokeStyle = strokeStyle;
        ctx.lineWidth = lineWidth;
        ctx.setLineDash(dash);
        ctx.beginPath();
        ctx.moveTo(points[0].x, points[0].y);
        for (let i = 1; i < points.length; i += 1) {
          ctx.lineTo(points[i].x, points[i].y);
        }
        ctx.stroke();
        ctx.restore();
      }

      function drawFilledPath(points, fillStyle) {
        if (points.length < 3) return;
        ctx.save();
        ctx.fillStyle = fillStyle;
        ctx.beginPath();
        ctx.moveTo(points[0].x, points[0].y);
        for (let i = 1; i < points.length; i += 1) {
          ctx.lineTo(points[i].x, points[i].y);
        }
        ctx.closePath();
        ctx.fill();
        ctx.restore();
      }

      function drawCircleGuide(transform, orbit, color) {
        const points = [];
        const guideZ = currentGuidePlaneZ();
        for (let i = 0; i <= 72; i += 1) {
          const angle = (i / 72) * 360;
          points.push(projectWorld(polarPoint(orbit, angle, guideZ), transform));
        }
        drawPath(points, color, state.activeModelPreset === "fok-s" ? 0.9 : 1);
        if (state.activeModelPreset === "fok-s") {
          const labelPoint = projectWorld(polarPoint(orbit, 0, guideZ), transform);
          ctx.save();
          ctx.fillStyle = color;
          ctx.font = "10px Avenir Next, Segoe UI, sans-serif";
          ctx.fillText(`o${Math.round(orbit)}`, labelPoint.x + 8, labelPoint.y - 4);
          ctx.restore();
        }
      }

      function fokSGuideColor(orbit) {
        if (Math.round(orbit) === 20000) return "rgba(232, 194, 115, 0.78)";
        if (Math.round(orbit) === 21000) return "rgba(143, 213, 166, 0.74)";
        if (Math.round(orbit) === 23000) return "rgba(127, 182, 244, 0.74)";
        if (Math.round(orbit) === 25000) return "rgba(183, 187, 217, 0.68)";
        if (Math.round(orbit) === 45000) return "rgba(232, 194, 115, 0.62)";
        if (Math.round(orbit) === 46000) return "rgba(229, 138, 182, 0.68)";
        if (Math.round(orbit) === 49000) return "rgba(234, 116, 91, 0.72)";
        if (Math.round(orbit) === 50000) return "rgba(105, 102, 153, 0.82)";
        return "rgba(183, 187, 217, 0.36)";
      }

      function drawFokSOrbitGuides(transform) {
        if (state.activeModelPreset !== "fok-s") return;
        // FOK-S keeps orbital positions in node placement, but avoids a heavy rim on the HAN plane.
      }

      function drawSectorRay(transform, clockDeg, orbit, color) {
        const angleDeg = clockDegToMathDeg(clockDeg);
        const target = projectWorld(polarPoint(orbit, angleDeg, layerBaseZ), transform);
        const origin = projectWorld({ x: 0, y: 0, z: layerBaseZ }, transform);
        drawPath([origin, target], color, 1.2);
      }

      function guidePlanePoints(transform, zValue) {
        const yearRingOrbit = activeLogicalMaxOrbit();
        const planePoints = [];
        for (let i = 0; i <= 96; i += 1) {
          const angle = (i / 96) * 360;
          planePoints.push(projectWorld(polarPoint(yearRingOrbit, angle, zValue), transform));
        }
        return planePoints;
      }

      function drawGuidePlaneRing(transform, zValue, options) {
        const planePoints = guidePlanePoints(transform, zValue);
        const stroke = interactionString(options.strokeKey, options.strokeFallback);
        const alpha = interactionNumber(options.alphaKey, options.alphaFallback);
        const width = interactionNumber(options.widthKey, options.widthFallback);
        if (options.fillKey) {
          drawFilledPath(
            planePoints,
            hexToRgba(
              interactionString(options.fillKey, options.fillFallback),
              interactionNumber(options.fillAlphaKey, options.fillAlphaFallback),
            ),
          );
        }
        drawPath(
          planePoints,
          hexToRgba(stroke, alpha),
          width,
        );
        if (options.label) {
          const labelPoint = projectWorld(polarPoint(activeLogicalMaxOrbit(), 8, zValue), transform);
          ctx.fillStyle = hexToRgba(
            interactionString(options.labelFillKey, stroke),
            interactionNumber(options.labelAlphaKey, 0.78),
          );
          ctx.font = "9.8px Avenir Next, Segoe UI, sans-serif";
          ctx.fillText(options.label, labelPoint.x + 10, labelPoint.y - 1);
        }
      }

      function drawPetriDishBottom(transform) {
        if (state.activeModelPreset !== "fok") return;
        drawGuidePlaneRing(transform, unknownYearZ, {
          fillKey: "petri_dish_bottom_fill",
          fillFallback: "#0C2B69",
          fillAlphaKey: "petri_dish_bottom_fill_alpha",
          fillAlphaFallback: 0.34,
          strokeKey: "petri_dish_bottom_stroke",
          strokeFallback: interactionString("han_plane_stroke", "#DCC9FF"),
          alphaKey: "petri_dish_bottom_stroke_alpha",
          alphaFallback: interactionNumber("han_plane_stroke_alpha", 0.92),
          widthKey: "petri_dish_bottom_stroke_width",
          widthFallback: interactionNumber("han_plane_stroke_width", 2.4),
          label: "petri_dish_bottom",
          labelFillKey: "petri_dish_bottom_label_fill",
          labelAlphaKey: "petri_dish_bottom_label_alpha",
        });
      }

      function drawHanPlane(transform) {
        if (state.activeModelPreset !== "fok") return;
        drawGuidePlaneRing(transform, hereAndNowZ, {
          strokeKey: "han_plane_stroke",
          strokeFallback: "#DCC9FF",
          alphaKey: "han_plane_stroke_alpha",
          alphaFallback: 0.92,
          widthKey: "han_plane_stroke_width",
          widthFallback: 2.4,
        });
      }

      function drawStemBottom(transform) {
        if (state.activeModelPreset !== "fok" || !stemBottom) return;
        const routeRings = stemBottomGuideRings();
        for (const ring of routeRings) {
          if (!Number.isFinite(ring.orbit)) continue;
          const points = [];
          const ringZ = Number(ring.z);
          const ringLabel = String(ring.label || "");
          const ringNormalDimFactor = normalDimActive() && (ringLabel.includes("source") || ringLabel.startsWith("shroom_top"))
            ? normalSourceReferenceScale()
            : 1;
          const ringStroke = hexToRgba(ring.color, clampAlpha(ring.stroke_alpha) * ringNormalDimFactor);
          const ringFillAlpha = clampAlpha(ring.fill_alpha || 0) * ringNormalDimFactor;
          const ringWidth = Math.max(0.2, (Number.isFinite(Number(ring.width)) ? Number(ring.width) : 0.75) * ringNormalDimFactor);
          for (let i = 0; i <= 72; i += 1) {
            const angle = (i / 72) * 360;
            points.push(projectWorld(stemBottomPoint(stemBottom, ring.orbit, angle, ringZ, ring.center_x, ring.center_y), transform));
          }
          if (ringFillAlpha > 0) {
            drawFilledPath(points, hexToRgba(ring.color, ringFillAlpha));
          }
          drawPath(points, ringStroke, ringWidth);
        }
      }

      function drawAxes(transform) {
        const origin = projectWorld({ x: 0, y: 0, z: unknownYearZ }, transform);
        const axisTicks = activeTimeAxisTicks();
        const zAxisTop = projectWorld({ x: 0, y: 0, z: currentZAxisTop() }, transform);
        const axisColor = "rgba(183, 187, 217, 0.98)";
        const axisTickFont = "9.8px Avenir Next, Segoe UI, sans-serif";
        const isFokSView = state.activeModelPreset === "fok-s";
        const yearRingColor = isFokSView ? "rgba(183, 187, 217, 0.30)" : "rgba(183, 187, 217, 0.42)";
        const yearRingWidth = isFokSView ? 0.35 : 0.6;
        const yearRingDash = isFokSView ? [4, 7] : [];
        const yearRingOrbit = activeLogicalMaxOrbit();
        const axisDx = zAxisTop.x - origin.x;
        const axisDy = zAxisTop.y - origin.y;
        const axisLength = Math.max(1, Math.hypot(axisDx, axisDy));
        const perpX = -axisDy / axisLength;
        const perpY = axisDx / axisLength;
        ctx.fillStyle = axisColor;

        for (const axisTick of axisTicks) {
          const tick = projectWorld({ x: 0, y: 0, z: axisTick.z }, transform);
          const tickStart = { x: tick.x - perpX * 8, y: tick.y - perpY * 8 };
          const tickEnd = { x: tick.x + perpX * 8, y: tick.y + perpY * 8 };
          const ringPoints = [];
          for (let i = 0; i <= 72; i += 1) {
            const angle = (i / 72) * 360;
            ringPoints.push(projectWorld(polarPoint(yearRingOrbit, angle, axisTick.z), transform));
          }
          drawPath(ringPoints, yearRingColor, yearRingWidth, yearRingDash);
          drawPath([tickStart, tickEnd], axisColor, 0.5);
          const labelPoint = projectWorld(polarPoint(yearRingOrbit, 0, axisTick.z), transform);
          ctx.fillStyle = axisColor;
          ctx.font = axisTickFont;
          ctx.fillText(axisTick.label, labelPoint.x + 10, labelPoint.y - 1);
        }
      }

      function drawGuides(transform) {
        drawFokSOrbitGuides(transform);
        drawPetriDishBottom(transform);
        drawHanPlane(transform);
        drawStemBottom(transform);
        drawAxes(transform);
      }

      const defaultEdgeStateWidths = {
        normal: 0.7,
        dim: 0.15,
        hover: 1.5,
        selection: 2.0,
      };
      let edgeStateWidths = defaultEdgeStateWidths;
      let edgeWidthMatrix = {};

      function activeEdgeWidthRole(hoveredNode, hoverScope) {
        const activeNodeId = hoverScope && hoverScope.activeNodeId;
        const activeNode = activeNodeId ? nodeById.get(activeNodeId) : hoveredNode;
        return selectionMatrixRole(nodeSizeRole(activeNode));
      }

      function edgeWidthForState(edge, stateName, hoveredNode, hoverScope) {
        const stateRow = edgeWidthMatrix && edgeWidthMatrix[stateName];
        const rawKind = edge && edge.kind;
        const alphaKind = edgeAlphaKey(edge);
        const mappedValue = stateRow
          ? Number(
              stateRow[rawKind] != null
                ? stateRow[rawKind]
                : (stateRow[alphaKind] != null
                  ? stateRow[alphaKind]
                  : (isCitationEdge(edge)
                    ? stateRow.citation
                    : NaN)),
            )
          : NaN;
        const globalValue = Number(
          edgeStateWidths && edgeStateWidths[stateName],
        );
        let width = Number.isFinite(mappedValue)
          ? mappedValue
          : (Number.isFinite(globalValue)
            ? globalValue
            : defaultEdgeStateWidths[stateName]);
        if (stateName !== "hover" && stateName !== "selection") return width;
        const activeRole = activeEdgeWidthRole(hoveredNode, hoverScope);
        const kindRows = interactionEdgeKindWidths && interactionEdgeKindWidths[stateName];
        const kindRow = kindRows && activeRole ? kindRows[activeRole] : null;
        const edgeKind = edgeAlphaKey(edge);
        const exceptionalValue = kindRow
          ? Number(
              kindRow[edgeKind] != null
                ? kindRow[edgeKind]
                : (isCitationEdge(edge) && kindRow.citation != null
                  ? kindRow.citation
                  : kindRow["*"]),
            )
          : NaN;
        if (Number.isFinite(exceptionalValue)) width = exceptionalValue;
        return width;
      }

      function edgeDrawStyle(edge, hoveredNode, dimmed = false, hoverScope = null) {
        const viaNodeIds = Array.isArray(edge.meta && edge.meta.via_node_ids) ? edge.meta.via_node_ids : [];
        const connected = hoveredNode && (
          edge.source === hoveredNode.id ||
          edge.target === hoveredNode.id ||
          viaNodeIds.includes(hoveredNode.id)
        );
        const baseAlpha = edgeBaseAlpha(edge);
        const isResearchRoute = String(edge.meta && edge.meta.route_name || "").toLowerCase() === "research_route";
        const researchRouteColor = interactionString("research_route_color", "#A887E6");
        const useResearchRouteColor = isResearchRoute && isSemanticEdge(edge);
        const nutrientEdge = isFokSNutrientEdge(edge);
        const nutrientColor = "#a7f3ae";
        const nutrientDash = [7, 5];
        const baseColor = useResearchRouteColor
          ? researchRouteColor
          : edge.style.color;
        const activeState = hoverScope && hoverScope.interactionMode === "hover"
          ? "hover"
          : "selection";
        const edgeInActiveScope = hoverScope && hoverScope.edges && hoverScope.edges.has(edge);
        const focusedColor = useResearchRouteColor
          ? researchRouteColor
          : isSemanticEdge(edge)
          ? edge.style.color
          : interactionString("connected_edge_color", "#9491BF");
        const dash = nutrientEdge ? nutrientDash : edge.style.dash || [];

        if (normalDimActive() && (edgeTouchesSourceReference(edge) || edgeConnectsUpperHanModel(edge))) {
          const factor = normalSourceReferenceScale();
          return {
            color: hexToRgba(
              nutrientEdge ? nutrientColor : baseColor,
              baseAlpha * edgeAlphaMultiplier(edge, "normal_source_reference", factor),
            ),
            width: Math.max(0.01, edgeWidthForState(edge, "dim", hoveredNode, hoverScope)),
            dash,
          };
        }
        if (dimmed) {
          const hoverSeeFactor = interactionNumber("hover_see_factor", 0.3);
          return {
            color: hexToRgba(
              nutrientEdge ? nutrientColor : baseColor,
              baseAlpha * edgeAlphaMultiplier(edge, "dim", hoverSeeFactor),
            ),
            width: Math.max(0.01, edgeWidthForState(edge, "dim", hoveredNode, hoverScope)),
            dash,
          };
        }

        if ((edgeInActiveScope && hoveredNode) || connected) {
          const stateName = hoverScope ? activeState : "hover";
          return {
            color: hexToRgba(
              nutrientEdge ? nutrientColor : focusedColor,
              edgeAlphaOverride(
                edge,
                stateName,
                interactionNumber("connected_edge_alpha", 0.92),
              ),
            ),
            width: Math.max(
              0.01,
              edgeWidthForState(edge, stateName, hoveredNode, hoverScope),
            ),
            dash,
          };
        }

        if (isCitationEdge(edge) && hoveredNode) {
          return {
            color: hexToRgba(
              baseColor,
              baseAlpha * edgeAlphaMultiplier(
                edge,
                "citation_hover_background",
                interactionNumber("hover_see_factor", 0.3),
              ),
            ),
            width: Math.max(0.01, edgeWidthForState(edge, "dim", hoveredNode, hoverScope)),
            dash: [],
          };
        }

        return {
          color: hexToRgba(
            nutrientEdge ? nutrientColor : baseColor,
            nutrientEdge
              ? edgeAlphaOverride(edge, "fok_s_nutrient", 0.76)
              : baseAlpha * edgeAlphaMultiplier(edge, "normal", 1),
          ),
          width: Math.max(0.01, edgeWidthForState(edge, "normal", hoveredNode, hoverScope)),
          dash,
        };
      }

      function drawEdge(edge, projectedById, hoveredNode, transform, hoverScope) {
        const from = projectedById.get(edge.source);
        const to = projectedById.get(edge.target);
        if (!from || !to) return;
        const dimmed = hoverScope && (
          !hoverScope.edges.has(edge) ||
          (hoverScope.contextualEdges && hoverScope.contextualEdges.has(edge))
        );
        const style = edgeDrawStyle(edge, hoveredNode, dimmed, hoverScope);
        const route = [from];
        const viaPoints = edge.meta && Array.isArray(edge.meta.via) ? edge.meta.via : [];
        for (const via of viaPoints) {
          const x = Number(Array.isArray(via) ? via[0] : via.x);
          const y = Number(Array.isArray(via) ? via[1] : via.y);
          const z = Number(Array.isArray(via) ? via[2] : via.z);
          if (Number.isFinite(x) && Number.isFinite(y) && Number.isFinite(z)) {
            route.push(projectWorld({ x, y, z }, transform));
          }
        }
        route.push(to);
        drawPath(route, style.color, style.width, style.dash);
      }

      function fokSReferencePotentialFactor(node) {
        if (state.activeModelPreset !== "fok-s" || !isReferenceSourceNode(node)) return 1;
        const materializedFactor = Number(node.meta && node.meta.reference_potential_factor);
        if (Number.isFinite(materializedFactor)) return Math.max(1, materializedFactor);
        const score = Number(node.meta && node.meta.reference_potential_score);
        return Number.isFinite(score) ? Math.max(1, score / 5) : 1;
      }

      function fokSReferenceNutrientFactor(node) {
        if (state.activeModelPreset !== "fok-s" || !isReferenceSourceNode(node)) return 1;
        const materializedScore = Number(node.meta && node.meta.reference_nutrient_score);
        if (Number.isFinite(materializedScore)) return Math.max(0.9, Math.min(3, materializedScore));
        const nutrientCount = (edgesByNode.get(node.id) || []).filter((edge) => isFokSNutrientEdge(edge)).length;
        return Math.max(0.9, Math.min(3, nutrientCount));
      }

      function fokSBaseStyleSize(node) {
        const metaSize = Number(node && node.meta && node.meta.fok_s_base_size);
        if (state.activeModelPreset === "fok-s" && Number.isFinite(metaSize) && metaSize > 0) return metaSize;
        return node && node.style && node.style.size ? node.style.size : 10;
      }

      function nodeDisplaySize(node, sizeScale) {
        const baseSize = fokSBaseStyleSize(node) * sizeScale;
        return baseSize * fokSReferencePotentialFactor(node) * fokSReferenceNutrientFactor(node);
      }

      function phenomenonGroupLevel(node) {
        const rawLevel = node && node.meta && node.meta.group_level;
        const explicitLevel = Number(rawLevel);
        if (Number.isFinite(explicitLevel)) return explicitLevel;
        if (node && Array.isArray(node.meta)) {
          for (const value of node.meta) {
            const packedLevel = Number(value);
            if (Number.isFinite(packedLevel) && packedLevel >= 0 && packedLevel <= 5) return packedLevel;
            const packedMatch = String(value || "").match(/(?:group_)?l(\d+)/i);
            if (packedMatch) return Number(packedMatch[1]);
          }
        }
        const semanticLevel = String((node && node.meta && node.meta.semantic_level) || rawLevel || "");
        const match = semanticLevel.match(/(?:group_)?l(\d+)/i);
        if (match) return Number(match[1]);
        const idMatch = String((node && node.id) || "").match(/PHENOGROUP-L(\d+)-/i);
        return idMatch ? Number(idMatch[1]) : null;
      }

      function isUpperPhenomenonGroup(node) {
        if (!node || node.kind !== "phenomenon_group") return false;
        const level = phenomenonGroupLevel(node);
        return level >= 2 && level <= 5;
      }

      function isLabeledPhenomenonGroup(node) {
        if (!node || node.kind !== "phenomenon_group") return false;
        const level = phenomenonGroupLevel(node);
        return (level >= 0 && level <= 5) || level === 9;
      }

      function isSpecificToolLikeNode(node) {
        return !!node && (node.kind === "specific_tool" || node.kind === "specific_tool_group" || node.kind === "tool");
      }

      function linkedToolPoles(node) {
        const poles = new Set();
        if (!isSpecificToolLikeNode(node)) return poles;
        for (const edge of edgesByNode.get(node.id) || []) {
          if (!visibleEdge(edge)) continue;
          let phenomenonId = null;
          if (edge.kind === "phenomenon_tool" && edge.source === node.id) {
            phenomenonId = edge.target;
          } else if (edge.kind === "source_phenomenon" && edgeViaNodeIds(edge).includes(node.id)) {
            phenomenonId = edge.target;
          }
          const pole = String((nodeById.get(phenomenonId) || {}).meta?.primary_pole || "").toUpperCase();
          if (pole === "ECO" || pole === "PSYCHO" || pole === "SOMATIC") poles.add(pole);
        }
        return poles;
      }

      function isMultidimensionalToolNode(node) {
        return linkedToolPoles(node).size > 1;
      }

      function activeSelectionBlocksCandidate(node) {
        const selectedNode = state.selectedId ? nodeById.get(state.selectedId) : null;
        return !!(selectedNode && node && selectedNode.id !== node.id && isMultidimensionalToolNode(node));
      }

      function isScopeLabelableNode(node) {
        return !!node && (
          isSourceResourceElement(node) ||
          isSpecificToolLikeNode(node) ||
          isPhenomenonLikeNode(node) ||
          node.kind === "environment" ||
          node.kind === "participant_group" ||
          node.kind === "intervention_unit" ||
          node.kind === "research_design" ||
          node.kind === "research_insights" ||
          isEnvironmentCategoryNode(node) ||
          node.kind === "age_category" ||
          isContextClusterNode(node) ||
          isLabeledPhenomenonGroup(node)
        );
      }

      function shouldLabelNode(node, hoveredNode, hoverScope) {
        if (!node) return false;
        if (!hoverScope) {
          const level = phenomenonGroupLevel(node);
          return node.kind === "phenomenon_group"
            && [0, 3, 4, 5, 9].includes(level);
        }
        if (hoverScope.activeNodeId === node.id) return !hoverScope.suppressActiveLabel;
        if (hoverScope.labelNodeIds && hoverScope.labelNodeIds.has(node.id) && isScopeLabelableNode(node)) return true;
        return false;
      }

      function isL3Node(node) {
        const level = phenomenonGroupLevel(node);
        return !!node && node.kind === "phenomenon_group" && level >= 3 && level <= 5;
      }

      function publicMobileFokSelectableNode(node) {
        if (!node || isSourceResourceElement(node)) return false;
        if (node.kind === "environment" || node.kind === "participant_group" || node.kind === "intervention_unit" || node.kind === "research_design" || node.kind === "research_insights") return true;
        if (isEnvironmentCategoryNode(node) || node.kind === "age_category" || isContextClusterNode(node)) return true;
        if (isPhenomenonLikeNode(node) || isSpecificToolLikeNode(node)) return true;
        if (node.kind === "phenomenon_group") {
          const level = phenomenonGroupLevel(node);
          return (level >= 0 && level <= 5) || level === 9;
        }
        return false;
      }

      function baseSelectableNode(node) {
        if (!node || !visibleNode(node)) return false;
        if (isSourceResourceElement(node)) {
          if (isPublicMobileFokInteraction()) {
            const selectedNode = state.selectedId ? nodeById.get(state.selectedId) : null;
            if (!selectedNode || !(isPhenomenonLikeNode(selectedNode) || isSpecificToolLikeNode(selectedNode))) {
              return false;
            }
          }
          return isFokSSelectableSourceNode(node);
        }
        if (node.kind === "environment" || node.kind === "participant_group" || node.kind === "intervention_unit" || node.kind === "research_design" || node.kind === "research_insights") return true;
        if (isEnvironmentCategoryNode(node) || node.kind === "age_category" || isContextClusterNode(node)) return true;
        if (isPhenomenonLikeNode(node) || isSpecificToolLikeNode(node)) return true;
        if (node.kind === "phenomenon_group") {
          const level = phenomenonGroupLevel(node);
          return (level >= 0 && level <= 5) || level === 9;
        }
        return false;
      }

      function normalSelectableNode(node) {
        if (!baseSelectableNode(node)) return false;
        if (state.activeModelPreset === "fok-s" && isFokSSelectableSourceNode(node)) {
          return true;
        }
        if (isPublicMobileFokInteraction()) {
          return publicMobileFokSelectableNode(node) && permissionAllows("normal", "select", node);
        }
        if (node.kind === "environment" || node.kind === "participant_group" || node.kind === "intervention_unit" || node.kind === "research_design" || node.kind === "research_insights") return permissionAllows("normal", "select", node);
        if (isEnvironmentCategoryNode(node) || node.kind === "age_category" || isContextClusterNode(node)) return permissionAllows("normal", "select", node);
        const groupLevel = phenomenonGroupLevel(node);
        const selectableUpperGroup = node.kind === "phenomenon_group"
          && ((groupLevel >= 0 && groupLevel <= 5) || groupLevel === 9);
        return (selectableUpperGroup || isFokSSelectableSourceNode(node)) && permissionAllows("normal", "select", node);
      }

      function repeatedSelectionClears(node) {
        if (state.activeModelPreset === "fok-s") return true;
        return interactionBoolean("deselect_repeated_selection", false);
      }

      function addSelectableNodeId(allowedIds, nodeId) {
        const candidate = nodeById.get(nodeId);
        if (activeSelectionBlocksCandidate(candidate)) return;
        if (baseSelectableNode(candidate)) allowedIds.add(nodeId);
      }

      function addViaSelectableTools(allowedIds, edge) {
        for (const viaNodeId of edgeViaNodeIds(edge)) {
          const viaNode = nodeById.get(viaNodeId);
          if (isSpecificToolLikeNode(viaNode)) {
            addSelectableNodeId(allowedIds, viaNodeId);
          }
        }
      }

      function addPhenomenonHierarchySelectable(allowedIds, phenomenonId) {
        const l1Ids = new Set();
        const l2Ids = new Set();
        for (const edge of edgesByNode.get(phenomenonId) || []) {
          if (!visibleEdge(edge) || edge.kind !== "phenomenon_group") continue;
          if (edge.source === phenomenonId && phenomenonGroupLevel(nodeById.get(edge.target)) === 1) {
            addSelectableNodeId(allowedIds, edge.target);
            l1Ids.add(edge.target);
          }
        }
        for (const l1Id of l1Ids) {
          for (const edge of edgesByNode.get(l1Id) || []) {
            if (!visibleEdge(edge) || edge.kind !== "phenomenon_group") continue;
            if (edge.source === l1Id && phenomenonGroupLevel(nodeById.get(edge.target)) === 2) {
              addSelectableNodeId(allowedIds, edge.target);
              l2Ids.add(edge.target);
            }
          }
        }
        for (const l2Id of l2Ids) {
          for (const edge of edgesByNode.get(l2Id) || []) {
            if (!visibleEdge(edge) || edge.kind !== "phenomenon_group") continue;
            if (edge.source === l2Id && phenomenonGroupLevel(nodeById.get(edge.target)) === 3) {
              addSelectableNodeId(allowedIds, edge.target);
            }
          }
        }
      }

      function selectionAllowedNodeIds(selectedNode) {
        const allowedIds = new Set();
        if (!baseSelectableNode(selectedNode)) return allowedIds;
        if (isEnvironmentCategoryNode(selectedNode) || selectedNode.kind === "age_category") {
          const categoryEdgeKind = isEnvironmentCategoryNode(selectedNode)
            ? selectedNode.kind
            : "participant_group_age_category";
          for (const edge of edgesByNode.get(selectedNode.id) || []) {
            if (!visibleEdge(edge) || edge.kind !== categoryEdgeKind) continue;
            addSelectableNodeId(allowedIds, edge.source === selectedNode.id ? edge.target : edge.source);
          }
          return allowedIds;
        }
        if (isContextClusterNode(selectedNode)) {
          for (const edge of edgesByNode.get(selectedNode.id) || []) {
            if (!visibleEdge(edge) || edge.kind !== selectedNode.kind) continue;
            addSelectableNodeId(allowedIds, edge.source === selectedNode.id ? edge.target : edge.source);
          }
          return allowedIds;
        }
        const selectedLevel = phenomenonGroupLevel(selectedNode);
        if (selectedNode.kind === "phenomenon_group" && (selectedLevel === 4 || selectedLevel === 5)) {
          const upperEdgeKind = selectedLevel === 4 ? "l4_context_cluster" : "l5_eag_semantic";
          for (const edge of edgesByNode.get(selectedNode.id) || []) {
            if (!visibleEdge(edge) || edge.kind !== upperEdgeKind) continue;
            addSelectableNodeId(
              allowedIds,
              edge.source === selectedNode.id ? edge.target : edge.source
            );
          }
          return allowedIds;
        }
        if (selectedNode.kind === "phenomenon_group" && selectedLevel === 3) {
          const childL2Ids = new Set();
          for (const edge of edgesByNode.get(selectedNode.id) || []) {
            if (!visibleEdge(edge) || edge.kind !== "phenomenon_group") continue;
            if (edge.target === selectedNode.id && phenomenonGroupLevel(nodeById.get(edge.source)) === 2) {
              addSelectableNodeId(allowedIds, edge.source);
              childL2Ids.add(edge.source);
            }
          }
          for (const l2Id of childL2Ids) {
            for (const edge of edgesByNode.get(l2Id) || []) {
              if (!visibleEdge(edge) || !contextClusterKindSet.has(edge.kind)) continue;
              const contextId = edge.source === l2Id ? edge.target : edge.source;
              const contextNode = nodeById.get(contextId);
              if (isContextClusterNode(contextNode)) addSelectableNodeId(allowedIds, contextId);
            }
          }
          return allowedIds;
        }
        if (selectedNode.kind === "phenomenon_group" && selectedLevel === 2) {
          const l3Ids = new Set();
          for (const edge of edgesByNode.get(selectedNode.id) || []) {
            if (!visibleEdge(edge) || edge.kind !== "phenomenon_group") continue;
            if (edge.target === selectedNode.id && phenomenonGroupLevel(nodeById.get(edge.source)) === 1) {
              addSelectableNodeId(allowedIds, edge.source);
            } else if (edge.source === selectedNode.id && phenomenonGroupLevel(nodeById.get(edge.target)) === 3) {
              addSelectableNodeId(allowedIds, edge.target);
              l3Ids.add(edge.target);
            }
          }
          for (const l3Id of l3Ids) {
            for (const edge of edgesByNode.get(l3Id) || []) {
              if (!visibleEdge(edge) || edge.kind !== "phenomenon_group") continue;
              if (edge.target === l3Id && phenomenonGroupLevel(nodeById.get(edge.source)) === 2) {
                addSelectableNodeId(allowedIds, edge.source);
              }
            }
          }
          return allowedIds;
        }
        if (selectedNode.kind === "phenomenon_group" && selectedLevel === 1) {
          const l2Ids = new Set();
          for (const edge of edgesByNode.get(selectedNode.id) || []) {
            if (!visibleEdge(edge) || edge.kind !== "phenomenon_group") continue;
            if (edge.source === selectedNode.id && phenomenonGroupLevel(nodeById.get(edge.target)) === 2) {
              addSelectableNodeId(allowedIds, edge.target);
              l2Ids.add(edge.target);
            } else if (edge.target === selectedNode.id) {
              const childNode = nodeById.get(edge.source);
              if (childNode && childNode.kind === "phenomenon") addSelectableNodeId(allowedIds, edge.source);
            }
          }
          for (const l2Id of l2Ids) {
            for (const edge of edgesByNode.get(l2Id) || []) {
              if (!visibleEdge(edge) || edge.kind !== "phenomenon_group") continue;
              if (edge.source === l2Id && phenomenonGroupLevel(nodeById.get(edge.target)) === 3) {
                addSelectableNodeId(allowedIds, edge.target);
              }
            }
          }
          return allowedIds;
        }
        if (isPhenomenonLikeNode(selectedNode)) {
          const l1Ids = new Set();
          const l2Ids = new Set();
          for (const edge of edgesByNode.get(selectedNode.id) || []) {
            if (!visibleEdge(edge)) continue;
            if (edge.kind === "phenomenon_group" && edge.source === selectedNode.id && phenomenonGroupLevel(nodeById.get(edge.target)) === 1) {
              addSelectableNodeId(allowedIds, edge.target);
              l1Ids.add(edge.target);
            } else if (edge.kind === "source_phenomenon" && edge.target === selectedNode.id) {
              addSelectableNodeId(allowedIds, edge.source);
              addViaSelectableTools(allowedIds, edge);
            } else if (edge.kind === "phenomenon_tool" && edge.target === selectedNode.id) {
              addSelectableNodeId(allowedIds, edge.source);
            }
          }
          for (const l1Id of l1Ids) {
            for (const edge of edgesByNode.get(l1Id) || []) {
              if (!visibleEdge(edge) || edge.kind !== "phenomenon_group") continue;
              if (edge.source === l1Id && phenomenonGroupLevel(nodeById.get(edge.target)) === 2) {
                addSelectableNodeId(allowedIds, edge.target);
                l2Ids.add(edge.target);
              }
            }
          }
          for (const l2Id of l2Ids) {
            for (const edge of edgesByNode.get(l2Id) || []) {
              if (!visibleEdge(edge) || edge.kind !== "phenomenon_group") continue;
              if (edge.source === l2Id && phenomenonGroupLevel(nodeById.get(edge.target)) === 3) {
                addSelectableNodeId(allowedIds, edge.target);
              }
            }
          }
          return allowedIds;
        }
        if (selectedNode.kind === "environment" || selectedNode.kind === "participant_group" || selectedNode.kind === "intervention_unit") {
          for (const edge of edgesByNode.get(selectedNode.id) || []) {
            if (!visibleEdge(edge)) continue;
            if (
              edge.kind === "source_research_design" ||
              edge.kind === "intervention_unit_participant_group" ||
              edge.kind === "intervention_unit_environment" ||
              environmentCategoryKindSet.has(edge.kind) ||
              edge.kind === "participant_group_age_category"
            ) {
              addSelectableNodeId(allowedIds, edge.source === selectedNode.id ? edge.target : edge.source);
            }
          }
          return allowedIds;
        }
        if (isSourceResourceElement(selectedNode)) {
          for (const edge of edgesByNode.get(selectedNode.id) || []) {
            if (!visibleEdge(edge)) continue;
          if (isCitationEdge(edge)) {
            addSelectableNodeId(allowedIds, edge.source === selectedNode.id ? edge.target : edge.source);
          } else if (edge.kind === "source_phenomenon" && edge.source === selectedNode.id) {
            addSelectableNodeId(allowedIds, edge.target);
            addPhenomenonHierarchySelectable(allowedIds, edge.target);
            addViaSelectableTools(allowedIds, edge);
          } else if (edge.kind === "tool_source" && edge.source === selectedNode.id) {
            addSelectableNodeId(allowedIds, edge.target);
          } else if (edge.kind === "source_research_design" && edge.source === selectedNode.id) {
            addSelectableNodeId(allowedIds, edge.target);
          } else if (edge.kind === "source_research_insights" && edge.source === selectedNode.id) {
            addSelectableNodeId(allowedIds, edge.target);
            }
          }
          for (const relatedNode of nodesSharingSource(selectedNode, ["environment", "participant_group", "intervention_unit", "research_insights"])) {
            addSelectableNodeId(allowedIds, relatedNode.id);
          }
          return allowedIds;
        }
        if (isSpecificToolLikeNode(selectedNode)) {
          const linkedPhenomenonIds = new Set();
          for (const edge of edgesByNode.get(selectedNode.id) || []) {
            if (!visibleEdge(edge)) continue;
            if (edge.kind === "tool_source" && edge.target === selectedNode.id) {
              addSelectableNodeId(allowedIds, edge.source);
            } else if (edge.kind === "phenomenon_tool" && edge.source === selectedNode.id) {
              addSelectableNodeId(allowedIds, edge.target);
              linkedPhenomenonIds.add(edge.target);
            } else if (edge.kind === "source_phenomenon" && edgeViaNodeIds(edge).includes(selectedNode.id)) {
              addSelectableNodeId(allowedIds, edge.source);
              addSelectableNodeId(allowedIds, edge.target);
              linkedPhenomenonIds.add(edge.target);
            }
          }
          const l1Ids = new Set();
          const l2Ids = new Set();
          for (const phenomenonId of linkedPhenomenonIds) {
            for (const edge of edgesByNode.get(phenomenonId) || []) {
              if (!visibleEdge(edge) || edge.kind !== "phenomenon_group") continue;
              if (edge.source === phenomenonId && phenomenonGroupLevel(nodeById.get(edge.target)) === 1) {
                addSelectableNodeId(allowedIds, edge.target);
                l1Ids.add(edge.target);
              }
            }
          }
          for (const l1Id of l1Ids) {
            for (const edge of edgesByNode.get(l1Id) || []) {
              if (!visibleEdge(edge) || edge.kind !== "phenomenon_group") continue;
              if (edge.source === l1Id && phenomenonGroupLevel(nodeById.get(edge.target)) === 2) {
                addSelectableNodeId(allowedIds, edge.target);
                l2Ids.add(edge.target);
              }
            }
          }
          for (const l2Id of l2Ids) {
            for (const edge of edgesByNode.get(l2Id) || []) {
              if (!visibleEdge(edge) || edge.kind !== "phenomenon_group") continue;
              if (edge.source === l2Id && phenomenonGroupLevel(nodeById.get(edge.target)) === 3) {
                addSelectableNodeId(allowedIds, edge.target);
              }
            }
          }
        }
        return allowedIds;
      }

      function interactionAllowedNode(node) {
        if (!baseSelectableNode(node)) return false;
        if (state.activeModelPreset === "fok-s") return normalSelectableNode(node);
        const selectedNode = state.selectedId ? nodeById.get(state.selectedId) : null;
        if (isDeselectNode(node) && interactionBoolean("deselect_always_available", true)) {
          const activeRole = selectedNode ? nodeInteractionRole(selectedNode) : "normal";
          return permissionAllows(activeRole, "select", node)
            || interactionBoolean("deselect_always_available", true);
        }
        if (selectedNode && baseSelectableNode(selectedNode)) {
          if (node.id === selectedNode.id) return true;
          return selectionAllowedNodeIds(selectedNode).has(node.id) && permissionAllows(nodeInteractionRole(selectedNode), "select", node);
        }
        const hoveredNode = state.hoverId ? nodeById.get(state.hoverId) : null;
        const hoveredLevel = phenomenonGroupLevel(hoveredNode);
        if (hoveredNode && hoveredNode.kind === "phenomenon_group" && hoveredLevel >= 1 && hoveredLevel <= 5) {
          if (node.id === hoveredNode.id) return true;
          return selectionAllowedNodeIds(hoveredNode).has(node.id) && permissionAllows(nodeInteractionRole(hoveredNode), "hover", node);
        }
        return normalSelectableNode(node);
      }

      function hoverAllowedNode(node) {
        if (isDeselectNode(node) && interactionBoolean("deselect_always_available", true)) return true;
        if (isPublicMobileFokInteraction()) return normalSelectableNode(node);
        if (state.activeModelPreset === "fok-s") return normalSelectableNode(node);
        if (activeSelectionBlocksCandidate(node)) return false;
        const activeNode = state.selectedId ? nodeById.get(state.selectedId) : null;
        const activeRole = activeNode ? nodeInteractionRole(activeNode) : "normal";
        return baseSelectableNode(node) && permissionAllows(activeRole, "hover", node);
      }

      const defaultNormalSizeMatrix = {
        source: 0.1, resource: 0.1, tools: 0.1, p: 0.1, l0: 7.0, l1: 0.1, l2: 12.0, l3: 24.0, l4: 24.0, l5: 24.0, l9: 5.0,
        eag_category: 0.8, eag_concept: 0.65, eag_expression: 0.5, eag_construct: 0.65,
        environment: 0.1, participant_group: 0.1, urban_environ_category: 0.1, natural_environ_category: 0.1, age_category: 0.1,
        urban: 7.0, natural: 7.0, population: 7.0, intervention_unit: 0.1, research_design: 0.1, research_insights: 0.1, stem_bottom: 3.0,
      };
      let normalSizeMatrix = defaultNormalSizeMatrix;

      function publicMobileNodeSizeRow() {
        if (!isPublicMobileFokInteraction() || !state.selectedId) return null;
        const activeNode = nodeById.get(state.selectedId);
        const activeRole = selectionMatrixRole(nodeSizeRole(activeNode));
        return activeRole && selectionSizeMatrix && selectionSizeMatrix[activeRole]
          ? selectionSizeMatrix[activeRole]
          : null;
      }

      function nodeBaseStyleSize(node) {
        const baseSize = Math.max(0.001, Number(node && node.style && node.style.size) || 1);
        const role = selectionMatrixRole(nodeSizeRole(node));
        if (state.activeModelPreset === "fok" && role && Object.prototype.hasOwnProperty.call(normalSizeMatrix, role)) {
          const mobileSizeRow = publicMobileNodeSizeRow();
          if (mobileSizeRow && Object.prototype.hasOwnProperty.call(mobileSizeRow, role)) {
            const mobileMatrixSize = Number(mobileSizeRow[role]);
            if (Number.isFinite(mobileMatrixSize)) return mobileMatrixSize;
          }
          const matrixSize = Number(normalSizeMatrix[role]);
          return Number.isFinite(matrixSize) ? matrixSize : baseSize;
        }
        return baseSize;
      }

      function nodeSizeRole(node) {
        if (!node) return null;
        if (isIntegratedSourceNode(node)) return "source";
        if (isReferenceSourceNode(node)) return "resource";
        if (isEagSemanticNode(node)) return node.kind;
        if (isPhenomenonLikeNode(node)) return "phenomenon";
        if (isSpecificToolLikeNode(node)) return "specific_tool";
        if (node.kind === "environment") return "environment";
        if (node.kind === "participant_group") return "participant_group";
        if (isEnvironmentCategoryNode(node)) return node.kind;
        if (node.kind === "age_category") return "age_category";
        if (isContextClusterNode(node)) return node.kind;
        if (node.kind === "intervention_unit") return "intervention_unit";
        if (node.kind === "research_design") return "research_design";
        if (node.kind === "research_insights") return "research_insights";
        if (node.kind === "stem_bottom") return "stem_bottom";
        if (node.kind === "phenomenon_group") {
          const level = phenomenonGroupLevel(node);
          if (level === 0) return "l0";
          if (level === 1) return "l1";
          if (level === 2) return "l2";
          if (level === 3) return "l3";
          if (level === 4) return "l4";
          if (level === 5) return "l5";
          if (level === 9) return "l9";
        }
        return null;
      }

      function selectionMatrixRole(role) {
        if (role === "phenomenon") return "p";
        if (role === "specific_tool") return "tools";
        return role;
      }

      function nodeTitleDesign(node) {
        const role = selectionMatrixRole(nodeSizeRole(node));
        const values = role && nodeDesignSpecification
          ? nodeDesignSpecification[role]
          : null;
        return values && typeof values === "object" ? values : {};
      }

      const alphaMatrix = interactionStyle.alpha_matrix || {};
      const nodeBaseAlphaMatrix = alphaMatrix.node_base || {};
      const nodeStateAlphaMultipliers = alphaMatrix.node_state_multipliers || {};
      const nodeStateAlphaOverrides = alphaMatrix.node_state_overrides || {};
      const edgeBaseAlphaMatrix = alphaMatrix.edge_base || {};
      const edgeStateAlphaMultipliers = alphaMatrix.edge_state_multipliers || {};
      const edgeStateAlphaOverrides = alphaMatrix.edge_state_overrides || {};

      function matrixAlphaValue(row, key, fallback) {
        if (!row || !key) return fallback;
        const value = Number(row[key]);
        return Number.isFinite(value) ? clampAlpha(value) : fallback;
      }

      function nodeAlphaRole(node) {
        return selectionMatrixRole(nodeSizeRole(node));
      }

      function nodeBaseAlpha(node, fallback = 1) {
        return matrixAlphaValue(nodeBaseAlphaMatrix, nodeAlphaRole(node), fallback);
      }

      function nodeAlphaMultiplier(node, stateName, fallback = 1) {
        return matrixAlphaValue(nodeStateAlphaMultipliers[stateName], nodeAlphaRole(node), fallback);
      }

      function nodeAlphaOverride(node, stateName, fallback = null) {
        const value = matrixAlphaValue(nodeStateAlphaOverrides[stateName], nodeAlphaRole(node), NaN);
        return Number.isFinite(value) ? value : fallback;
      }

      function edgeAlphaKey(edge) {
        if (!edge) return "";
        if (isCitationEdge(edge)) {
          return edge.meta && edge.meta.grounded_pair === true ? "citation_grounded" : "citation_reference";
        }
        return edge.kind || "";
      }

      function edgeAlphaRowValue(rowsByState, edge, stateName, fallback) {
        const row = rowsByState && rowsByState[stateName];
        if (!row || !edge) return fallback;
        const keyed = Number(row[edgeAlphaKey(edge)]);
        if (Number.isFinite(keyed)) return clampAlpha(keyed);
        const byKind = Number(row[edge.kind]);
        return Number.isFinite(byKind) ? clampAlpha(byKind) : fallback;
      }

      function edgeBaseAlpha(edge) {
        const key = edgeAlphaKey(edge);
        const alpha255 = Number(edgeBaseAlphaMatrix[key]);
        if (Number.isFinite(alpha255)) return clampAlpha(alpha255 / 255);
        const styleAlpha = Number(edge && edge.style ? edge.style.alpha : NaN);
        return Number.isFinite(styleAlpha) ? clampAlpha(styleAlpha / 255) : 80 / 255;
      }

      function edgeAlphaMultiplier(edge, stateName, fallback = 1) {
        return edgeAlphaRowValue(edgeStateAlphaMultipliers, edge, stateName, fallback);
      }

      function edgeAlphaOverride(edge, stateName, fallback = 1) {
        return edgeAlphaRowValue(edgeStateAlphaOverrides, edge, stateName, fallback);
      }

      const defaultSelectionSizeMatrix = {
        source: { ...defaultNormalSizeMatrix, source: 3.0, resource: 0.5, tools: 3.0, p: 3.0, l1: 5.0, l2: 5.0, l3: 7.0, environment: 3.0, participant_group: 3.0, urban_environ_category: 0.5, natural_environ_category: 0.5, age_category: 0.5, urban: 7.0, natural: 7.0, population: 7.0, intervention_unit: 3.0 },
        resource: { ...defaultNormalSizeMatrix, source: 3.0, resource: 1.0, tools: 0.5, p: 0.5, l1: 0.5, l2: 5.0, l3: 7.0 },
        tools: { ...defaultNormalSizeMatrix, source: 3.0, resource: 0.5, tools: 5.0, p: 3.0, l1: 5.0, l2: 5.0, l3: 7.0 },
        p: { ...defaultNormalSizeMatrix, source: 3.0, resource: 0.5, tools: 5.0, p: 10.0, l1: 7.0, l2: 5.0, l3: 7.0 },
        l0: { ...defaultNormalSizeMatrix, l0: 7.0 },
        l1: { ...defaultNormalSizeMatrix, source: 0.5, resource: 0.5, tools: 0.5, p: 7.0, l1: 10.0, l2: 5.0, l3: 7.0 },
        l2: { ...defaultNormalSizeMatrix, source: 0.5, resource: 0.5, tools: 0.5, p: 1.5, l1: 7.0, l2: 5.0, l3: 5.0 },
        l3: { ...defaultNormalSizeMatrix, source: 0.5, resource: 0.5, tools: 0.5, p: 0.5, l1: 0.5, l2: 10.0, l3: 7.0, urban_environ_category: 5.0, natural_environ_category: 5.0, age_category: 5.0, urban: 7.0, natural: 7.0, population: 7.0 },
        l4: { ...defaultNormalSizeMatrix, l4: 7.0, urban: 7.0, natural: 7.0, population: 7.0 },
        l5: { ...defaultNormalSizeMatrix, l5: 7.0, eag_category: 5.0, eag_concept: 5.0, eag_expression: 5.0, eag_construct: 5.0 },
        l9: { ...defaultNormalSizeMatrix, l9: 5.0 },
        environment: { ...defaultNormalSizeMatrix, source: 3.0, resource: 0.5, environment: 3.0, urban_environ_category: 5.0, natural_environ_category: 5.0, urban: 7.0, natural: 7.0, population: 7.0, intervention_unit: 3.0 },
        participant_group: { ...defaultNormalSizeMatrix, source: 3.0, resource: 0.5, participant_group: 3.0, age_category: 5.0, population: 7.0, intervention_unit: 3.0 },
        urban_environ_category: { ...defaultNormalSizeMatrix, source: 0.5, resource: 0.5, l3: 7.0, environment: 3.0, urban_environ_category: 5.0, urban: 7.0, intervention_unit: 0.5 },
        natural_environ_category: { ...defaultNormalSizeMatrix, source: 0.5, resource: 0.5, l3: 7.0, environment: 3.0, natural_environ_category: 5.0, natural: 7.0, intervention_unit: 0.5 },
        age_category: { ...defaultNormalSizeMatrix, source: 0.5, resource: 0.5, l3: 7.0, participant_group: 3.0, age_category: 5.0, population: 7.0, intervention_unit: 0.5 },
        urban: { ...defaultNormalSizeMatrix, l3: 7.0, environment: 3.0, urban_environ_category: 5.0, urban: 7.0 },
        natural: { ...defaultNormalSizeMatrix, l3: 7.0, environment: 3.0, natural_environ_category: 5.0, natural: 7.0 },
        population: { ...defaultNormalSizeMatrix, l3: 7.0, participant_group: 3.0, age_category: 5.0, population: 7.0 },
        intervention_unit: { ...defaultNormalSizeMatrix, source: 3.0, resource: 0.5, environment: 3.0, participant_group: 3.0, urban_environ_category: 5.0, natural_environ_category: 5.0, age_category: 5.0, urban: 7.0, natural: 7.0, population: 7.0, intervention_unit: 3.0 },
        stem_bottom: { ...defaultNormalSizeMatrix, stem_bottom: 3.0 },
      };
      let hoverSizeMatrix = defaultSelectionSizeMatrix;
      let selectionSizeMatrix = defaultSelectionSizeMatrix;
      let interactionPermissions = {};
      let interactionExposureProfiles = {};
      let interactionEdgeKindWidths = {};

      function nodeInteractionRole(node) {
        return selectionMatrixRole(nodeSizeRole(node));
      }

      function isDeselectNode(node) {
        if (!node || state.activeModelPreset !== "fok") return false;
        return nodeInteractionRole(node) === interactionString("deselect_trigger_role", "l9");
      }

      function interactionPermissionSurface() {
        if (publicRedactedScene()) return "public";
        return "private";
      }

      function interactionPermissionRow(activeRole) {
        const surface = interactionPermissionSurface();
        if (interactionPermissions && interactionPermissions[surface] && interactionPermissions[surface][activeRole]) {
          return interactionPermissions[surface][activeRole];
        }
        if (interactionPermissions && interactionPermissions.private && interactionPermissions.private[activeRole]) {
          return interactionPermissions.private[activeRole];
        }
        if (interactionPermissions && interactionPermissions[activeRole]) {
          return interactionPermissions[activeRole];
        }
        return null;
      }

      function permissionAllows(activeRole, action, node) {
        const targetRole = nodeInteractionRole(node);
        if (!targetRole) return false;
        const row = interactionPermissionRow(activeRole);
        const allowed = row && Array.isArray(row[action]) ? row[action] : null;
        if (!allowed) return false;
        return allowed.includes("*") || allowed.includes(targetRole);
      }

      function drawNode(node, projected, hoveredNode, hoverScope) {
        const aboveHan = state.activeModelPreset === "fok"
          && Number.isFinite(Number(node.z))
          && Number(node.z) > hereAndNowZ + 0.001;
      const sizeScale = 1;
      const roleForNormalDisplay = selectionMatrixRole(nodeSizeRole(node));
      const size = state.activeModelPreset === "fok" && roleForNormalDisplay
        ? nodeBaseStyleSize(node)
        : nodeDisplaySize(node, sizeScale);
        const stroke = aboveHan && !isDeselectNode(node)
          ? "#ffffff"
          : (node.style.stroke || "#ffffff");
        const fill = node.style.fill || "#ffffff";
        const configuredFillAlpha = Number(node.style.fill_alpha);
        const fillAlpha = isSourceResourceElement(node) && !node.meta.has_source_md
            ? interactionNumber("unintegrated_source_fill_alpha", 0.7)
            : (Number.isFinite(configuredFillAlpha) ? configuredFillAlpha : nodeBaseAlpha(node, 1));
        const configuredStrokeWidth = Number(node.style.stroke_width);
        const baseLineWidth = Number.isFinite(configuredStrokeWidth) ? configuredStrokeWidth : 2;
        const outerStroke = node.style.outer_stroke;
      const outerGap = (node.style.outer_gap || 2.2) * 1;
        const outerLineWidth = node.style.outer_stroke_width || 1;
        const isHovered = hoveredNode && hoveredNode.id === node.id;
        const isSelected = state.selectedId === node.id;
        const dimmed = hoverScope && !hoverScope.nodeIds.has(node.id);
        const selectionLikeHovered = isHovered && hoverScope && hoverScope.selectionLikeHover && hoverScope.activeNodeId === node.id;
        const highlighted = hoverScope && hoverScope.highlightNodeIds && hoverScope.highlightNodeIds.has(node.id);
        const normalSourceReferenceDimmed = !hoverScope && normalSourceReferenceDimActive() && isReferenceSourceNode(node);
        const defaultClarifyScale = defaultClarifyScaleForNode(node);
        const normalDimScaleFactor = normalSourceReferenceDimmed ? normalSourceReferenceScale() : 1;
        const dimScaleFactor = dimmed ? inactiveHoverSelectionScale() : 1;
        const hoverHighlightFactor = !dimmed && highlighted ? interactionNumber("hover_highlight_factor", 1.5) : 1;
        const hoverSizeFactor = !dimmed && hoverScope ? interactionNumber("hover_size_factor", 0.7) : 1;
        const interactionScale = defaultClarifyScale * normalDimScaleFactor * dimScaleFactor * hoverHighlightFactor * hoverSizeFactor;
        let alphaMultiplier = nodeAlphaMultiplier(node, "normal", 1);
        if (normalSourceReferenceDimmed) alphaMultiplier *= nodeAlphaMultiplier(node, "normal_source_reference", 1);
        if (dimmed) alphaMultiplier *= nodeAlphaMultiplier(node, "dim", 1);
        if (!dimmed && hoverScope) alphaMultiplier *= nodeAlphaMultiplier(node, "hover_scope", 1);
        if (!dimmed && highlighted) alphaMultiplier *= nodeAlphaMultiplier(node, "highlighted", 1);
        if (isSelected || selectionLikeHovered) alphaMultiplier *= nodeAlphaMultiplier(node, "selected", 1);
        if (state.activeModelPreset === "fok-s" && defaultClarifyScale !== 1) alphaMultiplier *= nodeAlphaMultiplier(node, "fok_s_clarify", 1);
        const hasScopedNodeSize = !dimmed
          && hoverScope
          && hoverScope.nodeSizeScaleById
          && hoverScope.nodeSizeScaleById.has(node.id);
        const scopedNodeSizeScale = hasScopedNodeSize
          ? (hoverScope.nodeSizeScaleById.get(node.id) || 1)
          : 1;
        // Scope size entries encode absolute target sizes as targetSize / nodeBaseStyleSize(node).
        // Draw them back as absolute values so hover/selection matrices are not multiplied by legacy node.style.size.
        const scopedAbsoluteSize = hasScopedNodeSize
          ? nodeBaseStyleSize(node) * scopedNodeSizeScale
          : null;
        const displaySize = Number.isFinite(scopedAbsoluteSize)
          ? scopedAbsoluteSize
          : size * interactionScale;
        const displayOuterGap = outerGap * (Number.isFinite(scopedAbsoluteSize) ? 1 : interactionScale);
        const scopedNodeAlpha = !dimmed && hoverScope && hoverScope.nodeAlphaById
          ? hoverScope.nodeAlphaById.get(node.id)
          : null;
        const effectiveStrokeAlpha = Number.isFinite(scopedNodeAlpha) ? scopedNodeAlpha : alphaMultiplier;
        const effectiveFillAlpha = Number.isFinite(scopedNodeAlpha) ? scopedNodeAlpha : fillAlpha * alphaMultiplier;

        if (isHovered && !dimmed && !selectionLikeHovered) {
          ctx.beginPath();
          ctx.arc(projected.x, projected.y, displaySize + interactionNumber("hover_halo_extra_radius", 8), 0, Math.PI * 2);
          ctx.fillStyle = interactionString("hover_halo_fill", "rgba(232, 194, 115, 0.18)");
          ctx.fill();
        }

        if (isSelected || selectionLikeHovered) {
          ctx.beginPath();
          ctx.arc(projected.x, projected.y, displaySize + interactionNumber("selected_halo_extra_radius", 12), 0, Math.PI * 2);
          ctx.fillStyle = interactionString("selected_halo_fill", "rgba(255, 255, 255, 0.24)");
          ctx.fill();
        }

        if (outerStroke) {
          ctx.save();
          ctx.beginPath();
          ctx.arc(projected.x, projected.y, displaySize + displayOuterGap, 0, Math.PI * 2);
          ctx.strokeStyle = hexToRgba(outerStroke, interactionNumber("outer_ring_alpha", 0.95));
          ctx.lineWidth = Math.max(0.5, outerLineWidth * interactionScale);
          ctx.stroke();
          ctx.restore();
        }

        ctx.save();
        ctx.strokeStyle = hexToRgba(stroke, effectiveStrokeAlpha);
        ctx.fillStyle = hexToRgba(
          fill,
          effectiveFillAlpha,
        );
        ctx.lineWidth = dimmed
          ? (baseLineWidth <= 0 ? 0 : Math.max(0.5, baseLineWidth * interactionScale))
          : isHovered
          ? (baseLineWidth + interactionNumber("hover_stroke_width_add", 1))
          : baseLineWidth;

        if (node.style.symbol === "triangle") {
          ctx.beginPath();
          ctx.moveTo(projected.x, projected.y - displaySize);
          ctx.lineTo(projected.x - displaySize * 0.86, projected.y + displaySize * 0.66);
          ctx.lineTo(projected.x + displaySize * 0.86, projected.y + displaySize * 0.66);
          ctx.closePath();
          ctx.fill();
          if (ctx.lineWidth > 0) ctx.stroke();
        } else if (node.style.symbol === "diamond") {
          ctx.beginPath();
          ctx.moveTo(projected.x, projected.y - displaySize);
          ctx.lineTo(projected.x + displaySize, projected.y);
          ctx.lineTo(projected.x, projected.y + displaySize);
          ctx.lineTo(projected.x - displaySize, projected.y);
          ctx.closePath();
          ctx.fill();
          if (ctx.lineWidth > 0) ctx.stroke();
        } else if (node.style.symbol === "square") {
          ctx.beginPath();
          ctx.rect(projected.x - displaySize, projected.y - displaySize, displaySize * 2, displaySize * 2);
          ctx.fill();
          if (ctx.lineWidth > 0) ctx.stroke();
        } else {
          ctx.beginPath();
          ctx.arc(projected.x, projected.y, displaySize, 0, Math.PI * 2);
          ctx.fill();
          if (ctx.lineWidth > 0) ctx.stroke();
        }
        ctx.restore();

        if (!dimmed && shouldLabelNode(node, hoveredNode, hoverScope)) {
          const titleDesign = nodeTitleDesign(node);
          const configuredFontSize = Number(titleDesign.title_font_size);
          const labelFontSize = Number.isFinite(configuredFontSize) && configuredFontSize > 0
            ? configuredFontSize
            : interactionNumber("node_label_font_size", 14.85) * 0.81;
          const labelWeight = hoverScope && hoverScope.normalLabelNodeIds && hoverScope.normalLabelNodeIds.has(node.id) ? 400 : 700;
          const boldLabel = labelWeight >= 700;
          ctx.font = `${labelWeight} ${labelFontSize}px Avenir Next, Segoe UI, sans-serif`;
          const label = node.short_label;
          const labelX = projected.x + displaySize + interactionNumber("node_label_margin", 4);
          const labelY = projected.y;
          ctx.save();
          ctx.textAlign = "left";
          ctx.textBaseline = "middle";
          ctx.lineJoin = "round";
          ctx.lineWidth = boldLabel
            ? interactionNumber("node_label_bold_stroke_width", 1)
            : interactionNumber("node_label_stroke_width", 2);
          ctx.strokeStyle = boldLabel
            ? interactionString("node_label_bold_stroke", "#2B145A")
            : interactionString("node_label_stroke", "rgba(0, 0, 0, 0.82)");
          ctx.strokeText(label, labelX, labelY);
          ctx.fillStyle = String(
            titleDesign.title_font_color
            || interactionString("node_label_fill", "rgba(238, 240, 255, 0.92)")
          );
          ctx.fillText(label, labelX, labelY);
          ctx.restore();
        }
      }

      function relatedNodes(node, allowedKinds, allowedEdgeKinds) {
        const neighbors = [];
        const relatedEdges = edgesByNode.get(node.id) || [];
        for (const edge of relatedEdges) {
          if (!edgeKindAllowed(allowedEdgeKinds, edge)) continue;
          const otherId = edge.source === node.id ? edge.target : edge.source;
          const otherNode = nodeById.get(otherId);
          if (!otherNode) continue;
          if (allowedKinds && !allowedKinds.includes(otherNode.kind)) continue;
          neighbors.push(otherNode);
        }
        return neighbors;
      }

      function sourceLinkKeys(node) {
        const keys = new Set();
        if (!node) return keys;
        const meta = node.meta || {};
        for (const value of [meta.source_id, meta.source_unique_id]) {
          const key = String(value || "").trim();
          if (key) keys.add(key);
        }
        if (isSourceResourceElement(node)) {
          for (const value of [node.id, node.unique_id, meta.source_id, meta.source_unique_id]) {
            const key = String(value || "").trim();
            if (key) keys.add(key);
          }
        }
        return keys;
      }

      function nodesSharingSource(node, allowedKinds) {
        const sourceKeys = sourceLinkKeys(node);
        if (!sourceKeys.size) return [];
        const allowedKindSet = new Set(allowedKinds || []);
        return nodes.filter((candidate) => {
          if (!candidate || candidate.id === node.id) return false;
          if (allowedKindSet.size && !allowedKindSet.has(candidate.kind)) return false;
          for (const key of sourceLinkKeys(candidate)) {
            if (sourceKeys.has(key)) return true;
          }
          return false;
        });
      }

      function uniqueSortedLabels(nodeList) {
        const labelsById = new Map();
        for (const node of nodeList) {
          if (!node || labelsById.has(node.id)) continue;
          labelsById.set(node.id, node.label || node.short_label || node.id);
        }
        return [...labelsById.values()].sort((left, right) => left.localeCompare(right));
      }

      function uniqueNodes(nodeList) {
        const nodesById = new Map();
        for (const node of nodeList) {
          if (!node || !node.id || nodesById.has(node.id)) continue;
          nodesById.set(node.id, node);
        }
        return [...nodesById.values()];
      }

      function toolsLinkedToGroup(node) {
        const directTools = relatedNodes(node, ["tool", "specific_tool", "specific_tool_group"], ["tool_group"]);
        const childGroups = relatedNodes(node, ["phenomenon_group"], ["phenomenon_group"]);
        const childTools = childGroups.flatMap((group) => relatedNodes(group, ["tool", "specific_tool", "specific_tool_group"], ["tool_group"]));
        return uniqueNodes([...directTools, ...childTools]);
      }

      function phenomenaLinkedToGroup(node) {
        const directPhenomena = relatedNodes(node, ["phenomenon"], ["phenomenon_group"]);
        const childGroups = relatedNodes(node, ["phenomenon_group"], ["phenomenon_group"]);
        const childPhenomena = childGroups.flatMap((group) =>
          relatedNodes(group, ["phenomenon"], ["phenomenon_group"])
        );
        return uniqueNodes([...directPhenomena, ...childPhenomena]);
      }

      function phenomenaLinkedThroughSources(node) {
        return uniqueNodes(
          relatedNodes(node, ["source"], ["tool_source"]).flatMap((sourceNode) =>
            relatedNodes(sourceNode, phenomenonLikeNodeKinds, ["source_phenomenon"])
          )
        );
      }

      function sourcesLinkedThroughTools(node) {
        return uniqueNodes(
          toolsLinkedToGroup(node).flatMap((tool) => relatedNodes(tool, ["source"], ["tool_source"]))
        );
      }

      function connectedPhenomena(node) {
        if (isPhenomenonLikeNode(node)) return [node];
        if (node.kind === "phenomenon_group") return phenomenaLinkedToGroup(node);
        if (isSpecificToolLikeNode(node)) return relatedNodes(node, ["phenomenon"], ["phenomenon_tool"]);
        if (node.kind === "source") return relatedNodes(node, phenomenonLikeNodeKinds, ["source_phenomenon"]);
        return [];
      }

      function connectedSourceNodes(node) {
        if (isEagSemanticNode(node)) return eagSourceNodes(node);
        if (isPhenomenonLikeNode(node)) return relatedNodes(node, ["source"], ["source_phenomenon"]);
        if (node.kind === "phenomenon_group") {
          const phenomenonSources = phenomenaLinkedToGroup(node).flatMap((phenomenonNode) =>
            relatedNodes(phenomenonNode, ["source"], ["source_phenomenon"])
          );
          return uniqueNodes([...phenomenonSources, ...sourcesLinkedThroughTools(node)]);
        }
        if (isSpecificToolLikeNode(node)) return relatedNodes(node, ["source"], ["tool_source"]);
        if (isSourceResourceElement(node)) {
          return relatedNodes(node, sourceResourceNodeKinds, citationEdgeKinds);
        }
        return [];
      }

      function eagResearchInsightNodes(node) {
        if (!isEagSemanticNode(node)) return [];
        return uniqueNodes(
          relatedNodes(node, ["research_insights"], researchInsightEagEdgeKinds)
        );
      }

      function eagSourceNodes(node) {
        return uniqueNodes(
          eagResearchInsightNodes(node).flatMap((insight) => nodesSharingSource(insight, ["source"]))
        );
      }

      function eagRelatedTools(node) {
        return uniqueNodes(
          eagSourceNodes(node).flatMap((sourceNode) =>
            relatedNodes(sourceNode, ["tool", "specific_tool", "specific_tool_group"], ["tool_source"])
          )
        );
      }

      function eagRelatedPhenomena(node) {
        const sourceNodes = eagSourceNodes(node);
        const tools = eagRelatedTools(node);
        return uniqueNodes([
          ...sourceNodes.flatMap((sourceNode) =>
            relatedNodes(sourceNode, ["phenomenon"], ["source_phenomenon"])
          ),
          ...tools.flatMap((toolNode) =>
            relatedNodes(toolNode, ["phenomenon"], ["phenomenon_tool"])
          ),
        ]);
      }

      function eagDirectSemanticNodes(node, kind) {
        const nodesById = new Map();
        for (const edge of edgesByNode.get(node.id) || []) {
          if (!eagRelationEdgeKinds.includes(edge.kind)) continue;
          const candidateId = edge.source === node.id ? edge.target : edge.source;
          const candidate = nodeById.get(candidateId);
          if (!candidate || candidate.id === node.id || candidate.kind !== kind) continue;
          nodesById.set(candidate.id, candidate);
        }
        return [...nodesById.values()].sort((left, right) =>
          navigatorNodeLabel(left).localeCompare(
            navigatorNodeLabel(right),
            undefined,
            { sensitivity: "base" }
          )
        );
      }

      function alphabetizedNodes(nodeList) {
        return uniqueNodes(nodeList).sort((left, right) =>
          navigatorNodeLabel(left).localeCompare(
            navigatorNodeLabel(right),
            undefined,
            { sensitivity: "base" }
          )
        );
      }

      function contextClusterCategoryNodes(node) {
        if (!node) return [];
        if (node.kind === "urban") {
          return alphabetizedNodes(
            relatedNodes(node, ["urban_environ_category"], ["urban"])
          );
        }
        if (node.kind === "natural") {
          return alphabetizedNodes(
            relatedNodes(node, ["natural_environ_category"], ["natural"])
          );
        }
        if (node.kind === "population") {
          return alphabetizedNodes(
            relatedNodes(node, ["age_category"], ["population"])
          );
        }
        return [];
      }

      function categoryMemberNodes(node) {
        if (!node) return [];
        if (node.kind === "urban_environ_category") {
          return alphabetizedNodes(
            relatedNodes(node, ["environment"], ["urban_environ_category"])
          );
        }
        if (node.kind === "natural_environ_category") {
          return alphabetizedNodes(
            relatedNodes(node, ["environment"], ["natural_environ_category"])
          );
        }
        if (node.kind === "age_category") {
          return alphabetizedNodes(
            relatedNodes(
              node,
              ["participant_group"],
              ["participant_group_age_category"]
            )
          );
        }
        return [];
      }

      function linkedSourcesForContextElements(elements) {
        return alphabetizedNodes(
          elements.flatMap((element) =>
            nodesSharingSource(element, ["source"])
          )
        );
      }

      function linkedSourcesForContextCluster(node) {
        const members = contextClusterCategoryNodes(node).flatMap(
          (category) => categoryMemberNodes(category)
        );
        return linkedSourcesForContextElements(members);
      }

      function linkedInterventionUnitsForContextElement(node) {
        if (!node) return [];
        if (node.kind === "environment") {
          return alphabetizedNodes(
            relatedNodes(
              node,
              ["intervention_unit"],
              ["intervention_unit_environment"]
            )
          );
        }
        if (node.kind === "participant_group") {
          return alphabetizedNodes(
            relatedNodes(
              node,
              ["intervention_unit"],
              ["intervention_unit_participant_group"]
            )
          );
        }
        return [];
      }

      function linkedSourceInsightsForContextElement(node) {
        return alphabetizedNodes(
          nodesSharingSource(node, ["research_insights"])
        );
      }

      function interventionUnitContext(node) {
        if (!node || node.kind !== "intervention_unit") {
          return {
            participantGroups: [],
            environments: [],
            tools: [],
            researchInsights: [],
            sources: [],
          };
        }
        const participantGroups = alphabetizedNodes(
          relatedNodes(
            node,
            ["participant_group"],
            ["intervention_unit_participant_group"]
          )
        );
        const environments = alphabetizedNodes(
          relatedNodes(
            node,
            ["environment"],
            ["intervention_unit_environment"]
          )
        );
        const sources = alphabetizedNodes(
          nodesSharingSource(node, ["source"])
        );
        const researchDesigns = alphabetizedNodes([
          ...nodesSharingSource(node, ["research_design"]),
          ...relatedNodes(
            node,
            ["research_design"],
            ["source_research_design"]
          ),
        ]);
        const tools = alphabetizedNodes([
          ...sources.flatMap((sourceNode) =>
            relatedNodes(
              sourceNode,
              ["tool", "specific_tool", "specific_tool_group"],
              ["tool_source"]
            )
          ),
          ...researchDesigns.flatMap((designNode) =>
            relatedNodes(
              designNode,
              ["tool", "specific_tool", "specific_tool_group"],
              ["tool_research_design"]
            )
          ),
        ]);
        return {
          participantGroups,
          environments,
          tools,
          researchInsights: alphabetizedNodes(
            nodesSharingSource(node, ["research_insights"])
          ),
          sources,
        };
      }

      function researchInsightContext(node) {
        const sharedSourceNodes = nodesSharingSource(node, [
          "source",
          "research_design",
          "participant_group",
          "environment",
          "intervention_unit",
        ]);
        const sourceNodes = alphabetizedNodes(
          sharedSourceNodes.filter((candidate) => candidate.kind === "source")
        );
        const configuredDesign = nodeById.get(String((node.meta || {}).research_design_id || ""));
        const researchDesigns = alphabetizedNodes([
          ...sharedSourceNodes.filter((candidate) => candidate.kind === "research_design"),
          ...(configuredDesign && configuredDesign.kind === "research_design"
            ? [configuredDesign]
            : []),
        ]);
        const participantGroups = sharedSourceNodes.filter(
          (candidate) => candidate.kind === "participant_group"
        );
        const environments = sharedSourceNodes.filter(
          (candidate) => candidate.kind === "environment"
        );
        const interventionUnits = sharedSourceNodes.filter(
          (candidate) => candidate.kind === "intervention_unit"
        );
        const phenomena = [];
        const plannedPhenomena = [];
        const tools = [];
        const usedTools = [];
        const plannedTools = [];
        const populations = [...participantGroups];
        const resolvedEnvironments = [...environments];
        for (const sourceNode of sourceNodes) {
          for (const edge of edgesByNode.get(sourceNode.id) || []) {
            const otherId = edge.source === sourceNode.id ? edge.target : edge.source;
            const candidate = nodeById.get(otherId);
            if (!candidate) continue;
            if (edge.kind === "source_phenomenon" && candidate.kind === "phenomenon") {
              phenomena.push(candidate);
              if ((edge.meta || {}).source_relation === "planned_only") {
                plannedPhenomena.push(candidate);
              }
            } else if (
              edge.kind === "tool_source" &&
              ["tool", "specific_tool", "specific_tool_group"].includes(candidate.kind)
            ) {
              tools.push(candidate);
              if ((edge.meta || {}).source_tool_relation === "planned_only") {
                plannedTools.push(candidate);
              } else {
                usedTools.push(candidate);
              }
            }
          }
          populations.push(
            ...relatedNodes(
              sourceNode,
              ["age_category"],
              ["conceptual_populations"]
            )
          );
          resolvedEnvironments.push(
            ...relatedNodes(
              sourceNode,
              environmentCategoryKinds,
              ["conceptual_environments"]
            )
          );
        }
        const semanticEdges = (edgesByNode.get(node.id) || []).filter((edge) =>
          ["research_insight_eag_category", "research_insight_eag_construct"].includes(edge.kind)
        );
        return {
          researchInsight: node,
          sourceNodes,
          researchDesigns,
          phenomena: alphabetizedNodes(phenomena),
          tools: alphabetizedNodes(tools),
          usedTools: alphabetizedNodes(usedTools),
          plannedTools: alphabetizedNodes(plannedTools),
          plannedPhenomena: alphabetizedNodes(plannedPhenomena),
          populations: alphabetizedNodes(populations),
          environments: alphabetizedNodes(resolvedEnvironments),
          interventionUnits: alphabetizedNodes(interventionUnits),
          categories: alphabetizedNodes(
            relatedNodes(
              node,
              ["eag_category"],
              ["research_insight_eag_category"]
            )
          ),
          constructs: alphabetizedNodes(
            relatedNodes(
              node,
              ["eag_construct"],
              ["research_insight_eag_construct"]
            )
          ),
          semanticEdges,
        };
      }

      function conciseNodeList(nodeList, maximum = 3) {
        const labels = alphabetizedNodes(nodeList).map((candidate) =>
          navigatorNodeLabel(candidate)
        );
        const visible = labels.slice(0, maximum);
        const hiddenCount = Math.max(0, labels.length - visible.length);
        if (hiddenCount) visible.push(`${hiddenCount} more`);
        if (visible.length <= 1) return visible[0] || "";
        if (visible.length === 2) return `${visible[0]} and ${visible[1]}`;
        return `${visible.slice(0, -1).join(", ")}, and ${visible[visible.length - 1]}`;
      }

      function humanizedMetadataValue(value) {
        return sentenceTitle(
          String(value || "")
            .trim()
            .replace(/[_-]+/g, " ")
            .replace(/\s+/g, " ")
        );
      }

      function researchProfileLabel(value) {
        const labels = {
          "single-pole": "One analytical pole",
          "double-pole": "Two analytical poles",
          "triple-pole": "Three analytical poles",
          unclear: "Analytical profile not yet resolved",
        };
        const normalized = String(value || "").trim().toLowerCase();
        return labels[normalized] || humanizedMetadataValue(value) || "Not available.";
      }

      function researchInsightRouteLabel(meta) {
        if (meta.research_path_terminal_mode === "intervention_unit") {
          return "Source → research design → intervention unit(s) → research insight";
        }
        return "Source → research design → research insight";
      }

      function researchInsightContributionSummary(node, context) {
        const materializedSummary = String(
          ((node || {}).meta || {}).research_insight_summary || ""
        ).trim();
        if (materializedSummary) return materializedSummary;
        const sourceId = String(
          ((node || {}).meta || {}).source_unique_id || ""
        ).trim();
        if (sourceId && !sourceId.startsWith("EAG-")) {
          return (
            "A content-based research insight summary has not yet been published " +
            "for this source. Its source description is being checked against the " +
            "local Markdown before a non-extractive 150–300-word synthesis is added."
          );
        }
        const sentences = [];
        const constructLabels = conciseNodeList(context.constructs);
        const categoryLabels = conciseNodeList(context.categories);
        const phenomenonLabels = conciseNodeList(context.phenomena);
        if (constructLabels) {
          const constructNoun = context.constructs.length === 1
            ? "the construct"
            : "the constructs";
          sentences.push(
            `This source contributes to the model through ${constructNoun} ${constructLabels}.`
          );
        } else if (phenomenonLabels) {
          sentences.push(
            `This source contributes analyzed findings concerning ${phenomenonLabels}.`
          );
        } else {
          sentences.push(
            "This research insight records the analyzed contribution of the linked source."
          );
        }
        if (categoryLabels) {
          const categoryNoun = context.categories.length === 1
            ? "the category"
            : "the categories";
          sentences.push(
            `Within the EAG semantic layer, the contribution is situated in ${categoryNoun} ${categoryLabels}.`
          );
        }
        return sentences.join(" ");
      }

      function researchInsightAnalysisBasis(context) {
        const insightMeta = context && context.researchInsight
          ? (context.researchInsight.meta || {})
          : {};
        const categoryEdgeCount = context.semanticEdges.filter(
          (edge) => edge.kind === "research_insight_eag_category"
        ).length;
        const constructEdgeCount = context.semanticEdges.filter(
          (edge) => edge.kind === "research_insight_eag_construct"
        ).length;
        const statements = [];
        if (insightMeta.research_insight_summary) {
          const strength = humanizedMetadataValue(
            insightMeta.research_insight_evidence_strength
          ).toLowerCase();
          const evidenceSections = Array.isArray(
            insightMeta.research_insight_evidence_sections
          )
            ? insightMeta.research_insight_evidence_sections
                .map(humanizedMetadataValue)
                .join(", ")
            : "";
          statements.push(
            `The content summary is an editorial, non-extractive synthesis` +
            `${strength ? ` with ${strength} evidence support` : ""}` +
            `${evidenceSections ? `, grounded in ${evidenceSections}` : ""}.`
          );
          statements.push(
            "No direct quotation from the original abstract, contents, introduction, or conclusion is used."
          );
        } else if (
          String(insightMeta.source_unique_id || "").trim() &&
          !String(insightMeta.source_unique_id || "").startsWith("EAG-")
        ) {
          statements.push(
            "The non-EAG source description is pending editorial verification against its local Markdown before a content summary is materialized."
          );
        }
        if (categoryEdgeCount) {
          statements.push(
            "Category links come from a focused match between the source description and the analyzed source evidence."
          );
        }
        if (constructEdgeCount) {
          statements.push(
            "Construct links preserve the explicit source connections inherited from the merged concept and expression records."
          );
        }
        if (!statements.length) {
          statements.push(
            "No direct EAG Category or Construct connection is currently recorded for this research insight."
          );
        }
        statements.push(
          "No separate confidence score is currently assigned at the research-insight level; this block therefore reports provenance without inventing a rating."
        );
        return statements.join(" ");
      }

      function eagPhenomenaByDimensionHtml(node) {
        const groups = { eco: [], psycho: [], somatic: [] };
        for (const phenomenonNode of eagRelatedPhenomena(node)) {
          const pole = String((phenomenonNode.meta || {}).primary_pole || "").toUpperCase();
          if (pole === "ECO") groups.eco.push(phenomenonNode);
          else if (pole === "PSYCHO") groups.psycho.push(phenomenonNode);
          else if (pole === "SOMATIC") groups.somatic.push(phenomenonNode);
        }
        const total = groups.eco.length + groups.psycho.length + groups.somatic.length;
        return `
          <div class="feps3d-shopify__info-block">
            <div class="feps3d-shopify__info-kicker">P BY DIMENSION</div>
            ${total
              ? `
                ${phenomenonGroupHtml("ECO", "eco", groups.eco)}
                ${phenomenonGroupHtml("PSYCHO", "psycho", groups.psycho)}
                ${phenomenonGroupHtml("SOMATIC", "somatic", groups.somatic)}
              `
              : `<div class="feps3d-shopify__muted">No linked p elements.</div>`}
          </div>
        `;
      }

      function infoListHtml(title, items, emptyLabel, sectionId = "") {
        const sectionAttr = sectionId
          ? ` data-fok-ui-information-section="${escapeHtml(sectionId)}"`
          : "";
        return `
          <div class="feps3d-shopify__info-block"${sectionAttr}>
            <div class="feps3d-shopify__info-kicker">${escapeHtml(title)}</div>
            ${items.length ? `<div class="feps3d-shopify__info-chip-list">${infoChipItemsHtml(items)}</div>` : `<div class="feps3d-shopify__muted">${escapeHtml(emptyLabel)}</div>`}
          </div>
        `;
      }

      function normalizedInfoLabel(value) { return String(value || "").trim().toLowerCase(); }
      function infoNodeForValue(value) {
        if (!value) return null;
        if (typeof value === "object") {
          const directId = value.id || value.node_id || value.unique_id;
          if (directId && nodeById.has(directId)) return nodeById.get(directId);
          if (value.node && value.node.id) return value.node;
          if (value.label || value.title) return infoNodeForValue(value.label || value.title);
          return null;
        }
        const target = normalizedInfoLabel(value);
        if (!target) return null;
        if (nodeById.has(value)) return nodeById.get(value);
        return nodes.find((candidate) => {
          const meta = candidate.meta || {};
          return [candidate.id, candidate.unique_id, candidate.short_label, candidate.label, nodeDisplayTitle(candidate), meta.source_short_label, meta.source_title, meta.normalized_tool_name, meta.concept_label, meta.phenomenon_label].some((entry) => normalizedInfoLabel(entry) === target);
        }) || null;
      }
      function infoChipTone(node, fallbackPole) {
        if (node && eagSemanticNodeKinds.has(node.kind)) return "eag";
        if (fallbackPole) return fallbackPole;
        if (!node) return "default";
        const level = phenomenonGroupLevel(node);
        if (level >= 3 && level <= 5) return "l3";
        const meta = node.meta || {};
        const pole = String(meta.primary_pole || meta.pole || "").toLowerCase();
        if (pole.includes("eco")) return "eco";
        if (pole.includes("psycho")) return "psycho";
        if (pole.includes("somatic")) return "somatic";
        if (node.kind === "source") return "source";
        if (node.kind === "resource") return "resource";
        if (isSpecificToolLikeNode(node)) return "tools";
        if (node.kind === "environment" || isEnvironmentCategoryNode(node)) return "environment";
        if (node.kind === "participant_group" || node.kind === "age_category") return "participant-group";
        if (node.kind === "intervention_unit" || node.kind === "research_design" || node.kind === "research_insights") return "intervention";
        return "default";
      }
      function infoChipHtml(value, fallbackPole) {
        const node = infoNodeForValue(value);
        const itemTone = value && typeof value === "object" ? value.tone : "";
        const label = typeof value === "object" ? (value.label || value.title || (node ? nodeDisplayTitle(node) : "")) : String(value || (node ? nodeDisplayTitle(node) : ""));
        const tone = infoChipTone(node, itemTone || fallbackPole);
        const nodeAttr = node ? ` data-info-select-node="${escapeHtml(node.id)}"` : "";
        return `<button type="button" class="feps3d-shopify__info-chip feps3d-shopify__info-chip--${escapeHtml(tone)}"${nodeAttr}>${escapeHtml(label)}</button>`;
      }
      function infoChipItemsHtml(items, fallbackPole) {
        const seen = new Set();
        return items.map((item) => {
          const node = infoNodeForValue(item);
          const key = node ? node.id : JSON.stringify(item);
          if (seen.has(key)) return "";
          seen.add(key);
          return infoChipHtml(item, fallbackPole);
        }).join("");
      }
      function infoItemLabel(value) {
        const node = infoNodeForValue(value);
        if (node) return navigatorNodeLabel(node);
        if (value && typeof value === "object") {
          return String(value.label || value.title || value.short_label || value.id || "").trim();
        }
        return String(value || "").trim();
      }
      function alphabeticalInfoItems(items) {
        return [...items].sort((left, right) =>
          infoItemLabel(left).localeCompare(infoItemLabel(right), undefined, { sensitivity: "base" })
        );
      }
      function collapsibleInfoListHtml(sectionId, title, items, emptyLabel) {
        const sortedItems = alphabeticalInfoItems(items);
        return `
          <details
            class="feps3d-shopify__info-block feps3d-shopify__semantic-dropdown"
            data-fok-ui-information-section="${escapeHtml(sectionId)}"
          >
            <summary>
              <span class="feps3d-shopify__info-kicker">${escapeHtml(title)}</span>
              <span class="feps3d-shopify__semantic-dropdown-count">${sortedItems.length}</span>
            </summary>
            <div class="feps3d-shopify__semantic-dropdown-body">
              ${sortedItems.length
                ? `<div class="feps3d-shopify__info-chip-list">${infoChipItemsHtml(sortedItems)}</div>`
                : `<div class="feps3d-shopify__muted">${escapeHtml(emptyLabel)}</div>`}
            </div>
          </details>
        `;
      }
      function dimensionChipItems() {
        return [{ id: "PHENOGROUP-L2-ECO", label: "Ecological", tone: "eco" }, { id: "PHENOGROUP-L2-PSYCHO", label: "Psychological", tone: "psycho" }, { id: "PHENOGROUP-L2-SOMATIC", label: "Somatic", tone: "somatic" }];
      }

      function l3EnvironmentParticipantControlItems() {
        return [
          { id: "CONTEXT-POPULATION", label: "Population categories", tone: "participant-group" },
          { id: "CONTEXT-ENVIRONMENTS-NATURAL", label: "Natural environments", tone: "environment" },
          { id: "CONTEXT-ENVIRONMENTS-URBAN", label: "Urban environments", tone: "environment" },
        ].filter((item) => {
          const targetNode = nodeById.get(item.id);
          return isContextClusterNode(targetNode);
        });
      }

      function l3EnvironmentParticipantControlsHtml() {
        return infoListHtml("ENVIRONMENTS AND PARTICIPANTS", l3EnvironmentParticipantControlItems(), "No environment or participant controls.");
      }

      function collectLabelValues(items) {
        return (Array.isArray(items) ? items : [])
          .map((item) => {
            if (typeof item === "string") return item;
            if (!item || typeof item !== "object") return "";
            return item.label || item.short_label || item.id || item.unique_id || "";
          })
          .filter((item) => String(item || "").trim());
      }

      function uniqueSortedLabelList(items) {
        const labelsByKey = new Map();
        for (const item of collectLabelValues(items)) {
          const trimmed = String(item).trim();
          if (!trimmed) continue;
          labelsByKey.set(trimmed, trimmed);
        }
        return [...labelsByKey.keys()].sort((left, right) => left.localeCompare(right));
      }

      function infoMatrixHtml(rows, sectionId = "", title = "") {
        const normalizedRows = rows
          .filter((row) => row && String((row[0] || "").trim()))
          .map((row) => [String(row[0]).trim(), String(row[1] || "").trim()]);
        const sectionAttr = sectionId
          ? ` data-fok-ui-information-section="${escapeHtml(sectionId)}"`
          : "";
        const titleHtml = title
          ? `<div class="feps3d-shopify__info-kicker">${escapeHtml(title)}</div>`
          : "";
        if (!normalizedRows.length) {
          return `<div class="feps3d-shopify__info-block"${sectionAttr}>${titleHtml}<div class="feps3d-shopify__muted">No values.</div></div>`;
        }
        const rowsHtml = normalizedRows
          .map(
            ([label, value]) => `
              <tr>
                <td>${escapeHtml(label)}</td>
              <td><div class="feps3d-shopify__info-matrix-value">${escapeHtml(value || "0")}</div></td>
            </tr>
          `
          )
          .join("");
        return `<div class="feps3d-shopify__info-block"${sectionAttr}>${titleHtml}<table class="feps3d-shopify__info-matrix" role="presentation"><tbody>${rowsHtml}</tbody></table></div>`;
      }

      function groundedCorpusCounts() {
        const selectionStats = scene && scene.meta
          && scene.meta.resource_render_selection
          && scene.meta.resource_render_selection.stats
          ? scene.meta.resource_render_selection.stats
          : {};
        const fallbackResourceCount = nodes.filter(
          (node) => node && node.kind === "resource"
        ).length;
        const outerOrbitResourceCount = nodes.filter((node) => {
          if (!node || node.kind !== "resource") return false;
          const metaOrbit = Number(node.meta && node.meta.fok_orbit);
          const orbit = Number.isFinite(metaOrbit)
            ? metaOrbit
            : Number(node.orbit_hint);
          return Number.isFinite(orbit) && Math.abs(orbit - 30000) <= 0.001;
        }).length;
        const totalResources = Number(selectionStats.resources_total);
        const renderedResources = Number(selectionStats.resources_selected);
        const integratedSources = nodes.filter(
          (node) => integratedResearchSourceNode(node)
        ).length;
        return {
          totalResources: Number.isFinite(totalResources)
            ? totalResources
            : fallbackResourceCount,
          renderedResources: outerOrbitResourceCount
            || (Number.isFinite(renderedResources)
              ? renderedResources
              : fallbackResourceCount),
          integratedSources,
        };
      }

      function formattedCount(value) {
        const numericValue = Number(value);
        return Number.isFinite(numericValue)
          ? new Intl.NumberFormat("en-US").format(numericValue)
          : "0";
      }

      function groundedInformationHtml(node = null) {
        const counts = groundedCorpusCounts();
        const categoryCounts = researchTypeCounts();
        const categoryRows = currentResearchTypes().map((type) => [
          `${researchTypeLabel(type)}:`,
          formattedCount(categoryCounts.get(type) || 0),
        ]);
        const integratedSourceNodes = navigatorNodes("sources");
        const headerHtml = node
          ? informationHeaderHtml(node, nodeDisplayTitle(node), {
              titleAllCaps: true,
            })
          : "";
        const summaryRows = [
          [
            `${uiTextValue("total_resources_title", "Total resources in database")}:`,
            formattedCount(counts.totalResources),
          ],
          [
            `${uiTextValue("rendered_resources_title", "Resources rendered on outer orbit (o30000)")}:`,
            formattedCount(counts.renderedResources),
          ],
          [
            `${uiTextValue("integrated_sources_count_title", "Integrated sources")}:`,
            formattedCount(counts.integratedSources),
          ],
          ...categoryRows,
        ];
        const researchTypeHtml = `
          <details
            class="feps3d-shopify__info-block feps3d-shopify__semantic-dropdown"
            data-fok-ui-information-section="research_type_filter"
          >
            <summary>
              <span class="feps3d-shopify__info-kicker">${escapeHtml(
                uiTextValue("research_type_filter_title", "Research type")
              )}</span>
              <span class="feps3d-shopify__semantic-dropdown-count">${currentResearchTypes().length}</span>
            </summary>
            <div class="feps3d-shopify__semantic-dropdown-body">
              <label class="feps3d-shopify__select-label">
                ${escapeHtml(uiTextValue("research_type_filter_title", "Research type"))}
                <select
                  class="feps3d-shopify__select"
                  data-feps3d-control="research-type"
                ></select>
              </label>
            </div>
          </details>
        `;
        return [
          headerHtml,
          infoMatrixHtml(
            summaryRows,
            "grounded_summary",
            uiTextValue("grounded_summary_title", "GROUNDED SOURCE BASE")
          ),
          researchTypeHtml,
          collapsibleInfoListHtml(
            "integrated_sources",
            uiTextValue("navigator.sources", "INTEGRATED SOURCES"),
            integratedSourceNodes,
            "No integrated sources."
          ),
        ].join("");
      }

      function nodeDisplayTitle(node) {
        const meta = node.meta || {};
        if (node.kind === "environment") return String(node.short_label || node.label || meta.micro_location || "Environment").trim();
        if (node.kind === "participant_group") return String(node.short_label || node.label || meta.participant_group_short_name || "Participant group").trim();
        if (node.kind === "intervention_unit") return String(meta.condition_label || node.short_label || node.label || "Intervention unit").trim();
        if (node.kind === "research_design" || node.kind === "research_insights") return String(meta.source_short_label || node.short_label || node.label || "Research").trim();
        return String(meta.source_title || meta.normalized_tool_name || meta.concept_label || meta.phenomenon_label || node.short_label || node.label || "Selected element").trim();
      }

      function sentenceTitle(value) {
        const normalized = String(value || "").trim();
        if (!normalized) return normalized;
        return normalized[0].toUpperCase() + normalized.slice(1);
      }

      function linkedToolsForInformation(node) {
        const meta = node.meta || {};
        if (isPhenomenonLikeNode(node)) {
          if (Array.isArray(meta.linked_tools) && meta.linked_tools.length) {
            return uniqueSortedLabelList(meta.linked_tools);
          }
          return uniqueSortedLabels(relatedNodes(node, ["tool", "specific_tool", "specific_tool_group"], ["phenomenon_tool"]));
        }
        if (node.kind === "specific_tool_group") {
          const linkedTools = uniqueSortedLabelList(meta.linked_tools);
          const edgeTools = uniqueSortedLabels(relatedNodes(node, ["specific_tool", "tool", "specific_tool_group"], ["tool_group"]));
          return uniqueSortedLabelList([...linkedTools, ...edgeTools]);
        }
        if (isSpecificToolLikeNode(node)) {
          return uniqueSortedLabels(relatedNodes(node, ["phenomenon"], ["phenomenon_tool"]));
        }
        if (node.kind === "source") {
          return uniqueSortedLabels(relatedNodes(node, ["tool", "specific_tool", "specific_tool_group"], ["tool_source"]));
        }
        if (node.kind === "phenomenon_group") {
          const groupPhenomena = phenomenaLinkedToGroup(node);
          const linkedGroupTools = groupPhenomena.flatMap((phenomenonNode) =>
            relatedNodes(phenomenonNode, ["tool", "specific_tool", "specific_tool_group"], ["phenomenon_tool"])
          );
          return uniqueSortedLabels(uniqueNodes(linkedGroupTools));
        }
        return [];
      }

    function linkedPhenomenaCountText(node) {
      const linkedPhenomena = linkedPhenomenonSummary(node);
      return `${linkedPhenomena.total}`;
    }

      function linkedPhenomenonGroupsByLevel(node, level) {
      const groups = uniqueNodes(
        relatedNodes(node, ["phenomenon_group"], ["phenomenon_group"]).filter((groupNode) =>
          groupNode != null && phenomenonGroupLevel(groupNode) === level
        )
      );
      return uniqueSortedLabels(groups);
    }

      function linkedPhenomenonGroupsByLevelByPole(node, level) {
        const groups = uniqueNodes(relatedNodes(node, ["phenomenon_group"], ["phenomenon_group"]).filter((groupNode) =>
          groupNode != null && phenomenonGroupLevel(groupNode) === level
        ));
        const grouped = { eco: [], psycho: [], somatic: [] };
        const seen = new Set();
        for (const groupNode of groups) {
          if (!groupNode) continue;
          const label = String(groupNode.label || groupNode.short_label || "").trim();
          if (!label) continue;
          const pole = String((groupNode.meta || {}).primary_pole || "").toUpperCase();
          const dedupeKey = `${pole}:${groupNode.id || label}`;
          if (seen.has(dedupeKey)) continue;
          seen.add(dedupeKey);
          if (pole === "ECO") grouped.eco.push(label);
          else if (pole === "PSYCHO") grouped.psycho.push(label);
          else if (pole === "SOMATIC") grouped.somatic.push(label);
        }
        grouped.eco.sort((left, right) => left.localeCompare(right));
        grouped.psycho.sort((left, right) => left.localeCompare(right));
        grouped.somatic.sort((left, right) => left.localeCompare(right));
        return grouped;
      }

      function linkedPhenomenonGroupsByLevelHtml(node, level) {
        const groups = linkedPhenomenonGroupsByLevelByPole(node, level);
        const hasGroups = groups.eco.length + groups.psycho.length + groups.somatic.length > 0;
        return `
          <div class="feps3d-shopify__info-block">
            <div class="feps3d-shopify__info-kicker">INCLUDED GROUPS</div>
            ${hasGroups
              ? `
                ${phenomenonGroupHtml("ECO", "eco", groups.eco)}
                ${phenomenonGroupHtml("PSYCHO", "psycho", groups.psycho)}
                ${phenomenonGroupHtml("SOMATIC", "somatic", groups.somatic)}
              `
              : `<div class="feps3d-shopify__muted">No linked L1 groups.</div>`}
          </div>
        `;
      }

    function informationHeaderHtml(node, displayTitle, options = {}) {
      const safeDisplayTitle = String(displayTitle || "Selected element");
      const titleValue = options.titleAllCaps ? safeDisplayTitle.toUpperCase() : safeDisplayTitle;
      return `
          <div class="feps3d-shopify__info-block">
            <div class="feps3d-shopify__info-title feps3d-shopify__info-title--hero">${escapeHtml(titleValue || "Selected element")}</div>
          </div>
        `;
    }

      function linkedPhenomenaByPoleInfoHtml(node) {
        const groups = linkedPhenomenonGroups(node);
        const linkedPhenomena = linkedPhenomenonSummary(node);
        if (!linkedPhenomena.total) {
        return `
          <div class="feps3d-shopify__info-block">
            <div class="feps3d-shopify__info-kicker">LINKED PHENOMENA</div>
            <div class="feps3d-shopify__muted">No linked phenomena.</div>
          </div>
        `;
      }
        return `
        <div class="feps3d-shopify__info-block">
          <div class="feps3d-shopify__info-kicker">LINKED PHENOMENA</div>
          ${phenomenonGroupHtml("ECO", "eco", groups.eco, true)}
          ${phenomenonGroupHtml("PSYCHO", "psycho", groups.psycho, true)}
          ${phenomenonGroupHtml("SOMATIC", "somatic", groups.somatic, true)}
        </div>
      `;
      }

    function sourceInformationHeaderHtml(title, year, authors, origin, language) {
      const yearValue = String(year || "Unknown.").trim();
      const authorValue = Array.isArray(authors) && authors.length
        ? authors.join(", ")
        : String(authors || "Not available.").trim();
      const sourceRows = [
        ["YEAR:", yearValue],
        ["AUTHORS:", authorValue],
        ["ORIGIN:", String(origin || "Not available.").trim()],
        ["LANGUAGE:", String(language || "Not available.").trim()],
      ];
      return `
        <div class="feps3d-shopify__info-block">
          <div class="feps3d-shopify__info-title">${escapeHtml(String(title || "Selected element"))}</div>
        </div>
        <div class="feps3d-shopify__info-block"><div class="feps3d-shopify__muted"></div></div>
        ${infoMatrixHtml(sourceRows)}
      `;
    }

      function publicRedactedScene() {
        return !!(scene && scene.meta && scene.meta.public_redacted);
      }

      function accessRequiredInfoHtml(title) {
        return `
          <div class="feps3d-shopify__info-block">
            <div class="feps3d-shopify__info-kicker">${escapeHtml(title)}</div>
            <div class="feps3d-shopify__access-required-box">Specialist Status Required to View Content</div>
          </div>
        `;
      }

      function linkedSourcesInfoHtml(
        items,
        emptyLabel,
        title = "LINKED SOURCES",
        sectionId = "linked_sources"
      ) {
        const sectionAttr = sectionId
          ? ` data-fok-ui-information-section="${escapeHtml(sectionId)}"`
          : "";
        return `
          <div class="feps3d-shopify__info-block"${sectionAttr}>
            <div class="feps3d-shopify__info-kicker">${escapeHtml(title)}</div>
            ${items.length
              ? `<div class="feps3d-shopify__info-chip-list feps3d-shopify__info-chip-list--linked-sources">${infoChipItemsHtml(items)}</div>`
              : `<div class="feps3d-shopify__muted">${escapeHtml(emptyLabel)}</div>`}
          </div>
        `;
      }

      function infoValueHtml(title, value, emptyLabel, valueClass = "") {
        const normalizedValue = Array.isArray(value)
          ? value.filter((item) => String(item || "").trim()).join(", ")
          : String(value || "").trim();
        const classAttr = valueClass ? ` class="${valueClass}"` : "";
        return `
          <div class="feps3d-shopify__info-block">
            <div class="feps3d-shopify__info-kicker">${escapeHtml(title)}</div>
            ${normalizedValue ? `<div${classAttr}>${escapeHtml(normalizedValue)}</div>` : `<div class="feps3d-shopify__muted">${escapeHtml(emptyLabel)}</div>`}
          </div>
        `;
      }

      function boxedInfoValueHtml(title, value, emptyLabel, boxClass, valueClass = "", sectionId = "") {
        const normalizedValue = Array.isArray(value)
          ? value.filter((item) => String(item || "").trim()).join(", ")
          : String(value || "").trim();
        const classAttr = valueClass ? ` class="${valueClass}"` : "";
        const sectionAttr = sectionId
          ? ` data-fok-ui-information-section="${escapeHtml(sectionId)}"`
          : "";
        const content = normalizedValue
          ? `<div${classAttr}>${escapeHtml(normalizedValue)}</div>`
          : `<div class="feps3d-shopify__muted">${escapeHtml(emptyLabel)}</div>`;
        return `
          <div class="feps3d-shopify__info-block"${sectionAttr}>
            <div class="feps3d-shopify__info-kicker">${escapeHtml(title)}</div>
            <div class="${boxClass}">${content}</div>
          </div>
        `;
      }

      function navigatorTitleHtml(node) {
        if (isL3Node(node)) return "";
        const title = String(node.short_label || node.label || "").trim();
        return title ? `<div class="feps3d-shopify__navigator-title">${escapeHtml(title)}</div>` : "";
      }

      function elementTypeLabel(node) {
        if (isSourceResourceElement(node)) return node.kind;
        return String(node.kind || "unknown").trim().toLowerCase() || "unknown";
      }

      function linkedPhenomenonGroups(node) {
        const groups = { eco: [], psycho: [], somatic: [] };
        const seen = new Set();
        for (const phenomenonNode of connectedPhenomena(node)) {
          if (!phenomenonNode) continue;
          const label = String(phenomenonNode.label || phenomenonNode.short_label || "").trim();
          if (!label) continue;
          const pole = String((phenomenonNode.meta || {}).primary_pole || "").toUpperCase();
          const dedupeKey = `${pole}:${phenomenonNode.id || label}`;
          if (seen.has(dedupeKey)) continue;
          seen.add(dedupeKey);
          if (pole === "ECO") groups.eco.push(label);
          else if (pole === "PSYCHO") groups.psycho.push(label);
          else if (pole === "SOMATIC") groups.somatic.push(label);
        }
        groups.eco.sort((left, right) => left.localeCompare(right));
        groups.psycho.sort((left, right) => left.localeCompare(right));
        groups.somatic.sort((left, right) => left.localeCompare(right));
        return groups;
      }

      function linkedPhenomenonSummary(node) {
        const groups = linkedPhenomenonGroups(node);
        return {
          total: groups.eco.length + groups.psycho.length + groups.somatic.length,
          eco: groups.eco.length,
          psycho: groups.psycho.length,
          somatic: groups.somatic.length,
        };
      }

      function phenomenonGroupHtml(title, poleKey, items, inline = false) {
        if (!items.length) return "";
        if (inline) {
          return `
            <div class="feps3d-shopify__pole-group feps3d-shopify__pole-group--inline">
              <div class="feps3d-shopify__pole-heading feps3d-shopify__pole-heading--${poleKey}">
                ${escapeHtml(title)}:
                <span class="feps3d-shopify__info-chip-list">${infoChipItemsHtml(items, poleKey)}</span>
              </div>
            </div>
          `;
        }
        return `
          <div class="feps3d-shopify__pole-group">
            <div class="feps3d-shopify__pole-heading feps3d-shopify__pole-heading--${poleKey}">${escapeHtml(title)}</div>
            <div class="feps3d-shopify__info-chip-list">${infoChipItemsHtml(items, poleKey)}</div>
          </div>
        `;
      }

      function elementBreakdownHtml(node) {
        const linkedSourceCount = uniqueSortedLabels(connectedSourceNodes(node)).length;
        const linkedPhenomenonGroupsByPole = linkedPhenomenonGroups(node);
        const linkedPhenomena = linkedPhenomenonSummary(node);
        const linkedPhenomenaHtml = linkedPhenomena.total
          ? `
          <div class="feps3d-shopify__element-inline-stat">
            <strong class="feps3d-shopify__stat-badge">${linkedPhenomena.total}</strong>
            <span class="feps3d-shopify__element-inline-breakdown">(<strong class="feps3d-shopify__stat-badge feps3d-shopify__stat-badge--eco">${linkedPhenomena.eco}</strong>, <strong class="feps3d-shopify__stat-badge feps3d-shopify__stat-badge--psycho">${linkedPhenomena.psycho}</strong>, <strong class="feps3d-shopify__stat-badge feps3d-shopify__stat-badge--somatic">${linkedPhenomena.somatic}</strong>)</span>
          </div>
          ${phenomenonGroupHtml("ECO", "eco", linkedPhenomenonGroupsByPole.eco)}
          ${phenomenonGroupHtml("PSYCHO", "psycho", linkedPhenomenonGroupsByPole.psycho)}
          ${phenomenonGroupHtml("SOMATIC", "somatic", linkedPhenomenonGroupsByPole.somatic)}
        `
          : `<div class="feps3d-shopify__muted">No linked phenomena.</div>`;
        return `
          <div class="feps3d-shopify__info-block">
            <div class="feps3d-shopify__info-kicker">Element type</div>
            <div>${escapeHtml(elementTypeLabel(node))}</div>
          </div>
          <div class="feps3d-shopify__info-block">
            <div class="feps3d-shopify__info-kicker">Linked sources</div>
            <div class="feps3d-shopify__element-inline-stat"><strong class="feps3d-shopify__stat-badge">${linkedSourceCount}</strong> linked sources</div>
          </div>
          <div class="feps3d-shopify__info-block">
            <div class="feps3d-shopify__info-kicker">Linked phenomena</div>
            ${linkedPhenomenaHtml}
          </div>
        `;
      }

      function environmentInformationHtml(node, title) {
        const meta = node.meta || {};
        const rows = [
          informationHeaderHtml(node, title),
          infoMatrixHtml([
            ["Microlocation:", meta.micro_location || title || "Not available."],
            ["Country:", meta.country_or_region_display_en || meta.country_or_region || "Not available."],
          ]),
          boxedInfoValueHtml("ABOUT THIS SETTING", meta.environment_description_en || meta.notes || "", "Not available.", "feps3d-shopify__summary-box"),
          meta.environment_activity_exposure_en
            ? boxedInfoValueHtml("ACTIVITY IN THIS SETTING", meta.environment_activity_exposure_en, "", "feps3d-shopify__summary-box")
            : "",
          infoListHtml(
            "INTERVENTION UNITS",
            linkedInterventionUnitsForContextElement(node),
            "No linked intervention units.",
            "intervention_units"
          ),
          infoListHtml(
            "SOURCE INSIGHTS",
            linkedSourceInsightsForContextElement(node),
            "No linked source insights.",
            "research_insights"
          ),
          linkedSourcesInfoHtml(
            linkedSourcesForContextElements([node]),
            "No linked sources."
          ),
        ];
        return rows.join("");
      }

      function participantGroupInformationHtml(node, title) {
        const meta = node.meta || {};
        const rows = [
          informationHeaderHtml(node, title),
          infoMatrixHtml([
            ["Group:", meta.participant_group_short_name || title || "Not available."],
            ["Age description:", meta.participant_group_age_description_en || meta.age_description || "Not available."],
            ["N initial:", meta.n_initial != null && meta.n_initial !== "" ? String(meta.n_initial) : "Not available."],
            ["Group role:", meta.group_role || "Not available."],
          ]),
          boxedInfoValueHtml("ABOUT THE PARTICIPANTS", meta.participant_group_description_en || "", "Not available.", "feps3d-shopify__summary-box"),
          meta.participant_group_activity_exposure_en
            ? boxedInfoValueHtml("ACTIVITIES AND ENVIRONMENT", meta.participant_group_activity_exposure_en, "", "feps3d-shopify__summary-box")
            : "",
          infoListHtml(
            "INTERVENTION UNITS",
            linkedInterventionUnitsForContextElement(node),
            "No linked intervention units.",
            "intervention_units"
          ),
          infoListHtml(
            "SOURCE INSIGHTS",
            linkedSourceInsightsForContextElement(node),
            "No linked source insights.",
            "research_insights"
          ),
          linkedSourcesInfoHtml(
            linkedSourcesForContextElements([node]),
            "No linked sources."
          ),
        ];
        return rows.join("");
      }

      function interventionUnitInformationHtml(node, title) {
        const meta = node.meta || {};
        const context = interventionUnitContext(node);
        const rows = [
          informationHeaderHtml(node, title),
          infoMatrixHtml([
            ["Condition:", meta.condition_label || title || "Not available."],
            ["Type:", meta.intervention_type || "Not available."],
            ["Comparison role:", meta.comparison_role || "Not available."],
            ["Source:", meta.source_short_label || meta.source_unique_id || meta.source_id || "Not available."],
            ["Confidence:", meta.confidence || "Not available."],
          ]),
          boxedInfoValueHtml(
            "INTERVENTION DESCRIPTION",
            meta.intervention_description || "",
            "No plain-language intervention description is available.",
            "feps3d-shopify__summary-box",
            "",
            "intervention_description"
          ),
          infoListHtml(
            "PARTICIPANT GROUPS",
            context.participantGroups,
            "No participant group is linked to this intervention unit.",
            "participant_groups"
          ),
          infoListHtml(
            "ENVIRONMENTS",
            context.environments,
            "No environment is linked to this intervention unit.",
            "environments"
          ),
          infoListHtml(
            "TOOLS USED IN THIS RESEARCH",
            context.tools,
            "No research tools are linked to this source.",
            "linked_tools"
          ),
          infoListHtml(
            "SOURCE INSIGHTS",
            context.researchInsights,
            "No source insights are linked to this intervention unit.",
            "research_insights"
          ),
          infoMatrixHtml(
            [
              ["Session duration:", meta.intervention_session_duration_display || "Not reported."],
              ["Frequency:", meta.intervention_frequency_display || "Not reported."],
              ["Programme duration:", meta.intervention_program_duration_display || "Not reported."],
              ["Number of exposures:", meta.intervention_session_count_display || "Not reported."],
              ["Total dose:", meta.intervention_total_dose_display || "Not calculable."],
            ],
            "dose",
            "INTERVENTION DOSE"
          ),
          boxedInfoValueHtml(
            "DOSE CALCULATION",
            meta.intervention_dose_calculation || "",
            "No reliable cumulative-dose calculation is available.",
            "feps3d-shopify__summary-box",
            "",
            "dose"
          ),
          boxedInfoValueHtml(
            "COMPONENTS",
            meta.intervention_components_legacy_labels,
            "No separate intervention components are recorded.",
            "feps3d-shopify__summary-box",
            "",
            "components"
          ),
          boxedInfoValueHtml(
            "NOTES",
            meta.notes || "",
            "No additional notes.",
            "feps3d-shopify__summary-box",
            "",
            "notes"
          ),
          linkedSourcesInfoHtml(
            context.sources,
            "No linked source."
          ),
        ];
        return rows.join("");
      }

      function researchInsightsInformationHtml(node, title) {
        const meta = node.meta || {};
        const context = researchInsightContext(node);
        const sourceNode = context.sourceNodes[0] || null;
        const rows = [
          informationHeaderHtml(node, title),
          boxedInfoValueHtml(
            "WHAT THIS SOURCE CONTRIBUTES",
            researchInsightContributionSummary(node, context),
            "Not available.",
            "feps3d-shopify__summary-box",
            "",
            "research_insight_summary"
          ),
          boxedInfoValueHtml(
            "SOURCE TITLE",
            meta.source_title || "",
            "Not available.",
            "feps3d-shopify__summary-box",
            "",
            "source_title"
          ),
          linkedSourcesInfoHtml(
            context.sourceNodes,
            "No linked source.",
            "SOURCE",
            "linked_sources"
          ),
          infoMatrixHtml(
            [
              ["Type:", humanizedMetadataValue(meta.source_type) || "Not available."],
              ["Subtype:", humanizedMetadataValue(meta.source_subtype) || "Not available."],
              ["Publication year:", meta.publication_year || "Not available."],
              ["Analytical profile:", researchProfileLabel(meta.research_profile)],
              ["Research route:", researchInsightRouteLabel(meta)],
            ],
            "research_character",
            "RESEARCH CHARACTER"
          ),
          infoListHtml(
            "RESEARCH DESIGN",
            context.researchDesigns,
            "No linked research design.",
            "research_design"
          ),
          context.plannedPhenomena.length
            ? infoListHtml(
                "PLANNED PHENOMENA",
                context.plannedPhenomena,
                "No planned phenomena.",
                "linked_phenomena"
              )
            : linkedPhenomenaByPoleInfoHtml(sourceNode || node),
          context.usedTools.length
            ? infoListHtml(
                "LINKED TOOLS",
                context.usedTools,
                "No linked tools.",
                "linked_tools"
              )
            : "",
          context.plannedTools.length
            ? infoListHtml(
                "PLANNED TOOLS",
                context.plannedTools,
                "No planned tools.",
                "linked_tools"
              )
            : "",
          infoListHtml(
            "POPULATIONS",
            context.populations,
            "No linked populations.",
            "populations"
          ),
          infoListHtml(
            "ENVIRONMENTS",
            context.environments,
            "No linked environments.",
            "environments"
          ),
          infoListHtml(
            "INTERVENTION UNITS",
            context.interventionUnits,
            "No linked intervention units.",
            "intervention_units"
          ),
          collapsibleInfoListHtml(
            "eag_categories",
            "CATEGORIES",
            context.categories,
            "No linked EAG categories."
          ),
          collapsibleInfoListHtml(
            "eag_constructs",
            "CONSTRUCTS",
            context.constructs,
            "No linked EAG Constructs."
          ),
          boxedInfoValueHtml(
            "ANALYSIS BASIS",
            researchInsightAnalysisBasis(context),
            "Not available.",
            "feps3d-shopify__summary-box",
            "",
            "analysis_basis"
          ),
        ];
        return rows.join("");
      }

      function categoryInformationHtml(node, title) {
        const meta = node.meta || {};
        const members = categoryMemberNodes(node);
        const memberTitle = node.kind === "age_category"
          ? "PARTICIPANT GROUPS"
          : "ENVIRONMENTS";
        const memberSectionId = node.kind === "age_category"
          ? "participant_groups"
          : "environments";
        const emptyMemberLabel = node.kind === "age_category"
          ? "No linked participant groups."
          : "No linked environments.";
        return [
          informationHeaderHtml(node, title),
          infoMatrixHtml([
            ["Category:", meta.category_label || title || "Not available."],
            ["Code:", meta.code || "Not available."],
            ["Axis:", meta.category_axis || "Not available."],
            ["Members:", meta.member_count != null ? String(meta.member_count) : "0"],
            ["Rank distribution:", meta.rank_distribution || "Not available."],
            ["Default rank:", meta.default_rank_interpretation || "Not available."],
          ]),
          boxedInfoValueHtml("CATEGORY DESCRIPTION", meta.category_description || "", "Not available.", "feps3d-shopify__summary-box"),
          infoListHtml(
            memberTitle,
            members,
            emptyMemberLabel,
            memberSectionId
          ),
          linkedSourcesInfoHtml(
            linkedSourcesForContextElements(members),
            "No linked sources."
          ),
        ].join("");
      }

      function contextClusterInformationHtml(node, title) {
        const meta = node.meta || {};
        const categories = contextClusterCategoryNodes(node);
        const categoryTitle = node.kind === "population"
          ? "AGE CATEGORIES"
          : node.kind === "urban"
          ? "URBAN ENVIRONMENT CATEGORIES"
          : "NATURAL ENVIRONMENT CATEGORIES";
        return [
          informationHeaderHtml(node, title),
          infoMatrixHtml([
            ["Cluster:", meta.cluster_label || title || "Not available."],
            ["Axis:", meta.cluster_axis || "Not available."],
            ["Members:", meta.member_count != null ? String(meta.member_count) : "0"],
          ]),
          boxedInfoValueHtml("CLUSTER DESCRIPTION", meta.cluster_description || "", "Not available.", "feps3d-shopify__summary-box"),
          infoListHtml(
            categoryTitle,
            categories,
            "No linked categories.",
            "categories"
          ),
          linkedSourcesInfoHtml(
            linkedSourcesForContextCluster(node),
            "No linked sources."
          ),
        ].join("");
      }

      function navigatorLinkHtml(url, label) {
        const safeUrl = escapeHtml(url);
        const safeLabel = escapeHtml(label || "Follow link to source");
        return `
          <div class="feps3d-shopify__info-block feps3d-shopify__link-spacer">
            <a class="feps3d-shopify__navigator-link" href="${safeUrl}" target="_blank" rel="noopener noreferrer">${safeLabel}</a>
          </div>
        `;
      }

      function navigatorHtml(node) {
        const lines = [
          navigatorTitleHtml(node),
          elementBreakdownHtml(node),
        ];
        return lines.join("");
      }

      function informationHtml(node) {
        const meta = node.meta || {};
        const title = nodeDisplayTitle(node);
        const year = meta.publication_year != null ? String(meta.publication_year) : "";
        const yearEmptyLabel = isSourceResourceElement(node) ? "Unknown." : "Not available.";
        const authors = Array.isArray(meta.source_author_surnames) ? meta.source_author_surnames : [];
        const citation = String(meta.apa7_citation || "").trim();
        const locatorUrl = String(meta.source_locator_url || "").trim();
        const block = String(meta.source_visual_record_type || meta.source_subtype || meta.record_type || "").trim();
        const sourceUniqueId = String(node.unique_id || meta.unique_id || "").trim();
        const sourceOrigin = String(meta.origin || meta.source_country || meta.country || meta.publication_country || "").trim();
        const sourceLanguage = String(meta.language || meta.source_language || meta.text_language || meta.main_language || "").trim();
        const displayTitle = isSpecificToolLikeNode(node) || isPhenomenonLikeNode(node) ? sentenceTitle(title) : title;
        const elementIntroHtml = informationHeaderHtml(node, displayTitle);
        const linkedSourcesCount = uniqueSortedLabels(connectedSourceNodes(node)).length;
        const linkedToolsCount = linkedToolsForInformation(node).length;
        const linkedPhenomenaText = linkedPhenomenaCountText(node);
        const linkedCountsHtml = infoMatrixHtml([
          ["Linked sources:", String(linkedSourcesCount)],
          ["Linked tools:", String(linkedToolsCount)],
          ["Linked phenomena:", linkedPhenomenaText],
        ]);
        if (isEagSemanticNode(node)) {
          const relatedSources = eagSourceNodes(node);
          const relatedTools = eagRelatedTools(node).sort((left, right) =>
            navigatorNodeLabel(left).localeCompare(navigatorNodeLabel(right))
          );
          const semanticDetails = [
            ["Semantic type:", String(meta.element_type || node.kind || "")],
            ["Taxonomy ID:", String(meta.taxonomy_id || node.unique_id || "")],
            ["Ontology layer:", String(meta.ontology_status || "prepared semantic layer")],
            ["Domain:", String(meta.concept_domain || "")],
            ["Concept type:", String(meta.concept_type || "").replace(/_/g, " ")],
            ["Tier:", String(meta.concept_tier || "").replace(/_/g, " ")],
            ["Original term:", String(meta.original_de || "")],
            ["Expression role:", String(meta.expression_role || "").replace(/_/g, " ")],
            [
              "Merged variants:",
              Array.isArray(meta.canonicalized_variant_forms)
                ? meta.canonicalized_variant_forms.join("; ")
                : "",
            ],
            ["Original source title:", String(meta.source_specific_original_label || "")],
            ["Primary pole:", String(meta.primary_pole || "Not available.")],
            ["Linked sources:", String(relatedSources.length)],
          ].filter(([_label, value]) => value);
          return [
            elementIntroHtml,
            boxedInfoValueHtml(
              uiTextValue("short_description_title", "SHORT DESCRIPTION"),
              meta.short_description || meta.semantic_description || "",
              "Not available.",
              "feps3d-shopify__summary-box",
              "",
              "short_description"
            ),
            boxedInfoValueHtml(
              uiTextValue("long_description_title", "LONG DESCRIPTION"),
              meta.long_description || "",
              "Not available.",
              "feps3d-shopify__summary-box",
              "",
              "long_description"
            ),
            meta.concept_citation_text
              ? boxedInfoValueHtml(
                  "FINAL CONCEPT CITATION",
                  meta.concept_citation_text,
                  "",
                  "feps3d-shopify__citation-box",
                  "",
                  "final_concept_citation"
                )
              : "",
            Array.isArray(meta.final_concept_ids) && meta.final_concept_ids.length
              ? infoValueHtml(
                  "FINAL CONCEPT CANDIDATES",
                  meta.final_concept_ids,
                  "No final concept candidates."
                )
              : "",
            infoMatrixHtml(semanticDetails),
            eagPhenomenaByDimensionHtml(node),
            infoListHtml("LINKED TOOLS", relatedTools, "No linked tools."),
            infoListHtml(
              "CATEGORIES",
              eagDirectSemanticNodes(node, "eag_category"),
              "No directly linked EAG categories.",
              "eag_categories",
            ),
            infoListHtml(
              "CONSTRUCTS",
              eagDirectSemanticNodes(node, "eag_construct"),
              "No directly linked Constructs.",
              "eag_constructs",
            ),
            linkedSourcesInfoHtml(relatedSources, "No linked sources."),
          ].join("");
        }
        if (node.kind === "phenomenon") {
          const linkedTools = Array.isArray(meta.linked_tools)
            ? meta.linked_tools.map((item) => item && (item.label || item.short_label || item.id)).filter(Boolean)
            : uniqueSortedLabels(relatedNodes(node, ["tool", "specific_tool", "specific_tool_group"], ["phenomenon_tool"]));
          const linkedSources = Array.isArray(meta.linked_sources)
            ? meta.linked_sources.filter(Boolean)
            : connectedSourceNodes(node);
          return [
            elementIntroHtml,
            boxedInfoValueHtml(
              uiTextValue("short_description_title", "SHORT DESCRIPTION"),
              meta.short_description || meta.phenomenon_description_text || meta.rationale || "",
              "Not available.",
              "feps3d-shopify__summary-box",
              "",
              "short_description"
            ),
            boxedInfoValueHtml(
              uiTextValue("long_description_title", "LONG DESCRIPTION"),
              meta.long_description || "",
              "Not available.",
              "feps3d-shopify__summary-box",
              "",
              "long_description"
            ),
            infoListHtml("LINKED TOOLS", linkedTools, "No linked tools."),
            linkedSourcesInfoHtml(linkedSources, "No linked sources."),
          ].join("");
        }
      if (node.kind === "specific_tool_group") {
        const linkedSources = Array.isArray(meta.linked_sources)
          ? meta.linked_sources.filter(Boolean)
          : connectedSourceNodes(node);
        const toolLines = [
          elementIntroHtml,
          boxedInfoValueHtml(
            uiTextValue("short_description_title", "SHORT DESCRIPTION"),
            meta.short_description || meta.tool_description_text || meta.tool_description || "",
            "Not available.",
            "feps3d-shopify__summary-box",
            "",
            "short_description"
          ),
          boxedInfoValueHtml(
            uiTextValue("long_description_title", "LONG DESCRIPTION"),
            meta.long_description || "",
            "Not available.",
            "feps3d-shopify__summary-box",
            "",
            "long_description"
          ),
          linkedSourcesInfoHtml(linkedSources, "No linked sources."),
        ];
          toolLines.push(linkedPhenomenaByPoleInfoHtml(node));
          toolLines.push(linkedCountsHtml);
          return toolLines.join("");
        }
      if (node.kind === "phenomenon_group") {
        const groupLevel = phenomenonGroupLevel(node);
        if (groupLevel === 0) {
          return groundedInformationHtml(node);
        }
        if (groupLevel === 1) {
          const groupDescription = boxedInfoValueHtml("GROUP DESCRIPTION", meta.phenomenon_group_description_text || "", "Not available.", "feps3d-shopify__summary-box");
          const groupIntroHtml = informationHeaderHtml(node, title, { titleAllCaps: true });
          const groupRows = [
              groupIntroHtml,
              groupDescription,
              infoListHtml("DIMENSIONS", dimensionChipItems(), "No dimensions."),
              linkedPhenomenaByPoleInfoHtml(node),
              linkedCountsHtml,
            ];
            return [
              ...groupRows,
            ].join("");
          }
          if (groupLevel === 2) {
            const groupDescription = boxedInfoValueHtml("GROUP DESCRIPTION", meta.phenomenon_group_description_text || "", "Not available.", "feps3d-shopify__summary-box");
            const groupIntroHtml = informationHeaderHtml(node, title, { titleAllCaps: true });
            const groupRows = [
              groupIntroHtml,
              groupDescription,
              linkedPhenomenonGroupsByLevelHtml(node, 1),
            ];
            return [
              ...groupRows,
            ].join("");
          }
          if (groupLevel === 9) {
            return [
              informationHeaderHtml(node, title, { titleAllCaps: true }),
              boxedInfoValueHtml(
                "MODEL STATE",
                meta.phenomenon_group_description_text || meta.description_en_long || "",
                "Tap to return to the normal model view.",
                "feps3d-shopify__summary-box",
              ),
            ].join("");
          }
          if (groupLevel === 4) {
            return [
              informationHeaderHtml(node, title, { titleAllCaps: true }),
              boxedInfoValueHtml("GROUP DESCRIPTION", meta.phenomenon_group_description_text || "", "Not available.", "feps3d-shopify__summary-box"),
              infoListHtml(
                "CONTEXT CLUSTERS",
                relatedNodes(node, contextClusterKinds, ["l4_context_cluster"]),
                "No linked context clusters."
              ),
            ].join("");
          }
          if (groupLevel === 5) {
            return [
              informationHeaderHtml(node, title, { titleAllCaps: true }),
              boxedInfoValueHtml("GROUP DESCRIPTION", meta.phenomenon_group_description_text || "", "Not available.", "feps3d-shopify__summary-box"),
              collapsibleInfoListHtml("eag_categories", "CATEGORIES", relatedNodes(node, ["eag_category"], ["l5_eag_semantic"]), "No linked EAG categories."),
              collapsibleInfoListHtml("eag_constructs", "CONSTRUCTS", relatedNodes(node, ["eag_construct"], ["l5_eag_semantic"]), "No linked Constructs."),
            ].join("");
          }
          const groupDescription = boxedInfoValueHtml("GROUP DESCRIPTION", meta.phenomenon_group_description_text || "", "Not available.", "feps3d-shopify__summary-box");
          const groupIntroHtml = informationHeaderHtml(node, title, { titleAllCaps: true });
          return [
            groupIntroHtml,
            groupDescription,
            linkedPhenomenonGroupsByLevelHtml(node, 2),
            l3EnvironmentParticipantControlsHtml(),
          ].join("");
        }
        if (node.kind === "environment") {
          return environmentInformationHtml(node, title);
        }
        if (isEnvironmentCategoryNode(node) || node.kind === "age_category") {
          return categoryInformationHtml(node, title);
        }
        if (isContextClusterNode(node)) {
          return contextClusterInformationHtml(node, title);
        }
        if (node.kind === "participant_group") {
          return participantGroupInformationHtml(node, title);
        }
        if (node.kind === "intervention_unit") {
          return interventionUnitInformationHtml(node, title);
        }
        if (node.kind === "research_insights") {
          return researchInsightsInformationHtml(node, title);
        }
        if (isSourceResourceElement(node)) {
          const sourceRows = [
            sourceInformationHeaderHtml(title, year || yearEmptyLabel, authors, sourceOrigin, sourceLanguage),
            linkedPhenomenaByPoleInfoHtml(node),

            infoListHtml("LINKED TOOLS", linkedToolsForInformation(node), "No linked tools."),

            infoListHtml("ENVIRONMENTS", nodesSharingSource(node, ["environment"]), "No linked environments."),

            infoListHtml("PARTICIPANT GROUPS", nodesSharingSource(node, ["participant_group"]), "No linked participant groups."),

            infoListHtml("INTERVENTION UNITS", nodesSharingSource(node, ["intervention_unit"]), "No linked intervention units."),

            infoListHtml("RESEARCH INSIGHTS", nodesSharingSource(node, ["research_insights"]), "No linked research insights."),
          ];
          const fokDescription = String(meta.fok_opis_source || "").trim();
          if (fokDescription) {
            sourceRows.splice(1, 0, boxedInfoValueHtml("FOK DESCRIPTION", fokDescription, "Not available.", "feps3d-shopify__fok-description-box"));
          }
          if (state.activeModelPreset === "fok-s" && isReferenceSourceNode(node)) {
            const potentialRaw = meta.reference_potential_score != null ? String(meta.reference_potential_score) : "";
            const potentialFactor = Number.isFinite(Number(meta.reference_potential_factor))
              ? String(Number(meta.reference_potential_factor))
              : String(fokSReferencePotentialFactor(node));
            const integratedCitations = Number.isFinite(Number(meta.reference_integrated_citation_count))
              ? String(Number(meta.reference_integrated_citation_count))
              : "";
            const nutrientConnections = Number.isFinite(Number(meta.reference_nutrient_connection_count))
              ? String(Number(meta.reference_nutrient_connection_count))
              : String((edgesByNode.get(node.id) || []).filter((edge) => isFokSNutrientEdge(edge)).length);
            const nutrientScore = String(fokSReferenceNutrientFactor(node));
            const supportScore = Number.isFinite(Number(meta.reference_support_score))
              ? String(Number(meta.reference_support_score))
              : String(fokSReferencePotentialFactor(node) * fokSReferenceNutrientFactor(node));
            sourceRows.push(infoValueHtml("Reference potential score", potentialRaw, "Not available."));
            sourceRows.push(infoValueHtml("Potential factor", potentialFactor, "Not available."));
            sourceRows.push(infoValueHtml("Integrated citation count", integratedCitations, "Not available."));
            sourceRows.push(infoValueHtml("Nutrient connection count", nutrientConnections, "Not available."));
            sourceRows.push(infoValueHtml("Reference nutrient score", nutrientScore, "Not available."));
            sourceRows.push(infoValueHtml("Combined support score", supportScore, "Not available."));
          }
          sourceRows.push(
            boxedInfoValueHtml(
              "SOURCE DESCRIPTION",
              meta.source_summary || "",
              "Not available.",
              "feps3d-shopify__summary-box"
            )
          );
          if (citation) {
            sourceRows.push(boxedInfoValueHtml("APA Citation", citation, "Not available.", "feps3d-shopify__citation-box"));
          }
          if (locatorUrl) {
            sourceRows.push(navigatorLinkHtml(locatorUrl, "Follow link to source"));
          }
          sourceRows.push(linkedCountsHtml);
          return sourceRows.join("");
        }
        const lines = [
          elementIntroHtml,
          infoValueHtml("Element", elementTypeLabel(node), "Not available."),
          infoValueHtml("Block", block, "Not available."),
          infoValueHtml("Unique ID", sourceUniqueId, "Not available."),
          infoValueHtml("Title", title, "Not available."),
          infoValueHtml("Authors", authors, "Not available."),
          infoValueHtml("Year", year, yearEmptyLabel),
        ];
        if (state.activeModelPreset === "fok-s" && isReferenceSourceNode(node)) {
          const potentialRaw = meta.reference_potential_score != null ? String(meta.reference_potential_score) : "";
          const potentialFactor = Number.isFinite(Number(meta.reference_potential_factor))
            ? String(Number(meta.reference_potential_factor))
            : String(fokSReferencePotentialFactor(node));
          const nutrientConnections = Number.isFinite(Number(meta.reference_nutrient_connection_count))
            ? String(Number(meta.reference_nutrient_connection_count))
            : "";
          const nutrientScore = String(fokSReferenceNutrientFactor(node));
          const supportScore = Number.isFinite(Number(meta.reference_support_score))
            ? String(Number(meta.reference_support_score))
            : String(fokSReferencePotentialFactor(node) * fokSReferenceNutrientFactor(node));
          lines.push(infoValueHtml("Reference potential score", potentialRaw, "Not available."));
          lines.push(infoValueHtml("Potential factor", potentialFactor, "Not available."));
          lines.push(infoValueHtml("Nutrient connection count", nutrientConnections, "Not available."));
          lines.push(infoValueHtml("Reference nutrient score", nutrientScore, "Not available."));
          lines.push(infoValueHtml("Combined support score", supportScore, "Not available."));
        }
        if (citation) {
          lines.push(boxedInfoValueHtml("APA Citation", citation, "Not available.", "feps3d-shopify__citation-box"));
        }
        if (locatorUrl) {
          lines.push(navigatorLinkHtml(locatorUrl, "Follow link to source"));
        }
        lines.push(linkedCountsHtml);
        return lines.join("");
      }

      function visibleNodesProjected(transform, isolateScope = null) {
        const projected = [];
        for (const node of nodes) {
          if (!visibleNode(node)) continue;
          if (isolateScope && !isolateScope.nodeIds.has(node.id)) continue;
          const rotated = rotatePoint(node);
          const point = projectRotated(rotated, transform);
          projected.push({ node, rotated, point });
        }
        projected.sort((a, b) => {
          const leftReset = isDeselectNode(a.node);
          const rightReset = isDeselectNode(b.node);
          if (leftReset !== rightReset) return leftReset ? 1 : -1;
          return a.rotated.y - b.rotated.y;
        });
        return projected;
      }

      function visibleEdgesSorted(isolateScope = null) {
        return edges
          .filter(visibleEdge)
          .filter((edge) => !isolateScope || isolateScope.edges.has(edge))
          .sort((left, right) => {
            const leftA = rotatePoint(nodeById.get(left.source));
            const leftB = rotatePoint(nodeById.get(left.target));
            const rightA = rotatePoint(nodeById.get(right.source));
            const rightB = rotatePoint(nodeById.get(right.target));
            return (leftA.y + leftB.y) / 2 - (rightA.y + rightB.y) / 2;
          });
      }

      function activeTapHitRadius() {
        const configuredRadius = compactMobileQuery.matches
          ? interactionNumber("mobile_tap_hit_radius", 24)
          : interactionNumber("desktop_tap_hit_radius", 18);
        return Math.max(4, configuredRadius);
      }

      function activeTapMoveThreshold() {
        const configuredThreshold = compactMobileQuery.matches
          ? interactionNumber("mobile_tap_move_threshold", 12)
          : interactionNumber("desktop_tap_move_threshold", 6);
        return Math.max(2, configuredThreshold);
      }

      function buildHitGrid(projectedNodes) {
        const cellSize = Math.max(32, activeTapHitRadius());
        const cells = new Map();
        for (const item of projectedNodes) {
          if (!interactionAllowedNode(item.node)) continue;
          const cellX = Math.floor(item.point.x / cellSize);
          const cellY = Math.floor(item.point.y / cellSize);
          const key = `${cellX},${cellY}`;
          if (!cells.has(key)) cells.set(key, []);
          cells.get(key).push(item);
        }
        return { cellSize, cells };
      }

      function nearestNode(mouseX, mouseY, projectedNodes) {
        let best = null;
        const radius = activeTapHitRadius();
        let bestDistance = radius;
        let candidates = projectedNodes;
        if (projectedNodes === lastProjectedNodes && lastHitGrid) {
          candidates = [];
          const minCellX = Math.floor((mouseX - radius) / lastHitGrid.cellSize);
          const maxCellX = Math.floor((mouseX + radius) / lastHitGrid.cellSize);
          const minCellY = Math.floor((mouseY - radius) / lastHitGrid.cellSize);
          const maxCellY = Math.floor((mouseY + radius) / lastHitGrid.cellSize);
          for (let cellX = minCellX; cellX <= maxCellX; cellX += 1) {
            for (let cellY = minCellY; cellY <= maxCellY; cellY += 1) {
              const cell = lastHitGrid.cells.get(`${cellX},${cellY}`);
              if (cell) candidates.push(...cell);
            }
          }
        }
        for (const item of candidates) {
          if (!interactionAllowedNode(item.node)) continue;
          const dx = item.point.x - mouseX;
          const dy = item.point.y - mouseY;
          const distance = Math.hypot(dx, dy);
          const resetPriority = best
            && Math.abs(distance - bestDistance) <= 0.5
            && isDeselectNode(item.node)
            && !isDeselectNode(best);
          if (distance < bestDistance || resetPriority) {
            best = item.node;
            bestDistance = distance;
          }
        }
        return best;
      }

      function selectedInspectNode() {
        const selectedNode = state.selectedId ? nodeById.get(state.selectedId) : null;
        if (selectedNode && visibleNode(selectedNode)) return selectedNode;
        return null;
      }

      function edgeViaNodeIds(edge) {
        return Array.isArray(edge.meta && edge.meta.via_node_ids) ? edge.meta.via_node_ids : [];
      }

      function edgeConnectedToNode(edge, node) {
        if (!node) return false;
        return edge.source === node.id || edge.target === node.id || edgeViaNodeIds(edge).includes(node.id);
      }

      function interactionScopeForNode(node, mode = "selection") {
        if (!node) return null;
        const visibilitySignature = [
          state.activeModelPreset,
          state.showNodes,
          state.showCitations,
          state.showSemantic,
          state.showReferenceThemeHealth,
          state.showReferenceBlue,
          state.showReferenceFringe,
          state.showPhenomena,
          state.showPhenomenonGroupL1,
          state.showPhenomenonGroupL2,
          state.showPhenomenonGroupL3,
          state.researchTypeFilter,
          [...state.hiddenConnectionKinds].sort().join(","),
          interactionScopeTraversal,
        ].join("|");
        const scopeCacheKey = `${mode}|${node.id}|${visibilitySignature}`;
        const cachedScope = interactionScopeCache.get(scopeCacheKey);
        if (cachedScope) return cachedScope;

        const scopeEdges = new Set();
        const scopeNodeIds = new Set([node.id]);
        const labelNodeIds = new Set();
        const normalLabelNodeIds = new Set();
        const highlightNodeIds = new Set([node.id]);
        const contextualEdges = new Set();
        const nodeSizeScaleById = new Map();
        const nodeAlphaById = new Map();
        const activeSizeRole = nodeSizeRole(node);
        const activeMatrixRole = selectionMatrixRole(activeSizeRole);
        const selectionLikeHover = mode === "hover" && (
          activeSizeRole === "source" ||
          activeSizeRole === "l1" ||
          activeSizeRole === "l2" ||
          activeSizeRole === "l3" ||
          activeSizeRole === "l4" ||
          activeSizeRole === "l5"
        );
        const activeExposureProfile = activeMatrixRole
          && interactionExposureProfiles
          && interactionExposureProfiles[activeMatrixRole]
          ? interactionExposureProfiles[activeMatrixRole][mode] || null
          : null;
        const activeNodeSizeMatrix = mode === "hover" ? hoverSizeMatrix : selectionSizeMatrix;
        const activeNodeSizeRow = activeMatrixRole ? activeNodeSizeMatrix[activeMatrixRole] : null;
        const titleRoles = new Set(
          activeExposureProfile && Array.isArray(activeExposureProfile.title_roles)
            ? activeExposureProfile.title_roles
            : []
        );
        const suppressActiveLabel = !activeMatrixRole || !titleRoles.has(activeMatrixRole);

        const roleForNode = (targetNode) => selectionMatrixRole(nodeSizeRole(targetNode));
        const applyConfiguredNodeSize = (nodeId) => {
          const targetNode = nodeById.get(nodeId);
          const targetRole = roleForNode(targetNode);
          if (!targetNode || !targetRole || !activeNodeSizeRow) return;
          const configuredSize = Number(activeNodeSizeRow[targetRole]);
          if (!Number.isFinite(configuredSize)) return;
          nodeSizeScaleById.set(nodeId, configuredSize / nodeBaseStyleSize(targetNode));
        };

        applyConfiguredNodeSize(node.id);
        if (!suppressActiveLabel) labelNodeIds.add(node.id);
        if (interactionBoolean("deselect_always_available", true)) {
          for (const candidate of nodes) {
            if (!isDeselectNode(candidate)) continue;
            scopeNodeIds.add(candidate.id);
            nodeSizeScaleById.set(candidate.id, 1);
          }
        }

        if (activeExposureProfile) {
          const allowedEdgeKinds = new Set(
            Array.isArray(activeExposureProfile.edge_kinds)
              ? activeExposureProfile.edge_kinds
              : []
          );
          const allowedRoles = new Set(
            Array.isArray(activeExposureProfile.exposed_roles)
              ? activeExposureProfile.exposed_roles
              : []
          );
          const configuredBranchPaths = Array.isArray(activeExposureProfile.branch_paths)
            ? activeExposureProfile.branch_paths.filter(
                (branchPath) => Array.isArray(branchPath) && branchPath.length >= 2
              )
            : [];
          const allowedSourcePhenomenonRoutes = new Set(
            Array.isArray(activeExposureProfile.source_phenomenon_routes)
              ? activeExposureProfile.source_phenomenon_routes.map(
                  (routeName) => String(routeName || "").toLowerCase(),
                )
              : []
          );
          const includeVia = activeExposureProfile.include_via !== false;
          const edgeAllowedByProfile = (edge) => {
            if (!visibleEdge(edge)) return false;
            if (!allowedEdgeKinds.size || !edgeKindAllowed(allowedEdgeKinds, edge)) return false;
            if (edge.kind === "source_phenomenon" && allowedSourcePhenomenonRoutes.size) {
              const routeName = String(edge.meta && edge.meta.route_name || "").toLowerCase();
              if (!allowedSourcePhenomenonRoutes.has(routeName)) return false;
            }
            return [edge.source, edge.target].every((endpointId) => {
              const endpointNode = nodeById.get(endpointId);
              const endpointRole = roleForNode(endpointNode);
              return !!endpointNode && !!endpointRole && allowedRoles.has(endpointRole);
            });
          };
          let branchEdges = null;
          let branchNodeIds = null;
          if (configuredBranchPaths.length) {
            branchEdges = new Set();
            branchNodeIds = new Set([node.id]);
            for (const branchPath of configuredBranchPaths) {
              if (branchPath[0] !== activeMatrixRole) continue;
              let currentNodeIds = new Set([node.id]);
              for (let pathIndex = 1; pathIndex < branchPath.length; pathIndex += 1) {
                const nextRole = branchPath[pathIndex];
                const nextNodeIds = new Set();
                for (const currentNodeId of currentNodeIds) {
                  for (const edge of interactionEdgesByNode.get(currentNodeId) || []) {
                    if (!edgeAllowedByProfile(edge)) continue;
                    let candidateNodeId = null;
                    if (edge.source === currentNodeId) candidateNodeId = edge.target;
                    else if (edge.target === currentNodeId) candidateNodeId = edge.source;
                    if (!candidateNodeId) continue;
                    const candidateNode = nodeById.get(candidateNodeId);
                    if (roleForNode(candidateNode) !== nextRole) continue;
                    branchEdges.add(edge);
                    branchNodeIds.add(candidateNodeId);
                    nextNodeIds.add(candidateNodeId);
                  }
                }
                currentNodeIds = nextNodeIds;
                if (!currentNodeIds.size) break;
              }
            }
          }
          const edgeAllowedInScope = (edge) => (
            edgeAllowedByProfile(edge)
            && (!branchEdges || branchEdges.has(edge))
          );
          const scopeSourceKeys = new Set(sourceLinkKeys(node));
          for (const edge of interactionEdgesByNode.get(node.id) || []) {
            if (!edgeAllowedInScope(edge)) continue;
            const directNodeIds = [
              edge.source,
              edge.target,
              ...(includeVia ? edgeViaNodeIds(edge) : []),
            ];
            for (const directNodeId of directNodeIds) {
              const directNode = nodeById.get(directNodeId);
              if (!directNode) continue;
              for (const sourceKey of sourceLinkKeys(directNode)) {
                scopeSourceKeys.add(sourceKey);
              }
            }
          }
          const nodeMatchesScopeSource = (candidateNode) => {
            if (branchNodeIds && branchNodeIds.has(candidateNode.id)) return true;
            const candidateSourceKeys = sourceLinkKeys(candidateNode);
            if (!candidateSourceKeys.size) return true;
            for (const sourceKey of candidateSourceKeys) {
              if (scopeSourceKeys.has(sourceKey)) return true;
            }
            return false;
          };
          const pendingNodeIds = [node.id];
          const traversedNodeIds = new Set([node.id]);
          const examinedEdges = new Set();
          let pendingNodeIndex = 0;
          while (pendingNodeIndex < pendingNodeIds.length) {
            const currentNodeId = pendingNodeIds[pendingNodeIndex];
            pendingNodeIndex += 1;
            if (
              interactionScopeTraversal !== "anchored_connected_paths"
              && currentNodeId !== node.id
            ) continue;
            for (const edge of interactionEdgesByNode.get(currentNodeId) || []) {
              if (examinedEdges.has(edge)) continue;
              examinedEdges.add(edge);
              if (!edgeAllowedInScope(edge)) continue;

              const endpointNodes = [edge.source, edge.target].map(
                (endpointId) => nodeById.get(endpointId),
              );
              const citationPath = isCitationEdge(edge);
              if (citationPath) {
                if (!endpointNodes.some((endpointNode) => {
                  const endpointSourceKeys = sourceLinkKeys(endpointNode);
                  return endpointSourceKeys.size && nodeMatchesScopeSource(endpointNode);
                })) continue;
              } else if (endpointNodes.some(
                (endpointNode) => !nodeMatchesScopeSource(endpointNode),
              )) {
                continue;
              }

              scopeEdges.add(edge);
              const retainedNodeIds = [
                edge.source,
                edge.target,
                ...(includeVia ? edgeViaNodeIds(edge) : []),
              ];
              for (const retainedNodeId of retainedNodeIds) {
                const retainedNode = nodeById.get(retainedNodeId);
                const retainedRole = roleForNode(retainedNode);
                if (!retainedNode || !retainedRole || !allowedRoles.has(retainedRole)) continue;
                const sourceMatched = nodeMatchesScopeSource(retainedNode);
                if (!citationPath && !sourceMatched) continue;
                scopeNodeIds.add(retainedNodeId);
                highlightNodeIds.add(retainedNodeId);
                applyConfiguredNodeSize(retainedNodeId);
                if (titleRoles.has(retainedRole)) labelNodeIds.add(retainedNodeId);
                const citationLeaf = citationPath && !sourceMatched;
                if (!citationLeaf && !traversedNodeIds.has(retainedNodeId)) {
                  traversedNodeIds.add(retainedNodeId);
                  pendingNodeIds.push(retainedNodeId);
                }
              }
            }
          }
        }

        const resolvedScope = {
          edges: scopeEdges,
          nodeIds: scopeNodeIds,
          labelNodeIds,
          normalLabelNodeIds,
          highlightNodeIds,
          contextualEdges,
          nodeSizeScaleById,
          nodeAlphaById,
          activeNodeId: node.id,
          suppressActiveLabel,
          selectionLikeHover,
          interactionMode: mode,
        };
        if (interactionScopeCache.size >= 128) interactionScopeCache.clear();
        interactionScopeCache.set(scopeCacheKey, resolvedScope);
        return resolvedScope;
      }

      function activeInspectNode() {
        const selectedNode = selectedInspectNode();
        if (selectedNode && isPublicMobileFokInteraction()) return selectedNode;
        const hoveredNode = state.hoverId ? nodeById.get(state.hoverId) : null;
        if (selectedNode && hoveredNode && visibleNode(hoveredNode) && inspectableNode(hoveredNode) && hoverOverridesSelection(selectedNode, hoveredNode)) return hoveredNode;
        if (selectedNode) return selectedNode;
        if (hoveredNode && visibleNode(hoveredNode) && inspectableNode(hoveredNode)) return hoveredNode;
        return null;
      }

      function hoverOverridesSelection(selectedNode, hoveredNode) {
        if (!selectedNode || !hoveredNode || selectedNode.id === hoveredNode.id) return false;
        if (isDeselectNode(hoveredNode)) return true;
        if (state.activeModelPreset === "fok-s") return normalSelectableNode(hoveredNode);
        if (selectedNode.kind === "phenomenon_group" && phenomenonGroupLevel(selectedNode) === 3 && isContextClusterNode(hoveredNode)) {
          return selectionAllowedNodeIds(selectedNode).has(hoveredNode.id);
        }
        if (selectedNode.kind !== "phenomenon" || hoveredNode.kind !== "phenomenon_group") return false;
        const hoveredLevel = phenomenonGroupLevel(hoveredNode);
        if (hoveredLevel !== 1 && hoveredLevel !== 2 && hoveredLevel !== 3) return false;
        return selectionAllowedNodeIds(selectedNode).has(hoveredNode.id);
      }

      function requestRender(immediate = false) {
        if (!scene) return;
        if (immediate) {
          if (animationFrame != null) {
            cancelAnimationFrame(animationFrame);
            animationFrame = null;
          }
          render();
          return;
        }
        if (animationFrame != null) return;
        animationFrame = requestAnimationFrame(() => {
          animationFrame = null;
          render();
        });
      }

      function render() {
        const transform = screenTransform();
        ctx.clearRect(0, 0, transform.width, transform.height);

        const gradient = ctx.createLinearGradient(0, 0, 0, transform.height);
        gradient.addColorStop(0, "rgba(15, 16, 32, 0.16)");
        gradient.addColorStop(1, "rgba(15, 16, 32, 0.32)");
        ctx.fillStyle = gradient;
        ctx.fillRect(0, 0, transform.width, transform.height);

        drawGuides(transform);

        const selectedNode = selectedInspectNode();
        const publicMobileSelection = selectedNode && isPublicMobileFokInteraction();
        const hoveredNode = publicMobileSelection ? selectedNode : activeInspectNode();
        const selectionScope = selectedNode ? interactionScopeForNode(selectedNode, "selection") : null;
        const hoverOverrideScope = !publicMobileSelection && selectedNode && hoveredNode && hoverOverridesSelection(selectedNode, hoveredNode)
          ? interactionScopeForNode(hoveredNode, "hover")
          : null;
        const hoverScope = hoverOverrideScope || selectionScope || (hoveredNode ? interactionScopeForNode(hoveredNode, "hover") : null);
        const uiMode = selectedNode
          ? (hoverOverrideScope ? "hover" : "selection")
          : (hoveredNode ? "hover" : "normal");
        const uiProfile = applyUiDisplayState(uiMode, hoveredNode);
        const projectedNodes = visibleNodesProjected(transform);
        lastTransform = transform;
        lastProjectedNodes = projectedNodes;
        lastHitGrid = buildHitGrid(projectedNodes);
        const projectedById = new Map(projectedNodes.map((item) => [item.node.id, item.point]));

        for (const edge of visibleEdgesSorted()) {
          drawEdge(edge, projectedById, hoveredNode, transform, hoverScope);
        }

        for (const item of projectedNodes) {
          drawNode(item.node, item.point, hoveredNode, hoverScope);
        }

        updateInformationCard(
          informationHtmlForUi(hoveredNode || null, uiMode, uiProfile)
        );
      }

      function setView(azimuth, elevation, zoom = 1, projectionMode = "orthographic") {
        state.azimuth = azimuth;
        state.elevation = elevation;
        state.zoom = zoom;
        state.projectionMode = projectionMode;
        requestRender();
      }

      function applyViewPreset(preset) {
        let view = currentProfileView();
        if (preset === "top") {
          view = currentSuperiorView();
        } else if (preset === "perspective") {
          view = currentAstronomicalView();
        } else if (preset === "front") {
          view = currentProfileView();
        } else if (preset === "isometric") {
          view = currentIsometricView();
        }
        state.activeViewPreset = preset;
        syncViewOptions();
        setView(view.azimuth, view.elevation, view.zoom, view.projectionMode);
      }

      function applyCombinedViewPreset(preset) {
        if (preset === "fok-s-expanded") {
          state.activeModelPreset = "fok-s";
          researchTypeVisibilityCache = null;
          buildNavigatorControls();
          applyViewPreset("top");
          return;
        }
        state.activeModelPreset = "fok";
        researchTypeVisibilityCache = null;
        if (state.selectedId && !researchTypeVisibleNode(nodeById.get(state.selectedId))) state.selectedId = null;
        if (state.hoverId && !researchTypeVisibleNode(nodeById.get(state.hoverId))) state.hoverId = null;
        buildNavigatorControls();
        if (preset === "fok-side") {
          applyViewPreset("front");
        } else if (preset === "fok-projection") {
          applyViewPreset("perspective");
        } else {
          applyViewPreset("top");
        }
      }

      function beginDrag(clientX, clientY) {
        state.dragging = true;
        interactionMoved = false;
        dragStart = {
          x: clientX,
          y: clientY,
          azimuth: state.azimuth,
          elevation: state.elevation,
        };
        canvas.classList.add("feps3d-shopify--dragging");
      }

      function endDrag() {
        state.dragging = false;
        dragStart = null;
        pinchStartDistance = null;
        pinchStartZoom = null;
        canvas.classList.remove("feps3d-shopify--dragging");
      }

      function pinchDistance(touchA, touchB) {
        return Math.hypot(touchA.clientX - touchB.clientX, touchA.clientY - touchB.clientY);
      }

      function clearActiveSelection() {
        state.selectedId = null;
        state.hoverId = null;
        syncNavigatorButtons();
        requestRender();
      }

      function selectNodeAtClientPoint(clientX, clientY, keepHoverOnDeselect = true) {
        const rect = canvas.getBoundingClientRect();
        if (clientX < rect.left || clientX > rect.right || clientY < rect.top || clientY > rect.bottom) {
          return false;
        }
        if (!lastTransform || lastProjectedNodes.length === 0) {
          return false;
        }
        const localX = clientX - rect.left;
        const localY = clientY - rect.top;
        const node = nearestNode(localX, localY, lastProjectedNodes);
        if (!node || !interactionAllowedNode(node)) {
          if (
            state.activeModelPreset === "fok"
            && interactionBoolean("deselect_empty_canvas", false)
          ) {
            clearActiveSelection();
            return true;
          }
          return false;
        }
        if (isDeselectNode(node)) {
          clearActiveSelection();
          return true;
        }
        const publicMobileSelection = isPublicMobileFokInteraction();
        if (state.selectedId === node.id) {
          if (repeatedSelectionClears(node)) {
            state.selectedId = null;
            state.hoverId = publicMobileSelection ? null : (keepHoverOnDeselect ? node.id : null);
            syncNavigatorButtons();
          } else {
            state.hoverId = publicMobileSelection ? null : node.id;
          }
          requestRender();
          return true;
        }
        state.selectedId = node.id;
        state.hoverId = publicMobileSelection ? null : node.id;
        syncNavigatorButtons();
        ensurePublicDetailsLoaded(node.id);
        requestRender();
        return true;
      }

      function bindEvents() {
        for (const option of controls.viewOptions) {
          option.addEventListener("change", () => {
            if (option.checked) applyCombinedViewPreset(option.value);
          });
        }

        controls.nodes.addEventListener("change", () => {
          state.showNodes = controls.nodes.checked;
          requestRender();
        });
        controls.nodes.addEventListener("change", () => {
          state.showNodes = controls.nodes.checked;
          requestRender();
        });
        controls.citations.addEventListener("change", () => {
          state.showCitations = controls.citations.checked;
          requestRender();
        });
        controls.semantic.addEventListener("change", () => {
          state.showSemantic = controls.semantic.checked;
          requestRender();
        });
        controls.referenceThemeHealth.addEventListener("change", () => {
          state.showReferenceThemeHealth = controls.referenceThemeHealth.checked;
          requestRender();
        });
        controls.referenceBlue.addEventListener("change", () => {
          state.showReferenceBlue = controls.referenceBlue.checked;
          requestRender();
        });
        controls.referenceFringe.addEventListener("change", () => {
          state.showReferenceFringe = controls.referenceFringe.checked;
          requestRender();
        });
        controls.phenomena.addEventListener("change", () => {
          state.showPhenomena = controls.phenomena.checked;
          requestRender();
        });
        controls.phenomenonGroupL1.addEventListener("change", () => {
          state.showPhenomenonGroupL1 = controls.phenomenonGroupL1.checked;
          requestRender();
        });
        controls.phenomenonGroupL2.addEventListener("change", () => {
          state.showPhenomenonGroupL2 = controls.phenomenonGroupL2.checked;
          requestRender();
        });
        controls.phenomenonGroupL3.addEventListener("change", () => {
          state.showPhenomenonGroupL3 = controls.phenomenonGroupL3.checked;
          requestRender();
        });
        canvas.addEventListener("mousedown", (event) => {
          beginDrag(event.clientX, event.clientY);
        });

        window.addEventListener("mouseup", (event) => {
          const shouldSelect = state.dragging && dragStart && !interactionMoved;
          const clientX = event.clientX;
          const clientY = event.clientY;
          endDrag();
          if (shouldSelect) {
            suppressNextClickSelection = selectNodeAtClientPoint(clientX, clientY, true);
          }
        });

        window.addEventListener("mousemove", (event) => {
          const rect = canvas.getBoundingClientRect();
          if (state.dragging && dragStart) {
            if (Math.hypot(event.clientX - dragStart.x, event.clientY - dragStart.y) > 4) {
              interactionMoved = true;
            }
            state.azimuth = dragStart.azimuth + (event.clientX - dragStart.x) * 0.01;
            state.elevation = Math.max(-1.35, Math.min(1.55, dragStart.elevation + (event.clientY - dragStart.y) * 0.01));
            requestRender();
            return;
          }
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) {
            if (state.hoverId !== null) {
              state.hoverId = null;
              requestRender();
            }
            return;
          }
          if (!lastTransform || lastProjectedNodes.length === 0) {
            return;
          }
          const hoverNode = nearestNode(event.clientX - rect.left, event.clientY - rect.top, lastProjectedNodes);
          const nextHoverId = hoverNode && hoverAllowedNode(hoverNode) ? hoverNode.id : null;
          if (nextHoverId !== state.hoverId) {
            state.hoverId = nextHoverId;
            requestRender();
          }
        });

        canvas.addEventListener("wheel", (event) => {
          event.preventDefault();
          const factor = event.deltaY > 0 ? 0.92 : 1.08;
          state.zoom = Math.max(0.45, Math.min(3.2, state.zoom * factor));
          requestRender();
        }, { passive: false });

        canvas.addEventListener("touchstart", (event) => {
          event.preventDefault();
          if (event.touches.length === 1) {
            const touch = event.touches[0];
            touchGestureWasMulti = false;
            suppressNextClickSelection = false;
            beginDrag(touch.clientX, touch.clientY);
          } else if (event.touches.length === 2) {
            touchGestureWasMulti = true;
            endDrag();
            pinchStartDistance = pinchDistance(event.touches[0], event.touches[1]);
            pinchStartZoom = state.zoom;
          }
        }, { passive: false });

        canvas.addEventListener("touchmove", (event) => {
          event.preventDefault();
          if (event.touches.length === 1 && state.dragging && dragStart) {
            const touch = event.touches[0];
            if (Math.hypot(touch.clientX - dragStart.x, touch.clientY - dragStart.y) > activeTapMoveThreshold()) {
              interactionMoved = true;
            }
            state.azimuth = dragStart.azimuth + (touch.clientX - dragStart.x) * 0.01;
            state.elevation = Math.max(-1.35, Math.min(1.55, dragStart.elevation + (touch.clientY - dragStart.y) * 0.01));
            requestRender();
            return;
          }
          if (event.touches.length === 2 && pinchStartDistance && pinchStartZoom) {
            touchGestureWasMulti = true;
            const nextDistance = pinchDistance(event.touches[0], event.touches[1]);
            const factor = nextDistance / pinchStartDistance;
            state.zoom = Math.max(0.45, Math.min(3.2, pinchStartZoom * factor));
            requestRender();
          }
        }, { passive: false });

        canvas.addEventListener("touchend", (event) => {
          if (event.touches.length === 0) {
            const touch = event.changedTouches && event.changedTouches.length ? event.changedTouches[0] : null;
            const shouldSelect = state.dragging
              && dragStart
              && !interactionMoved
              && !touchGestureWasMulti
              && touch;
            endDrag();
            touchGestureWasMulti = false;
            if (shouldSelect && touch) {
              suppressNextClickSelection = selectNodeAtClientPoint(
                touch.clientX,
                touch.clientY,
                false,
              );
            }
            return;
          }
          if (event.touches.length === 1) {
            const touch = event.touches[0];
            pinchStartDistance = null;
            pinchStartZoom = null;
            beginDrag(touch.clientX, touch.clientY);
          }
        });

        canvas.addEventListener("touchcancel", () => {
          touchGestureWasMulti = false;
          suppressNextClickSelection = false;
          endDrag();
        });

        canvas.addEventListener("click", (event) => {
          if (suppressNextClickSelection) {
            suppressNextClickSelection = false;
            return;
          }
          if (interactionMoved) return;
          selectNodeAtClientPoint(event.clientX, event.clientY, false);
        });

        canvas.addEventListener("dblclick", () => {
          applyViewPreset(state.activeViewPreset);
        });
        window.addEventListener("pageshow", () => requestRender(true));
        window.addEventListener("orientationchange", () => requestRender(true));
        document.addEventListener("visibilitychange", () => {
          if (!document.hidden) requestRender(true);
        });
        window.addEventListener("resize", () => {
          syncUiResponsiveLayout();
          requestRender();
        });
      }

      function hydrateScene(data) {
        scene = inflateScenePayload(data);
        nodes = scene.nodes.slice();
        edges = scene.edges.slice();
        nodeById = new Map(nodes.map((node) => [node.id, node]));
        edgeById = new Map(edges.map((edge) => [edge.id, edge]));
        edgesByNode = new Map();
        interactionEdgesByNode = new Map();
        interactionScopeCache = new Map();
        for (const edge of edges) {
          if (!edgesByNode.has(edge.source)) edgesByNode.set(edge.source, []);
          if (!edgesByNode.has(edge.target)) edgesByNode.set(edge.target, []);
          edgesByNode.get(edge.source).push(edge);
          edgesByNode.get(edge.target).push(edge);
          const interactionNodeIds = new Set([
            edge.source,
            edge.target,
            ...edgeViaNodeIds(edge),
          ]);
          for (const nodeId of interactionNodeIds) {
            if (!interactionEdgesByNode.has(nodeId)) interactionEdgesByNode.set(nodeId, []);
            interactionEdgesByNode.get(nodeId).push(edge);
          }
        }
        const visualStyle = scene.meta && scene.meta.visual_style ? scene.meta.visual_style : {};
        interactionStyle = visualStyle.interaction_styles || {};
        const nodeDesignWrapper = visualStyle.node_design_specification || {};
        nodeDesignSpecification = nodeDesignWrapper.values || nodeDesignWrapper || {};
        const uiDisplayWrapper = visualStyle.ui_display_specification || {};
        uiDisplaySpecification = uiDisplayWrapper.values || uiDisplayWrapper || {};
        normalSizeMatrix = interactionStyle.normal_size_matrix || defaultNormalSizeMatrix;
        hoverSizeMatrix = interactionStyle.hover_size_matrix || interactionStyle.selection_size_matrix || defaultSelectionSizeMatrix;
        selectionSizeMatrix = interactionStyle.selection_size_matrix || defaultSelectionSizeMatrix;
        interactionPermissions = interactionStyle.interaction_permissions || {};
        interactionExposureProfiles = interactionStyle.interaction_exposure_profiles || {};
        interactionScopeTraversal = interactionStyle.interaction_scope_traversal
          || "anchored_connected_paths";
        edgeStateWidths = interactionStyle.edge_state_widths || defaultEdgeStateWidths;
        edgeWidthMatrix = interactionStyle.edge_width_matrix || {};
        interactionEdgeKindWidths = interactionStyle.interaction_edge_kind_widths || {};
        timeRules = scene.space && scene.space.time_rules ? scene.space.time_rules : {};
        stemBottom = scene.space && scene.space.stem_bottom ? scene.space.stem_bottom : null;
        orbitRange = scene.space && Array.isArray(scene.space.logical_orbit_range) ? scene.space.logical_orbit_range : [1, 30000];
        zRange = scene.space && Array.isArray(scene.space.z_range) ? scene.space.z_range : [0, 2410];
        unknownYearZ = Number.isFinite(timeRules.unknown_year_z) ? timeRules.unknown_year_z : 0;
        flatYearCutoff = Number.isFinite(timeRules.flat_year_cutoff) ? timeRules.flat_year_cutoff : 1990;
        flatYearZ = Number.isFinite(timeRules.flat_year_z) ? timeRules.flat_year_z : 10;
        layerBaseZ = Number.isFinite(timeRules.layer_base_z) ? timeRules.layer_base_z : 2410;
        zUnitsPerYear = Number.isFinite(timeRules.z_units_per_year) ? timeRules.z_units_per_year : 20;
        postHanZUnitsPerYear = Number.isFinite(timeRules.post_han_z_units_per_year) ? timeRules.post_han_z_units_per_year : 40;
        fokSYearSpacingMultiplier = Number.isFinite(timeRules.fok_s_year_spacing_multiplier) ? timeRules.fok_s_year_spacing_multiplier : 3;
        fokSExtraTickYears = Array.isArray(timeRules.fok_s_extra_tick_years)
          ? timeRules.fok_s_extra_tick_years.map((year) => Number(year)).filter((year) => Number.isFinite(year))
          : [1995, 2005, 2015, 2025];
        hereAndNowYear = Number.isFinite(timeRules.han_year)
          ? timeRules.han_year
          : (Number.isFinite(timeRules.here_and_now_year) ? timeRules.here_and_now_year : new Date().getFullYear());
        hereAndNowZ = Number.isFinite(timeRules.han_z)
          ? timeRules.han_z
          : (Number.isFinite(timeRules.here_and_now_z)
            ? timeRules.here_and_now_z
            : (hereAndNowYear <= flatYearCutoff ? flatYearZ : flatYearZ + zUnitsPerYear * (hereAndNowYear - flatYearCutoff)));
        researchTypeVisibilityCache = null;
        renderResearchTypeFilterControls();
        applyInitialView();
        syncViewOptions();
        renderConnectionFilterControls();
        applyUiDisplayCommon();
        state.selectedId = null;
        state.hoverId = null;
        buildNavigatorControls();
        const normalUiProfile = applyUiDisplayState("normal", null);
        updateInformationCard(informationHtmlForUi(null, "normal", normalUiProfile));
        requestRender(true);
        setTimeout(() => requestRender(true), 120);
        setTimeout(() => requestRender(true), 640);
      }

      root.addEventListener("click", (event) => {
        const button = event.target.closest("[data-info-select-node]");
        if (!button || !root.contains(button)) return;
        event.preventDefault();
        selectNavigatorNode(button.getAttribute("data-info-select-node"));
      });

      bindEvents();

      const inlineSceneId = String(root.dataset.feps3dInlineSceneId || "").trim();
      const scenePromise = inlineSceneId
        ? Promise.resolve(inlineJsonById(inlineSceneId))
        : fetch(root.dataset.feps3dSceneUrl, { credentials: "same-origin" })
        .then((response) => {
          if (!response.ok) {
            throw new Error(`Scene asset request failed with status ${response.status}`);
          }
          return response.json();
        });
      scenePromise
        .then((data) => {
          hydrateScene(data);
        })
        .catch((error) => {
          console.error("FOK-3D Shopify embed load failed:", error);
          infoCard.innerHTML = `<div class="feps3d-shopify__muted">${escapeHtml(String(error.message || error))}</div>`;
        });
  }
})();
